export type EmojiLocale = 'es' | 'en'

export interface EmojiItem {
  id: number
  emoji: string
  keywords: Record<EmojiLocale, string[]>
}

export const emojis = {
  emoticons: [
    {
      id: 1,
      emoji: '😀',
      keywords: {
        en: ['smile', 'happy', 'face', 'joy'],
        es: ['sonrisa', 'feliz', 'cara', 'alegría'],
      },
    },
    {
      id: 2,
      emoji: '😃',
      keywords: {
        en: ['smile', 'happy', 'cheerful', 'excited'],
        es: ['sonrisa', 'feliz', 'alegre', 'emocionado'],
      },
    },
    {
      id: 3,
      emoji: '😄',
      keywords: {
        en: ['smile', 'happy', 'laugh', 'joyful'],
        es: ['sonrisa', 'feliz', 'risa', 'alegre'],
      },
    },
    {
      id: 4,
      emoji: '😁',
      keywords: {
        en: ['smile', 'happy', 'grin', 'pleased'],
        es: ['sonrisa', 'feliz', 'sonrisa', 'contento'],
      },
    },
    {
      id: 5,
      emoji: '😆',
      keywords: {
        en: ['laugh', 'happy', 'grin', 'joyful'],
        es: ['risa', 'feliz', 'sonrisa', 'alegre'],
      },
    },
    {
      id: 6,
      emoji: '😅',
      keywords: {
        en: ['laugh', 'happy', 'sweat', 'relief'],
        es: ['risa', 'feliz', 'sudor', 'alivio'],
      },
    },
    {
      id: 7,
      emoji: '🤣',
      keywords: {
        en: ['laugh', 'happy', 'hilarious', 'joy'],
        es: ['risa', 'feliz', 'divertido', 'alegría'],
      },
    },
    {
      id: 8,
      emoji: '😂',
      keywords: {
        en: ['laugh', 'happy', 'tears', 'hilarious'],
        es: ['risa', 'feliz', 'lágrimas', 'divertido'],
      },
    },
    {
      id: 9,
      emoji: '🙂',
      keywords: {
        en: ['neutral', 'content', 'calm', 'composed'],
        es: ['neutral', 'contento', 'tranquilo', 'compuesto'],
      },
    },
    {
      id: 10,
      emoji: '🙃',
      keywords: {
        en: ['upside down', 'sarcastic', 'ironic', 'ambiguous'],
        es: ['al revés', 'sarcástico', 'irónico', 'ambiguo'],
      },
    },
    {
      id: 11,
      emoji: '🫠',
      keywords: {
        en: ['headphones', 'listening', 'music', 'audio'],
        es: ['auriculares', 'escuchando', 'música', 'audio'],
      },
    },
    {
      id: 12,
      emoji: '😉',
      keywords: {
        en: ['wink', 'playful', 'mischievous', 'flirty'],
        es: ['guiño', 'juguetón', 'pícaro', 'coqueto'],
      },
    },
    {
      id: 13,
      emoji: '😊',
      keywords: {
        en: ['smile', 'happy', 'content', 'pleased'],
        es: ['sonrisa', 'feliz', 'contento', 'satisfecho'],
      },
    },
    {
      id: 14,
      emoji: '😇',
      keywords: {
        en: ['angelic', 'innocent', 'blessed', 'virtuous'],
        es: ['angelical', 'innocente', 'bendecido', 'virtuoso'],
      },
    },
    {
      id: 15,
      emoji: '🥰',
      keywords: {
        en: ['love', 'affection', 'warmth', 'admiration'],
        es: ['amor', 'afecto', 'calor', 'admiración'],
      },
    },
    {
      id: 16,
      emoji: '😍',
      keywords: {
        en: ['heart eyes', 'love', 'admiration', 'infatuation'],
        es: ['ojos de corazón', 'amor', 'admiración', 'fascinación'],
      },
    },
    {
      id: 17,
      emoji: '🤩',
      keywords: {
        en: ['starstruck', 'excitement', 'amazed', 'admirable'],
        es: ['asombrado', 'emoción', 'asombrado', 'admirable'],
      },
    },
    {
      id: 18,
      emoji: '😘',
      keywords: {
        en: ['kiss', 'love', 'affection', 'blow a kiss'],
        es: ['beso', 'amor', 'afecto', 'soplar un beso'],
      },
    },
    {
      id: 19,
      emoji: '😗',
      keywords: {
        en: ['kiss', 'love', 'affection', 'puckered lips'],
        es: ['beso', 'amor', 'afecto', 'labios fruncidos'],
      },
    },
    {
      id: 20,
      emoji: '😚',
      keywords: {
        en: ['kiss', 'love', 'affection', 'tender'],
        es: ['beso', 'amor', 'afecto', 'tierno'],
      },
    },
    {
      id: 21,
      emoji: '😙',
      keywords: {
        en: ['kiss', 'love', 'affection', 'gentle'],
        es: ['beso', 'amor', 'afecto', 'gentil'],
      },
    },
    {
      id: 22,
      emoji: '🥲',
      keywords: {
        en: ['teary-eyed', 'emotional', 'sentimental', 'touching'],
        es: ['ojos llorosos', 'emocional', 'sentimental', 'conmovedor'],
      },
    },
    {
      id: 23,
      emoji: '😋',
      keywords: {
        en: ['tasty', 'delicious', 'yum', 'savoring'],
        es: ['rico', 'delicioso', 'yum', 'disfrutando'],
      },
    },
    {
      id: 24,
      emoji: '😛',
      keywords: {
        en: ['tongue out', 'playful', 'cheeky', 'funny'],
        es: ['lengua afuera', 'juguetón', 'pícaro', 'gracioso'],
      },
    },
    {
      id: 25,
      emoji: '😜',
      keywords: {
        en: ['wink', 'playful', 'mischievous', 'fun'],
        es: ['guiño', 'juguetón', 'pícaro', 'divertido'],
      },
    },
    {
      id: 26,
      emoji: '🤪',
      keywords: {
        en: ['crazy', 'wild', 'silly', 'fun'],
        es: ['loco', 'salvaje', 'tonto', 'divertido'],
      },
    },
    {
      id: 27,
      emoji: '😝',
      keywords: {
        en: ['playful', 'mischievous', 'funny', 'silly'],
        es: ['juguetón', 'pícaro', 'gracioso', 'tonto'],
      },
    },
    {
      id: 28,
      emoji: '🤑',
      keywords: {
        en: ['money', 'wealth', 'greed', 'rich'],
        es: ['dinero', 'riqueza', 'codicia', 'rico'],
      },
    },
    {
      id: 29,
      emoji: '🤗',
      keywords: {
        en: ['hug', 'warm', 'comfort', 'affectionate'],
        es: ['abrazo', 'cálido', 'consuelo', 'cariñoso'],
      },
    },
    {
      id: 30,
      emoji: '🤭',
      keywords: {
        en: ['giggling', 'amused', 'entertained', 'playful'],
        es: ['risita', 'divertido', 'entretenido', 'juguetón'],
      },
    },
    {
      id: 31,
      emoji: '🫢',
      keywords: {
        en: ['yawning', 'tired', 'fatigued', 'sleepy'],
        es: ['bostezo', 'cansado', 'fatigado', 'somnoliento'],
      },
    },
    {
      id: 32,
      emoji: '🫣',
      keywords: {
        en: ['drooling', 'hungry', 'craving', 'desire'],
        es: ['babeando', 'hambriento', 'antojo', 'deseo'],
      },
    },
    {
      id: 33,
      emoji: '🤫',
      keywords: {
        en: ['shush', 'quiet', 'secret', 'hush'],
        es: ['silencio', 'callado', 'secreto', 'chitón'],
      },
    },
    {
      id: 34,
      emoji: '🤔',
      keywords: {
        en: ['thinking', 'pondering', 'considering', 'contemplating'],
        es: ['pensando', 'reflexionando', 'considerando', 'contemplando'],
      },
    },
    {
      id: 35,
      emoji: '🫡',
      keywords: {
        en: ['spy', 'suspicious', 'intrigued', 'curious'],
        es: ['espía', 'sospechoso', 'intrigado', 'curioso'],
      },
    },
    {
      id: 36,
      emoji: '🤐',
      keywords: {
        en: ['zipper mouth', 'silent', 'quiet', 'confidential'],
        es: ['boca cerrada', 'silencioso', 'callado', 'confidencial'],
      },
    },
    {
      id: 37,
      emoji: '🤨',
      keywords: {
        en: ['raised eyebrow', 'skeptical', 'doubtful', 'disbelief'],
        es: ['ceja levantada', 'escéptico', 'dudoso', 'incredulidad'],
      },
    },
    {
      id: 38,
      emoji: '😐',
      keywords: {
        en: ['neutral', 'indifferent', 'bored', 'expressionless'],
        es: ['neutral', 'indiferente', 'aburrido', 'sin expresión'],
      },
    },
    {
      id: 39,
      emoji: '😑',
      keywords: {
        en: ['annoyed', 'bored', 'indifferent', 'unimpressed'],
        es: ['molesto', 'aburrido', 'indiferente', 'poco impresionado'],
      },
    },
    {
      id: 40,
      emoji: '😶',
      keywords: {
        en: ['speechless', 'mute', 'silent', 'expressionless'],
        es: ['sin palabras', 'mudo', 'silencioso', 'sin expresión'],
      },
    },
    {
      id: 41,
      emoji: '🫥',
      keywords: {
        en: ['unamused', 'displeased', 'uninterested', 'apathetic'],
        es: ['sin gracia', 'disgustado', 'desinteresado', 'apático'],
      },
    },
    {
      id: 42,
      emoji: '😶‍🌫️',
      keywords: {
        en: ['silent', 'mute', 'communication', 'deaf'],
        es: ['silencioso', 'mudo', 'comunicación', 'sordo'],
      },
    },
    {
      id: 43,
      emoji: '😏',
      keywords: {
        en: ['smirk', 'smug', 'sly', 'confident'],
        es: ['sonrisa pícara', 'presumido', 'astuto', 'confiado'],
      },
    },
    {
      id: 44,
      emoji: '😒',
      keywords: {
        en: ['displeased', 'unimpressed', 'annoyed', 'indifferent'],
        es: ['disgustado', 'poco impresionado', 'molesto', 'indiferente'],
      },
    },
    {
      id: 45,
      emoji: '🙄',
      keywords: {
        en: ['eyeroll', 'disbelief', 'annoyed', 'frustrated'],
        es: ['ojos en blanco', 'incredulidad', 'molesto', 'frustrado'],
      },
    },
    {
      id: 46,
      emoji: '😬',
      keywords: {
        en: ['grimace', 'awkward', 'nervous', 'cringe'],
        es: ['mueca', 'incómodo', 'nervioso', 'vergüenza ajena'],
      },
    },
    {
      id: 47,
      emoji: '😮‍💨',
      keywords: {
        en: ['shocked', 'astonished', 'gasping', 'surprised'],
        es: ['impactado', 'asombrado', 'jadeando', 'sorprendido'],
      },
    },
    {
      id: 48,
      emoji: '🤥',
      keywords: {
        en: ['lying', 'untruthful', 'deceptive', 'dishonest'],
        es: ['mintiendo', 'falso', 'engañoso', 'deshonesto'],
      },
    },
    {
      id: 49,
      emoji: '🫨',
      keywords: {
        en: ['hushing face', 'quiet', 'shush', 'secret'],
        es: ['cara de silencio', 'callado', 'silencio', 'secreto'],
      },
    },
    {
      id: 50,
      emoji: '😌',
      keywords: {
        en: ['relieved', 'content', 'calm', 'satisfied'],
        es: ['aliviado', 'contento', 'calmado', 'satisfecho'],
      },
    },
    {
      id: 51,
      emoji: '😔',
      keywords: {
        en: ['sad', 'disappointed', 'dejected', 'down'],
        es: ['triste', 'decepcionado', 'abatido', 'decaído'],
      },
    },
    {
      id: 52,
      emoji: '😪',
      keywords: {
        en: ['sleepy', 'tired', 'exhausted', 'fatigued'],
        es: ['somnoliento', 'cansado', 'agotado', 'fatigado'],
      },
    },
    {
      id: 53,
      emoji: '🤤',
      keywords: {
        en: ['drooling', 'craving', 'hungry', 'appetizing'],
        es: ['babeando', 'antojo', 'hambriento', 'apetitoso'],
      },
    },
    {
      id: 54,
      emoji: '😴',
      keywords: {
        en: ['sleeping', 'asleep', 'zzz', 'resting'],
        es: ['durmiendo', 'dormido', 'zzz', 'descansando'],
      },
    },
    {
      id: 55,
      emoji: '😷',
      keywords: {
        en: ['mask', 'sick', 'health', 'ill'],
        es: ['mascarilla', 'enfermo', 'salud', 'enfermedad'],
      },
    },
    {
      id: 56,
      emoji: '🤒',
      keywords: {
        en: ['sick', 'unwell', 'feverish', 'ailment'],
        es: ['enfermo', 'indispuesto', 'con fiebre', 'dolencia'],
      },
    },
    {
      id: 57,
      emoji: '🤕',
      keywords: {
        en: ['injured', 'hurt', 'sick', 'unwell'],
        es: ['herido', 'lastimado', 'enfermo', 'indispuesto'],
      },
    },
    {
      id: 58,
      emoji: '🤢',
      keywords: {
        en: ['nauseated', 'sick', 'vomit', 'unwell'],
        es: ['nauseabundo', 'enfermo', 'vómito', 'indispuesto'],
      },
    },
    {
      id: 59,
      emoji: '🤮',
      keywords: {
        en: ['vomit', 'throw up', 'sick', 'nauseated'],
        es: ['vomitar', 'devolver', 'enfermo', 'nauseabundo'],
      },
    },
    {
      id: 60,
      emoji: '🤧',
      keywords: {
        en: ['sneeze', 'sick', 'cold', 'allergy'],
        es: ['estornudo', 'enfermo', 'resfriado', 'alergia'],
      },
    },
    {
      id: 61,
      emoji: '🥵',
      keywords: {
        en: ['hot', 'heat', 'sweating', 'fever'],
        es: ['calor', 'caliente', 'sudando', 'fiebre'],
      },
    },
    {
      id: 62,
      emoji: '🥶',
      keywords: {
        en: ['cold', 'chill', 'freezing', 'shivering'],
        es: ['frío', 'escalofrío', 'congelado', 'temblando'],
      },
    },
    {
      id: 63,
      emoji: '🥴',
      keywords: {
        en: ['woozy', 'dizzy', 'intoxicated', 'unsteady'],
        es: ['mareado', 'aturdido', 'intoxicado', 'inestable'],
      },
    },
    {
      id: 64,
      emoji: '😵',
      keywords: {
        en: ['dizzy', 'unconscious', 'faint', 'overwhelmed'],
        es: ['mareado', 'inconsciente', 'desmayo', 'abrumado'],
      },
    },
    {
      id: 65,
      emoji: '😵‍💫',
      keywords: {
        en: ['dizzy', 'unconscious', 'faint', 'overwhelmed'],
        es: ['mareado', 'inconsciente', 'desmayo', 'abrumado'],
      },
    },
    {
      id: 66,
      emoji: '🤯',
      keywords: {
        en: ['mind blown', 'shocked', 'astonished', 'amazed'],
        es: ['mente explotada', 'impactado', 'asombrado', 'maravillado'],
      },
    },
    {
      id: 67,
      emoji: '🤠',
      keywords: {
        en: ['cowboy', 'wild west', 'rodeo', 'hat'],
        es: ['vaquero', 'viejo oeste', 'rodeo', 'sombrero'],
      },
    },
    {
      id: 68,
      emoji: '🥳',
      keywords: {
        en: ['celebration', 'party', 'excitement', 'joy'],
        es: ['celebración', 'fiesta', 'emoción', 'alegría'],
      },
    },
    {
      id: 69,
      emoji: '🥸',
      keywords: {
        en: ['disguise', 'mask', 'costume', 'playful'],
        es: ['disfraz', 'máscara', 'traje', 'juguetón'],
      },
    },
    {
      id: 70,
      emoji: '😎',
      keywords: {
        en: ['cool', 'sunglasses', 'confident', 'awesome'],
        es: ['genial', 'gafas de sol', 'confiado', 'increíble'],
      },
    },
    {
      id: 71,
      emoji: '🤓',
      keywords: {
        en: ['nerd', 'geek', 'intelligent', 'knowledgeable'],
        es: ['nerd', 'geek', 'inteligente', 'conocedor'],
      },
    },
    {
      id: 72,
      emoji: '🧐',
      keywords: {
        en: ['inquiring', 'curious', 'examining', 'studious'],
        es: ['investigador', 'curioso', 'examinando', 'estudioso'],
      },
    },
    {
      id: 73,
      emoji: '😕',
      keywords: {
        en: ['confused', 'uncertain', 'perplexed', 'puzzled'],
        es: ['confundido', 'incierto', 'perplejo', 'desconcertado'],
      },
    },
    {
      id: 74,
      emoji: '🫤',
      keywords: {
        en: ['displeased', 'unhappy', 'dissatisfied', 'unsure'],
        es: ['disgustado', 'infeliz', 'insatisfecho', 'inseguro'],
      },
    },
    {
      id: 75,
      emoji: '😟',
      keywords: {
        en: ['worried', 'anxious', 'concerned', 'troubled'],
        es: ['preocupado', 'ansioso', 'inquieto', 'afligido'],
      },
    },
    {
      id: 76,
      emoji: '🙁',
      keywords: {
        en: ['frowning', 'unhappy', 'sad', 'displeased'],
        es: ['ceñudo', 'infeliz', 'triste', 'disgustado'],
      },
    },
    {
      id: 77,
      emoji: '☹️',
      keywords: {
        en: ['frowning', 'unhappy', 'sad', 'displeased'],
        es: ['ceñudo', 'infeliz', 'triste', 'disgustado'],
      },
    },
    {
      id: 78,
      emoji: '😮',
      keywords: {
        en: ['surprised', 'shocked', 'astonished', 'awe'],
        es: ['sorprendido', 'impactado', 'asombrado', 'admiración'],
      },
    },
    {
      id: 79,
      emoji: '😯',
      keywords: {
        en: ['surprised', 'shocked', 'stunned', 'awe'],
        es: ['sorprendido', 'impactado', 'aturdido', 'admiración'],
      },
    },
    {
      id: 80,
      emoji: '😲',
      keywords: {
        en: ['astonished', 'surprised', 'shocked', 'amazed'],
        es: ['asombrado', 'sorprendido', 'impactado', 'maravillado'],
      },
    },
    {
      id: 81,
      emoji: '😳',
      keywords: {
        en: ['flushed', 'embarrassed', 'shy', 'blushing'],
        es: ['sonrojado', 'avergonzado', 'tímido', 'ruborizado'],
      },
    },
    {
      id: 82,
      emoji: '🥺',
      keywords: {
        en: ['pleading', 'puppy eyes', 'begging', 'hopeful'],
        es: ['suplicando', 'ojitos tiernos', 'rogando', 'esperanzado'],
      },
    },
    {
      id: 83,
      emoji: '🥹',
      keywords: {
        en: ['concerned', 'solicitous', 'anxious', 'nervous'],
        es: ['preocupado', 'solícito', 'ansioso', 'nervioso'],
      },
    },
    {
      id: 84,
      emoji: '😦',
      keywords: {
        en: ['frowning', 'concerned', 'worried', 'anxious'],
        es: ['ceñudo', 'inquieto', 'preocupado', 'ansioso'],
      },
    },
    {
      id: 85,
      emoji: '😧',
      keywords: {
        en: ['anguished', 'distressed', 'pain', 'uncomfortable'],
        es: ['angustiado', 'afligido', 'dolor', 'incómodo'],
      },
    },
    {
      id: 86,
      emoji: '😨',
      keywords: {
        en: ['afraid', 'scared', 'anxious', 'terrified'],
        es: ['asustado', 'atemorizado', 'ansioso', 'aterrado'],
      },
    },
    {
      id: 87,
      emoji: '😰',
      keywords: {
        en: ['anxious', 'worried', 'stressed', 'terrified'],
        es: ['ansioso', 'preocupado', 'estresado', 'aterrado'],
      },
    },
    {
      id: 88,
      emoji: '😥',
      keywords: {
        en: ['sad', 'crying', 'tearful', 'upset'],
        es: ['triste', 'llorando', 'lloroso', 'alterado'],
      },
    },
    {
      id: 89,
      emoji: '😢',
      keywords: {
        en: ['sad', 'crying', 'tearful', 'sorrowful'],
        es: ['triste', 'llorando', 'lloroso', 'apenado'],
      },
    },
    {
      id: 90,
      emoji: '😭',
      keywords: {
        en: ['crying', 'sobbing', 'heartbroken', 'sad'],
        es: ['llorando', 'sollozando', 'desconsolado', 'triste'],
      },
    },
    {
      id: 91,
      emoji: '😱',
      keywords: {
        en: ['screaming', 'shocked', 'terrified', 'fearful'],
        es: ['gritando', 'impactado', 'aterrado', 'temeroso'],
      },
    },
    {
      id: 92,
      emoji: '😖',
      keywords: {
        en: ['anguished', 'tormented', 'distressed', 'pain'],
        es: ['angustiado', 'atormentado', 'afligido', 'dolor'],
      },
    },
    {
      id: 93,
      emoji: '😣',
      keywords: {
        en: ['anguished', 'disappointed', 'despair', 'hurt'],
        es: ['angustiado', 'decepcionado', 'desesperación', 'herido'],
      },
    },
    {
      id: 94,
      emoji: '😞',
      keywords: {
        en: ['sad', 'disappointed', 'unhappy', 'regretful'],
        es: ['triste', 'decepcionado', 'infeliz', 'arrepentido'],
      },
    },
    {
      id: 95,
      emoji: '😓',
      keywords: {
        en: ['worried', 'anxious', 'concerned', 'troubled'],
        es: ['preocupado', 'ansioso', 'inquieto', 'afligido'],
      },
    },
    {
      id: 96,
      emoji: '😩',
      keywords: {
        en: ['weary', 'exhausted', 'tired', 'stressed'],
        es: ['agotado', 'exhausto', 'cansado', 'estresado'],
      },
    },
    {
      id: 97,
      emoji: '😫',
      keywords: {
        en: ['tired', 'exhausted', 'weary', 'fatigued'],
        es: ['cansado', 'exhausto', 'agotado', 'fatigado'],
      },
    },
    {
      id: 98,
      emoji: '🥱',
      keywords: {
        en: ['yawn', 'tired', 'sleepy', 'bored'],
        es: ['bostezo', 'cansado', 'somnoliento', 'aburrido'],
      },
    },
    {
      id: 99,
      emoji: '😤',
      keywords: {
        en: ['angry', 'frustrated', 'annoyed', 'irritated'],
        es: ['enojado', 'frustrado', 'molesto', 'irritado'],
      },
    },
    {
      id: 100,
      emoji: '😡',
      keywords: {
        en: ['angry', 'mad', 'irritable', 'frustrated'],
        es: ['enojado', 'furioso', 'irritable', 'frustrado'],
      },
    },
    {
      id: 101,
      emoji: '😠',
      keywords: {
        en: ['angry', 'irate', 'annoyed', 'displeased'],
        es: ['enojado', 'furioso', 'molesto', 'disgustado'],
      },
    },
    {
      id: 102,
      emoji: '🤬',
      keywords: {
        en: ['swearing', 'cursing', 'angry', 'irate'],
        es: ['insultando', 'maldiciendo', 'enojado', 'furioso'],
      },
    },
    {
      id: 103,
      emoji: '😈',
      keywords: {
        en: ['devilish', 'mischievous', 'naughty', 'evil'],
        es: ['diabólico', 'pícaro', 'travieso', 'malvado'],
      },
    },
    {
      id: 104,
      emoji: '👿',
      keywords: {
        en: ['evil', 'devil', 'angry', 'demon'],
        es: ['malvado', 'diablo', 'enojado', 'demonio'],
      },
    },
    {
      id: 105,
      emoji: '💀',
      keywords: {
        en: ['skull', 'dead', 'death', 'grim'],
        es: ['calavera', 'muerto', 'muerte', 'sombrío'],
      },
    },
    {
      id: 106,
      emoji: '☠️',
      keywords: {
        en: ['skull', 'crossbones', 'danger', 'dead'],
        es: ['calavera', 'huesos cruzados', 'peligro', 'muerto'],
      },
    },
    {
      id: 107,
      emoji: '💩',
      keywords: {
        en: ['poop', 'crap', 'funny', 'silly'],
        es: ['popó', 'mierda', 'gracioso', 'tonto'],
      },
    },
    {
      id: 108,
      emoji: '🤡',
      keywords: {
        en: ['clown', 'silly', 'funny', 'entertaining'],
        es: ['payaso', 'tonto', 'gracioso', 'entretenido'],
      },
    },
    {
      id: 109,
      emoji: '👹',
      keywords: {
        en: ['ogre', 'monster', 'evil', 'demon'],
        es: ['ogro', 'monstruo', 'malvado', 'demonio'],
      },
    },
    {
      id: 110,
      emoji: '👺',
      keywords: {
        en: ['goblin', 'monster', 'evil', 'trickster'],
        es: ['duende', 'monstruo', 'malvado', 'tramposo'],
      },
    },
    {
      id: 111,
      emoji: '👻',
      keywords: {
        en: ['ghost', 'spooky', 'haunted', 'paranormal'],
        es: ['fantasma', 'espeluznante', 'embrujado', 'paranormal'],
      },
    },
    {
      id: 112,
      emoji: '👽',
      keywords: {
        en: ['alien', 'extraterrestrial', 'ufo', 'space'],
        es: ['alienígena', 'extraterrestre', 'ovni', 'espacio'],
      },
    },
    {
      id: 113,
      emoji: '👾',
      keywords: {
        en: ['alien', 'monster', 'game', 'space'],
        es: ['alienígena', 'monstruo', 'juego', 'espacio'],
      },
    },
    {
      id: 114,
      emoji: '🤖',
      keywords: {
        en: ['robot', 'artificial intelligence', 'machine', 'cybernetic'],
        es: ['robot', 'inteligencia artificial', 'máquina', 'cibernético'],
      },
    },
    {
      id: 115,
      emoji: '😺',
      keywords: {
        en: ['cat', 'smile', 'happy', 'playful'],
        es: ['gato', 'sonrisa', 'feliz', 'juguetón'],
      },
    },
    {
      id: 116,
      emoji: '😸',
      keywords: {
        en: ['cat', 'smile', 'happy', 'joyful'],
        es: ['gato', 'sonrisa', 'feliz', 'alegre'],
      },
    },
    {
      id: 117,
      emoji: '😹',
      keywords: {
        en: ['cat', 'laugh', 'happy', 'joy'],
        es: ['gato', 'risa', 'feliz', 'alegría'],
      },
    },
    {
      id: 118,
      emoji: '😻',
      keywords: {
        en: ['cat', 'love', 'affection', 'adoration'],
        es: ['gato', 'amor', 'afecto', 'adoración'],
      },
    },
    {
      id: 119,
      emoji: '😼',
      keywords: {
        en: ['cat', 'smirk', 'mischievous', 'playful'],
        es: ['gato', 'sonrisa pícara', 'travieso', 'juguetón'],
      },
    },
    {
      id: 120,
      emoji: '😽',
      keywords: {
        en: ['cat', 'kiss', 'affectionate', 'smooch'],
        es: ['gato', 'beso', 'cariñoso', 'besito'],
      },
    },
    {
      id: 121,
      emoji: '🙀',
      keywords: {
        en: ['cat', 'shock', 'surprise', 'scared'],
        es: ['gato', 'impacto', 'sorpresa', 'asustado'],
      },
    },
    {
      id: 122,
      emoji: '😿',
      keywords: {
        en: ['sad', 'cat', 'crying', 'unhappy'],
        es: ['triste', 'gato', 'llorando', 'infeliz'],
      },
    },
    {
      id: 123,
      emoji: '😾',
      keywords: {
        en: ['angry', 'cat', 'grumpy', 'annoyed'],
        es: ['enojado', 'gato', 'gruñón', 'molesto'],
      },
    },
    {
      id: 124,
      emoji: '🙈',
      keywords: {
        en: ['monkey', 'see no evil', 'playful', 'curious'],
        es: ['mono', 'no ver el mal', 'juguetón', 'curioso'],
      },
    },
    {
      id: 125,
      emoji: '🙉',
      keywords: {
        en: ['monkey', 'hear no evil', 'listening', 'curious'],
        es: ['mono', 'no oír el mal', 'escuchando', 'curioso'],
      },
    },
    {
      id: 126,
      emoji: '🙊',
      keywords: {
        en: ['monkey', 'speak no evil', 'silence', 'secret'],
        es: ['mono', 'no decir el mal', 'silencio', 'secreto'],
      },
    },
    {
      id: 127,
      emoji: '💋',
      keywords: {
        en: ['kiss', 'lips', 'affection', 'romance'],
        es: ['beso', 'labios', 'afecto', 'romance'],
      },
    },
    {
      id: 128,
      emoji: '💯',
      keywords: {
        en: ['100', 'perfect', 'score', 'excellent'],
        es: ['100', 'perfecto', 'puntaje', 'excelente'],
      },
    },
    {
      id: 129,
      emoji: '💢',
      keywords: {
        en: ['anger', 'explosion', 'angry', 'mad'],
        es: ['ira', 'explosión', 'enojado', 'furioso'],
      },
    },
    {
      id: 130,
      emoji: '💥',
      keywords: {
        en: ['explosion', 'impact', 'boom', 'power'],
        es: ['explosión', 'impacto', 'boom', 'poder'],
      },
    },
    {
      id: 131,
      emoji: '💫',
      keywords: {
        en: ['star', 'sparkle', 'magic', 'glitter'],
        es: ['estrella', 'brillo', 'magia', 'destello'],
      },
    },
    {
      id: 132,
      emoji: '💦',
      keywords: {
        en: ['water', 'sweat', 'droplet', 'wet'],
        es: ['agua', 'sudor', 'gota', 'mojado'],
      },
    },
    {
      id: 133,
      emoji: '💨',
      keywords: {
        en: ['wind', 'blow', 'fast', 'movement'],
        es: ['viento', 'soplo', 'rápido', 'movimiento'],
      },
    },
    {
      id: 134,
      emoji: '🕳️',
      keywords: {
        en: ['hole', 'void', 'empty', 'gap'],
        es: ['agujero', 'vacío', 'hueco', 'brecha'],
      },
    },
    {
      id: 135,
      emoji: '💤',
      keywords: {
        en: ['sleep', 'zzz', 'rest', 'nap'],
        es: ['sueño', 'zzz', 'descanso', 'siesta'],
      },
    },
    {
      id: 136,
      emoji: '👋',
      keywords: {
        en: ['wave', 'hello', 'goodbye', 'greeting'],
        es: ['saludo', 'hola', 'adiós', 'saludar'],
      },
    },
    {
      id: 137,
      emoji: '🤚',
      keywords: {
        en: ['raised hand', 'stop', 'hi', 'greeting'],
        es: ['mano levantada', 'alto', 'hola', 'saludo'],
      },
    },
    {
      id: 138,
      emoji: '🖐️',
      keywords: {
        en: ['hand', 'fingers', 'palm', 'gesture'],
        es: ['mano', 'dedos', 'palma', 'gesto'],
      },
    },
    {
      id: 139,
      emoji: '✋',
      keywords: {
        en: ['hand', 'stop', 'hi', 'greeting'],
        es: ['mano', 'alto', 'hola', 'saludo'],
      },
    },
    {
      id: 140,
      emoji: '🖖',
      keywords: {
        en: ['vulcan', 'hand', 'greeting', 'peace'],
        es: ['vulcano', 'mano', 'saludo', 'paz'],
      },
    },
    {
      id: 141,
      emoji: '🫱',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'upward'],
        es: ['mano', 'palma', 'gesto', 'hacia arriba'],
      },
    },
    {
      id: 142,
      emoji: '🫲',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'downward'],
        es: ['mano', 'palma', 'gesto', 'hacia abajo'],
      },
    },
    {
      id: 143,
      emoji: '🫳',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'left'],
        es: ['mano', 'palma', 'gesto', 'izquierda'],
      },
    },
    {
      id: 144,
      emoji: '🫴',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'right'],
        es: ['mano', 'palma', 'gesto', 'derecha'],
      },
    },
    {
      id: 145,
      emoji: '🫷',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'crossed'],
        es: ['mano', 'palma', 'gesto', 'cruzado'],
      },
    },
    {
      id: 146,
      emoji: '🫸',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'diagonal'],
        es: ['mano', 'palma', 'gesto', 'diagonal'],
      },
    },
    {
      id: 147,
      emoji: '👌',
      keywords: {
        en: ['okay', 'good', 'perfect', 'excellent'],
        es: ['ok', 'bueno', 'perfecto', 'excelente'],
      },
    },
    {
      id: 148,
      emoji: '🤌',
      keywords: {
        en: ['pinch', 'fingers', 'hand', 'small amount'],
        es: ['pellizco', 'dedos', 'mano', 'poca cantidad'],
      },
    },
    {
      id: 149,
      emoji: '🤏',
      keywords: {
        en: ['pinch', 'fingers', 'hand', 'small amount'],
        es: ['pellizco', 'dedos', 'mano', 'poca cantidad'],
      },
    },
    {
      id: 150,
      emoji: '✌️',
      keywords: {
        en: ['victory', 'peace', 'two', 'hand'],
        es: ['victoria', 'paz', 'dos', 'mano'],
      },
    },
    {
      id: 151,
      emoji: '🤞',
      keywords: {
        en: ['crossed fingers', 'wish', 'luck', 'hope'],
        es: ['dedos cruzados', 'deseo', 'suerte', 'esperanza'],
      },
    },
    {
      id: 152,
      emoji: '🫰',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'fingers crossed'],
        es: ['mano', 'palma', 'gesto', 'dedos cruzados'],
      },
    },
    {
      id: 153,
      emoji: '🤟',
      keywords: {
        en: ['love', 'hand', 'sign', 'gesture'],
        es: ['amor', 'mano', 'señal', 'gesto'],
      },
    },
    {
      id: 154,
      emoji: '🤘',
      keywords: {
        en: ['rock', 'hand', 'sign', 'gesture'],
        es: ['rock', 'mano', 'señal', 'gesto'],
      },
    },
    {
      id: 155,
      emoji: '🤙',
      keywords: {
        en: ['call me', 'hang loose', 'phone', 'gesture'],
        es: ['llámame', 'relajado', 'teléfono', 'gesto'],
      },
    },
    {
      id: 156,
      emoji: '👈',
      keywords: {
        en: ['pointing', 'left', 'direction', 'arrow'],
        es: ['apuntando', 'izquierda', 'dirección', 'flecha'],
      },
    },
    {
      id: 157,
      emoji: '👉',
      keywords: {
        en: ['pointing', 'right', 'direction', 'arrow'],
        es: ['apuntando', 'derecha', 'dirección', 'flecha'],
      },
    },
    {
      id: 158,
      emoji: '👆',
      keywords: {
        en: ['pointing', 'up', 'direction', 'arrow'],
        es: ['apuntando', 'arriba', 'dirección', 'flecha'],
      },
    },
    {
      id: 159,
      emoji: '🖕',
      keywords: {
        en: ['middle finger', 'rude', 'offensive', 'gesture'],
        es: ['dedo medio', 'grosero', 'ofensivo', 'gesto'],
      },
    },
    {
      id: 160,
      emoji: '👇',
      keywords: {
        en: ['pointing', 'down', 'direction', 'arrow'],
        es: ['apuntando', 'abajo', 'dirección', 'flecha'],
      },
    },
    {
      id: 161,
      emoji: '☝️',
      keywords: {
        en: ['pointing', 'up', 'direction', 'arrow'],
        es: ['apuntando', 'arriba', 'dirección', 'flecha'],
      },
    },
    {
      id: 162,
      emoji: '🫵',
      keywords: {
        en: ['hand', 'palm', 'gesture', 'stop'],
        es: ['mano', 'palma', 'gesto', 'alto'],
      },
    },
    {
      id: 163,
      emoji: '👍',
      keywords: {
        en: ['thumbs up', 'good', 'approval', 'positive'],
        es: ['pulgar arriba', 'bueno', 'aprobación', 'positivo'],
      },
    },
    {
      id: 164,
      emoji: '👎',
      keywords: {
        en: ['thumbs down', 'bad', 'disapproval', 'negative'],
        es: ['pulgar abajo', 'malo', 'desaprobación', 'negativo'],
      },
    },
    {
      id: 165,
      emoji: '✊',
      keywords: {
        en: ['raised fist', 'power', 'solidarity', 'strength'],
        es: ['puño levantado', 'poder', 'solidaridad', 'fuerza'],
      },
    },
    {
      id: 166,
      emoji: '👊',
      keywords: {
        en: ['fist bump', 'punch', 'hit', 'strong'],
        es: ['choque de puños', 'puñetazo', 'golpe', 'fuerte'],
      },
    },
    {
      id: 167,
      emoji: '🤛',
      keywords: {
        en: ['left fist', 'punch', 'hit', 'strong'],
        es: ['puño izquierdo', 'puñetazo', 'golpe', 'fuerte'],
      },
    },
    {
      id: 168,
      emoji: '🤜',
      keywords: {
        en: ['right fist', 'punch', 'hit', 'strong'],
        es: ['puño derecho', 'puñetazo', 'golpe', 'fuerte'],
      },
    },
    {
      id: 169,
      emoji: '👏',
      keywords: {
        en: ['clap', 'applause', 'bravo', 'congratulations'],
        es: ['aplauso', 'aplausos', 'bravo', 'felicitaciones'],
      },
    },
    {
      id: 170,
      emoji: '🙌',
      keywords: {
        en: ['raised hands', 'celebration', 'praise', 'excitement'],
        es: ['manos levantadas', 'celebración', 'alabanza', 'emoción'],
      },
    },
    {
      id: 171,
      emoji: '🫶',
      keywords: {
        en: ['hands', 'praying', 'thankful', 'blessings'],
        es: ['manos', 'rezando', 'agradecido', 'bendiciones'],
      },
    },
    {
      id: 172,
      emoji: '👐',
      keywords: {
        en: ['open hands', 'gesture', 'receive', 'give'],
        es: ['manos abiertas', 'gesto', 'recibir', 'dar'],
      },
    },
    {
      id: 173,
      emoji: '🤲',
      keywords: {
        en: ['palms up', 'hands', 'gesture', 'receive'],
        es: ['palmas arriba', 'manos', 'gesto', 'recibir'],
      },
    },
    {
      id: 174,
      emoji: '🤝',
      keywords: {
        en: ['handshake', 'agreement', 'deal', 'partnership'],
        es: ['apretón de manos', 'acuerdo', 'trato', 'alianza'],
      },
    },
    {
      id: 175,
      emoji: '🙏',
      keywords: {
        en: ['folded hands', 'pray', 'plead', 'thankful'],
        es: ['manos juntas', 'rezar', 'suplicar', 'agradecido'],
      },
    },
    {
      id: 176,
      emoji: '✍️',
      keywords: {
        en: ['writing', 'signature', 'pen', 'creative'],
        es: ['escritura', 'firma', 'bolígrafo', 'creativo'],
      },
    },
    {
      id: 177,
      emoji: '💅',
      keywords: {
        en: ['nail polish', 'beauty', 'manicure', 'cosmetic'],
        es: ['esmalte de uñas', 'belleza', 'manicura', 'cosmético'],
      },
    },
    {
      id: 178,
      emoji: '🤳',
      keywords: {
        en: ['selfie', 'photo', 'camera', 'pose'],
        es: ['selfie', 'foto', 'cámara', 'pose'],
      },
    },
    {
      id: 179,
      emoji: '💪',
      keywords: {
        en: ['flex', 'strong', 'bicep', 'power'],
        es: ['flexionar', 'fuerte', 'bíceps', 'poder'],
      },
    },
    {
      id: 180,
      emoji: '🦾',
      keywords: {
        en: ['mechanical arm', 'prosthetic', 'strength', 'assist'],
        es: ['brazo mecánico', 'prótesis', 'fuerza', 'asistencia'],
      },
    },
    {
      id: 181,
      emoji: '🦿',
      keywords: {
        en: ['mechanical leg', 'prosthetic', 'movement', 'assist'],
        es: ['pierna mecánica', 'prótesis', 'movimiento', 'asistencia'],
      },
    },
    {
      id: 182,
      emoji: '🦵',
      keywords: {
        en: ['leg', 'kick', 'muscle', 'movement'],
        es: ['pierna', 'patada', 'músculo', 'movimiento'],
      },
    },
    {
      id: 183,
      emoji: '🦶',
      keywords: {
        en: ['foot', 'step', 'walk', 'movement'],
        es: ['pie', 'paso', 'caminar', 'movimiento'],
      },
    },
    {
      id: 184,
      emoji: '👂',
      keywords: {
        en: ['ear', 'hear', 'listening', 'sound'],
        es: ['oreja', 'oír', 'escuchando', 'sonido'],
      },
    },
    {
      id: 185,
      emoji: '🦻',
      keywords: {
        en: ['deaf', 'hard of hearing', 'accessibility', 'ear'],
        es: ['sordo', 'dificultad auditiva', 'accesibilidad', 'oreja'],
      },
    },
    {
      id: 186,
      emoji: '👃',
      keywords: {
        en: ['nose', 'smell', 'sniff', 'scent'],
        es: ['nariz', 'oler', 'olfatear', 'aroma'],
      },
    },
    {
      id: 187,
      emoji: '🧠',
      keywords: {
        en: ['brain', 'mind', 'intellect', 'thinking'],
        es: ['cerebro', 'mente', 'intelecto', 'pensamiento'],
      },
    },
    {
      id: 188,
      emoji: '🫀',
      keywords: {
        en: ['heart', 'organ', 'cardiovascular', 'love'],
        es: ['corazón', 'órgano', 'cardiovascular', 'amor'],
      },
    },
    {
      id: 189,
      emoji: '🫁',
      keywords: {
        en: ['lungs', 'organ', 'respiratory', 'breathe'],
        es: ['pulmones', 'órgano', 'respiratorio', 'respirar'],
      },
    },
    {
      id: 190,
      emoji: '🦷',
      keywords: {
        en: ['tooth', 'dentist', 'oral', 'teeth'],
        es: ['diente', 'dentista', 'oral', 'dientes'],
      },
    },
    {
      id: 191,
      emoji: '🦴',
      keywords: {
        en: ['bone', 'skeletal', 'anatomy', 'structure'],
        es: ['hueso', 'esquelético', 'anatomía', 'estructura'],
      },
    },
    {
      id: 192,
      emoji: '👀',
      keywords: {
        en: ['eyes', 'look', 'see', 'watch'],
        es: ['ojos', 'mirar', 'ver', 'observar'],
      },
    },
    {
      id: 193,
      emoji: '👁️',
      keywords: {
        en: ['eye', 'vision', 'look', 'see'],
        es: ['ojo', 'visión', 'mirar', 'ver'],
      },
    },
    {
      id: 194,
      emoji: '👅',
      keywords: {
        en: ['tongue', 'lick', 'taste', 'mouth'],
        es: ['lengua', 'lamer', 'saborear', 'boca'],
      },
    },
    {
      id: 195,
      emoji: '👄',
      keywords: {
        en: ['lips', 'mouth', 'kiss', 'talk'],
        es: ['labios', 'boca', 'beso', 'hablar'],
      },
    },
    {
      id: 196,
      emoji: '🫦',
      keywords: {
        en: ['face', 'abstract', 'expression', 'emoticon'],
        es: ['cara', 'abstracto', 'expresión', 'emoticón'],
      },
    },
    {
      id: 197,
      emoji: '👶',
      keywords: {
        en: ['baby', 'infant', 'newborn', 'child'],
        es: ['bebé', 'infante', 'recién nacido', 'niño'],
      },
    },
    {
      id: 198,
      emoji: '🧒',
      keywords: {
        en: ['child', 'kid', 'young', 'playful'],
        es: ['niño', 'chico', 'joven', 'juguetón'],
      },
    },
    {
      id: 199,
      emoji: '👦',
      keywords: {
        en: ['boy', 'child', 'kid', 'young'],
        es: ['niño', 'menor', 'chico', 'joven'],
      },
    },
    {
      id: 200,
      emoji: '👧',
      keywords: {
        en: ['girl', 'child', 'kid', 'young'],
        es: ['niña', 'menor', 'chica', 'joven'],
      },
    },
    {
      id: 201,
      emoji: '🧑',
      keywords: {
        en: ['person', 'individual', 'human', 'adult'],
        es: ['persona', 'individuo', 'humano', 'adulto'],
      },
    },
    {
      id: 202,
      emoji: '👱',
      keywords: {
        en: ['blond hair', 'person', 'young', 'individual'],
        es: ['cabello rubio', 'persona', 'joven', 'individuo'],
      },
    },
    {
      id: 203,
      emoji: '👨',
      keywords: {
        en: ['man', 'person', 'adult', 'male'],
        es: ['hombre', 'persona', 'adulto', 'masculino'],
      },
    },
    {
      id: 204,
      emoji: '🧔',
      keywords: {
        en: ['bearded', 'face', 'man', 'individual'],
        es: ['barbudo', 'cara', 'hombre', 'individuo'],
      },
    },
    {
      id: 205,
      emoji: '🧔‍♂️',
      keywords: {
        en: ['bearded', 'face', 'man', 'individual'],
        es: ['barbudo', 'cara', 'hombre', 'individuo'],
      },
    },
    {
      id: 206,
      emoji: '🧔‍♀️',
      keywords: {
        en: ['bearded', 'face', 'woman', 'individual'],
        es: ['barbuda', 'cara', 'mujer', 'individuo'],
      },
    },
    {
      id: 207,
      emoji: '👨‍🦰',
      keywords: {
        en: ['red hair', 'man', 'person', 'individual'],
        es: ['cabello rojo', 'hombre', 'persona', 'individuo'],
      },
    },
    {
      id: 208,
      emoji: '👨‍🦱',
      keywords: {
        en: ['curly hair', 'man', 'person', 'individual'],
        es: ['cabello rizado', 'hombre', 'persona', 'individuo'],
      },
    },
    {
      id: 209,
      emoji: '👨‍🦳',
      keywords: {
        en: ['white hair', 'man', 'person', 'individual'],
        es: ['cabello blanco', 'hombre', 'persona', 'individuo'],
      },
    },
    {
      id: 210,
      emoji: '👨‍🦲',
      keywords: {
        en: ['bald', 'man', 'person', 'individual'],
        es: ['calvo', 'hombre', 'persona', 'individuo'],
      },
    },
    {
      id: 211,
      emoji: '👩',
      keywords: {
        en: ['woman', 'person', 'adult', 'female'],
        es: ['mujer', 'persona', 'adulta', 'femenino'],
      },
    },
    {
      id: 212,
      emoji: '👩‍🦰',
      keywords: {
        en: ['red hair', 'woman', 'person', 'individual'],
        es: ['cabello rojo', 'mujer', 'persona', 'individuo'],
      },
    },
    {
      id: 213,
      emoji: '🧑‍🦰',
      keywords: {
        en: ['red hair', 'person', 'individual', 'human'],
        es: ['cabello rojo', 'persona', 'individuo', 'humano'],
      },
    },
    {
      id: 214,
      emoji: '👩‍🦱',
      keywords: {
        en: ['curly hair', 'woman', 'person', 'individual'],
        es: ['cabello rizado', 'mujer', 'persona', 'individuo'],
      },
    },
    {
      id: 215,
      emoji: '🧑‍🦱',
      keywords: {
        en: ['curly hair', 'person', 'individual', 'human'],
        es: ['cabello rizado', 'persona', 'individuo', 'humano'],
      },
    },
    {
      id: 216,
      emoji: '👩‍🦳',
      keywords: {
        en: ['white hair', 'woman', 'person', 'individual'],
        es: ['cabello blanco', 'mujer', 'persona', 'individuo'],
      },
    },
    {
      id: 217,
      emoji: '🧑‍🦳',
      keywords: {
        en: ['white hair', 'person', 'individual', 'human'],
        es: ['cabello blanco', 'persona', 'individuo', 'humano'],
      },
    },
    {
      id: 218,
      emoji: '👩‍🦲',
      keywords: {
        en: ['bald', 'woman', 'person', 'individual'],
        es: ['calva', 'mujer', 'persona', 'individuo'],
      },
    },
    {
      id: 219,
      emoji: '🧑‍🦲',
      keywords: {
        en: ['bald', 'person', 'individual', 'human'],
        es: ['calvo', 'persona', 'individuo', 'humano'],
      },
    },
    {
      id: 220,
      emoji: '👱‍♀️',
      keywords: {
        en: ['blond hair', 'woman', 'person', 'individual'],
        es: ['cabello rubio', 'mujer', 'persona', 'individuo'],
      },
    },
    {
      id: 221,
      emoji: '👱‍♂️',
      keywords: {
        en: ['blond hair', 'man', 'person', 'individual'],
        es: ['cabello rubio', 'hombre', 'persona', 'individuo'],
      },
    },
    {
      id: 222,
      emoji: '🧓',
      keywords: {
        en: ['older adult', 'elderly', 'senior', 'aging'],
        es: ['adulto mayor', 'anciano', 'mayor', 'envejecimiento'],
      },
    },
    {
      id: 223,
      emoji: '👴',
      keywords: {
        en: ['old man', 'elderly', 'senior', 'aging'],
        es: ['anciano', 'hombre mayor', 'mayor', 'envejecimiento'],
      },
    },
    {
      id: 224,
      emoji: '👵',
      keywords: {
        en: ['old woman', 'elderly', 'senior', 'aging'],
        es: ['anciana', 'mujer mayor', 'mayor', 'envejecimiento'],
      },
    },
    {
      id: 225,
      emoji: '🙍',
      keywords: {
        en: ['frowning', 'sad', 'unhappy', 'upset'],
        es: ['ceñudo', 'triste', 'infeliz', 'molesto'],
      },
    },
    {
      id: 226,
      emoji: '🙍‍♂️',
      keywords: {
        en: ['frowning', 'man', 'sad', 'unhappy'],
        es: ['ceñudo', 'hombre', 'triste', 'infeliz'],
      },
    },
    {
      id: 227,
      emoji: '🙍‍♀️',
      keywords: {
        en: ['frowning', 'woman', 'sad', 'unhappy'],
        es: ['ceñuda', 'mujer', 'triste', 'infeliz'],
      },
    },
    {
      id: 228,
      emoji: '🙎',
      keywords: {
        en: ['pouting', 'displeased', 'unhappy', 'annoyed'],
        es: ['haciendo puchero', 'disgustado', 'infeliz', 'molesto'],
      },
    },
    {
      id: 229,
      emoji: '🙎‍♂️',
      keywords: {
        en: ['pouting', 'man', 'unhappy', 'annoyed'],
        es: ['haciendo puchero', 'hombre', 'infeliz', 'molesto'],
      },
    },
    {
      id: 230,
      emoji: '🙎‍♀️',
      keywords: {
        en: ['pouting', 'woman', 'unhappy', 'annoyed'],
        es: ['haciendo puchero', 'mujer', 'infeliz', 'molesta'],
      },
    },
    {
      id: 231,
      emoji: '🙅',
      keywords: {
        en: ['no', 'stop', 'disapproval', 'denial'],
        es: ['no', 'alto', 'desaprobación', 'negación'],
      },
    },
    {
      id: 232,
      emoji: '🙅‍♂️',
      keywords: {
        en: ['no', 'stop', 'disapproval', 'denial'],
        es: ['no', 'alto', 'desaprobación', 'negación'],
      },
    },
    {
      id: 233,
      emoji: '🙅‍♀️',
      keywords: {
        en: ['no', 'disapproval', 'disagree', 'reject'],
        es: ['no', 'desaprobación', 'desacuerdo', 'rechazar'],
      },
    },
    {
      id: 234,
      emoji: '🙆',
      keywords: {
        en: ['approval', 'acceptance', 'agree', 'support'],
        es: ['aprobación', 'aceptación', 'estar de acuerdo', 'apoyo'],
      },
    },
    {
      id: 235,
      emoji: '🙆‍♂️',
      keywords: {
        en: ['approval', 'acceptance', 'agree', 'support'],
        es: ['aprobación', 'aceptación', 'estar de acuerdo', 'apoyo'],
      },
    },
    {
      id: 236,
      emoji: '🙆‍♀️',
      keywords: {
        en: ['approval', 'acceptance', 'agree', 'support'],
        es: ['aprobación', 'aceptación', 'estar de acuerdo', 'apoyo'],
      },
    },
    {
      id: 237,
      emoji: '💁',
      keywords: {
        en: ['gesture', 'information', 'help', 'assistance'],
        es: ['gesto', 'información', 'ayuda', 'asistencia'],
      },
    },
    {
      id: 238,
      emoji: '💁‍♂️',
      keywords: {
        en: ['gesture', 'information', 'help', 'assistance'],
        es: ['gesto', 'información', 'ayuda', 'asistencia'],
      },
    },
    {
      id: 239,
      emoji: '💁‍♀️',
      keywords: {
        en: ['gesture', 'information', 'help', 'assistance'],
        es: ['gesto', 'información', 'ayuda', 'asistencia'],
      },
    },
    {
      id: 240,
      emoji: '🙋',
      keywords: {
        en: ['gesture', 'question', 'curious', 'interested'],
        es: ['gesto', 'pregunta', 'curioso', 'interesado'],
      },
    },
    {
      id: 241,
      emoji: '🙋‍♂️',
      keywords: {
        en: ['gesture', 'question', 'curious', 'interested'],
        es: ['gesto', 'pregunta', 'curioso', 'interesado'],
      },
    },
    {
      id: 242,
      emoji: '🙋‍♀️',
      keywords: {
        en: ['gesture', 'question', 'curious', 'interested'],
        es: ['gesto', 'pregunta', 'curiosa', 'interesada'],
      },
    },
    {
      id: 243,
      emoji: '🧏',
      keywords: {
        en: ['deaf', 'accessibility', 'inclusion', 'communication'],
        es: ['sordo', 'accesibilidad', 'inclusión', 'comunicación'],
      },
    },
    {
      id: 244,
      emoji: '🧏‍♂️',
      keywords: {
        en: ['deaf', 'accessibility', 'inclusion', 'communication'],
        es: ['sordo', 'accesibilidad', 'inclusión', 'comunicación'],
      },
    },
    {
      id: 245,
      emoji: '🧏‍♀️',
      keywords: {
        en: ['deaf', 'accessibility', 'inclusion', 'communication'],
        es: ['sorda', 'accesibilidad', 'inclusión', 'comunicación'],
      },
    },
    {
      id: 246,
      emoji: '🙇',
      keywords: {
        en: ['bow', 'respect', 'apology', 'thanks'],
        es: ['reverencia', 'respeto', 'disculpa', 'gracias'],
      },
    },
    {
      id: 247,
      emoji: '🙇‍♂️',
      keywords: {
        en: ['bow', 'respect', 'apology', 'thanks'],
        es: ['reverencia', 'respeto', 'disculpa', 'gracias'],
      },
    },
    {
      id: 248,
      emoji: '🙇‍♀️',
      keywords: {
        en: ['bow', 'respect', 'apology', 'thanks'],
        es: ['reverencia', 'respeto', 'disculpa', 'gracias'],
      },
    },
    {
      id: 249,
      emoji: '🤦',
      keywords: {
        en: ['facepalm', 'frustration', 'disbelief', 'exasperation'],
        es: ['mano en la cara', 'frustración', 'incredulidad', 'exasperación'],
      },
    },
    {
      id: 250,
      emoji: '🤦‍♂️',
      keywords: {
        en: ['facepalm', 'frustration', 'disbelief', 'exasperation'],
        es: ['mano en la cara', 'frustración', 'incredulidad', 'exasperación'],
      },
    },
    {
      id: 251,
      emoji: '🤦‍♀️',
      keywords: {
        en: ['facepalm', 'frustration', 'disbelief', 'exasperation'],
        es: ['mano en la cara', 'frustración', 'incredulidad', 'exasperación'],
      },
    },
    {
      id: 252,
      emoji: '🤷',
      keywords: {
        en: ['shrug', 'indifference', 'uncertainty', 'confusion'],
        es: ['encogerse de hombros', 'indiferencia', 'incertidumbre', 'confusión'],
      },
    },
    {
      id: 253,
      emoji: '🤷‍♂️',
      keywords: {
        en: ['shrug', 'indifference', 'uncertainty', 'confusion'],
        es: ['encogerse de hombros', 'indiferencia', 'incertidumbre', 'confusión'],
      },
    },
    {
      id: 254,
      emoji: '🤷‍♀️',
      keywords: {
        en: ['shrug', 'indifference', 'uncertainty', 'confusion'],
        es: ['encogerse de hombros', 'indiferencia', 'incertidumbre', 'confusión'],
      },
    },
    {
      id: 255,
      emoji: '🫅',
      keywords: {
        en: ['face', 'abstract', 'expression', 'emoticon'],
        es: ['cara', 'abstracto', 'expresión', 'emoticón'],
      },
    },
    {
      id: 256,
      emoji: '🤴',
      keywords: {
        en: ['king', 'royalty', 'leader', 'nobility'],
        es: ['rey', 'realeza', 'líder', 'nobleza'],
      },
    },
    {
      id: 257,
      emoji: '👸',
      keywords: {
        en: ['queen', 'royalty', 'leader', 'nobility'],
        es: ['reina', 'realeza', 'líder', 'nobleza'],
      },
    },
    {
      id: 258,
      emoji: '👳',
      keywords: {
        en: ['person wearing turban', 'culture', 'religion', 'headwear'],
        es: ['persona con turbante', 'cultura', 'religión', 'tocado'],
      },
    },
    {
      id: 259,
      emoji: '👳‍♂️',
      keywords: {
        en: ['man wearing turban', 'culture', 'religion', 'headwear'],
        es: ['hombre con turbante', 'cultura', 'religión', 'tocado'],
      },
    },
    {
      id: 260,
      emoji: '👳‍♀️',
      keywords: {
        en: ['woman wearing turban', 'culture', 'religion', 'headwear'],
        es: ['mujer con turbante', 'cultura', 'religión', 'tocado'],
      },
    },
    {
      id: 261,
      emoji: '👲',
      keywords: {
        en: ['person wearing skullcap', 'culture', 'religion', 'headwear'],
        es: ['persona con gorro', 'cultura', 'religión', 'tocado'],
      },
    },
    {
      id: 262,
      emoji: '🧕',
      keywords: {
        en: ['woman with headscarf', 'Muslim', 'modesty', 'religion'],
        es: ['mujer con velo', 'musulmana', 'modestia', 'religión'],
      },
    },
    {
      id: 263,
      emoji: '🤵',
      keywords: {
        en: ['groom', 'wedding', 'marriage', 'ceremony'],
        es: ['novio', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 264,
      emoji: '🤵‍♂️',
      keywords: {
        en: ['groom', 'wedding', 'marriage', 'ceremony'],
        es: ['novio', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 265,
      emoji: '🤵‍♀️',
      keywords: {
        en: ['bride', 'wedding', 'marriage', 'ceremony'],
        es: ['novia', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 266,
      emoji: '👰',
      keywords: {
        en: ['bride', 'wedding', 'marriage', 'ceremony'],
        es: ['novia', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 267,
      emoji: '👰‍♂️',
      keywords: {
        en: ['bridegroom', 'wedding', 'marriage', 'ceremony'],
        es: ['novio', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 268,
      emoji: '👰‍♀️',
      keywords: {
        en: ['bride', 'wedding', 'marriage', 'ceremony'],
        es: ['novia', 'boda', 'matrimonio', 'ceremonia'],
      },
    },
    {
      id: 269,
      emoji: '🤰',
      keywords: {
        en: ['pregnant', 'expecting', 'motherhood', 'parenting'],
        es: ['embarazada', 'esperando bebé', 'maternidad', 'crianza'],
      },
    },
    {
      id: 270,
      emoji: '🫃',
      keywords: {
        en: ['face', 'abstract', 'expression', 'emoticon'],
        es: ['cara', 'abstracto', 'expresión', 'emoticón'],
      },
    },
    {
      id: 271,
      emoji: '🫄',
      keywords: {
        en: ['face', 'abstract', 'expression', 'emoticon'],
        es: ['cara', 'abstracto', 'expresión', 'emoticón'],
      },
    },
    {
      id: 272,
      emoji: '🤱',
      keywords: {
        en: ['breastfeeding', 'motherhood', 'nursing', 'parenting'],
        es: ['lactancia', 'maternidad', 'amamantar', 'crianza'],
      },
    },
    {
      id: 273,
      emoji: '👩‍🍼',
      keywords: {
        en: ['feeding baby', 'caregiver', 'nursing', 'parenting'],
        es: ['alimentando bebé', 'cuidadora', 'cuidado', 'crianza'],
      },
    },
    {
      id: 274,
      emoji: '👨‍🍼',
      keywords: {
        en: ['feeding baby', 'caregiver', 'nursing', 'parenting'],
        es: ['alimentando bebé', 'cuidador', 'cuidado', 'crianza'],
      },
    },
    {
      id: 275,
      emoji: '🧑‍🍼',
      keywords: {
        en: ['feeding baby', 'caregiver', 'nursing', 'parenting'],
        es: ['alimentando bebé', 'cuidador', 'cuidado', 'crianza'],
      },
    },
    {
      id: 276,
      emoji: '🧍',
      keywords: {
        en: ['standing', 'upright', 'person', 'pose'],
        es: ['de pie', 'erguido', 'persona', 'pose'],
      },
    },
    {
      id: 277,
      emoji: '🧍‍♂️',
      keywords: {
        en: ['standing', 'upright', 'person', 'pose'],
        es: ['de pie', 'erguido', 'persona', 'pose'],
      },
    },
    {
      id: 278,
      emoji: '🧍‍♀️',
      keywords: {
        en: ['standing', 'upright', 'person', 'pose'],
        es: ['de pie', 'erguida', 'persona', 'pose'],
      },
    },
    {
      id: 279,
      emoji: '🧎',
      keywords: {
        en: ['kneeling', 'respect', 'proposal', 'prayer'],
        es: ['arrodillado', 'respeto', 'propuesta', 'oración'],
      },
    },
    {
      id: 280,
      emoji: '🧎‍♂️',
      keywords: {
        en: ['kneeling', 'respect', 'proposal', 'prayer'],
        es: ['arrodillado', 'respeto', 'propuesta', 'oración'],
      },
    },
    {
      id: 281,
      emoji: '🧎‍♀️',
      keywords: {
        en: ['kneeling', 'respect', 'proposal', 'prayer'],
        es: ['arrodillada', 'respeto', 'propuesta', 'oración'],
      },
    },
    {
      id: 282,
      emoji: '💃',
      keywords: {
        en: ['dancing', 'joy', 'celebration', 'movement'],
        es: ['bailando', 'alegría', 'celebración', 'movimiento'],
      },
    },
    {
      id: 283,
      emoji: '🕺',
      keywords: {
        en: ['dancing', 'joy', 'celebration', 'movement'],
        es: ['bailando', 'alegría', 'celebración', 'movimiento'],
      },
    },
    {
      id: 284,
      emoji: '🛀',
      keywords: {
        en: ['bathing', 'clean', 'relax', 'self-care'],
        es: ['bañándose', 'limpio', 'relajación', 'autocuidado'],
      },
    },
    {
      id: 285,
      emoji: '🛌',
      keywords: {
        en: ['bed', 'rest', 'sleep', 'night'],
        es: ['cama', 'descanso', 'sueño', 'noche'],
      },
    },
    {
      id: 286,
      emoji: '🧑‍⚕️',
      keywords: {
        en: ['healthcare worker', 'doctor', 'medical', 'profession'],
        es: ['trabajador de salud', 'doctor', 'médico', 'profesión'],
      },
    },
    {
      id: 287,
      emoji: '👨‍⚕️',
      keywords: {
        en: ['male doctor', 'healthcare worker', 'medical', 'profession'],
        es: ['doctor', 'trabajador de salud', 'médico', 'profesión'],
      },
    },
    {
      id: 288,
      emoji: '👩‍⚕️',
      keywords: {
        en: ['female doctor', 'healthcare worker', 'medical', 'profession'],
        es: ['doctora', 'trabajadora de salud', 'médico', 'profesión'],
      },
    },
    {
      id: 289,
      emoji: '🧑‍🎓',
      keywords: {
        en: ['student', 'graduation', 'learning', 'education'],
        es: ['estudiante', 'graduación', 'aprendizaje', 'educación'],
      },
    },
    {
      id: 290,
      emoji: '👨‍🎓',
      keywords: {
        en: ['male student', 'graduation', 'learning', 'education'],
        es: ['estudiante hombre', 'graduación', 'aprendizaje', 'educación'],
      },
    },
    {
      id: 291,
      emoji: '👩‍🎓',
      keywords: {
        en: ['female student', 'graduation', 'learning', 'education'],
        es: ['estudiante mujer', 'graduación', 'aprendizaje', 'educación'],
      },
    },
    {
      id: 292,
      emoji: '🧑‍🏫',
      keywords: {
        en: ['teacher', 'educator', 'teaching', 'education'],
        es: ['profesor', 'educador', 'enseñanza', 'educación'],
      },
    },
    {
      id: 293,
      emoji: '👨‍🏫',
      keywords: {
        en: ['male teacher', 'educator', 'teaching', 'education'],
        es: ['profesor', 'educador', 'enseñanza', 'educación'],
      },
    },
    {
      id: 294,
      emoji: '👩‍🏫',
      keywords: {
        en: ['female teacher', 'educator', 'teaching', 'education'],
        es: ['profesora', 'educadora', 'enseñanza', 'educación'],
      },
    },
    {
      id: 295,
      emoji: '🧑‍⚖️',
      keywords: {
        en: ['judge', 'legal', 'law', 'justice'],
        es: ['juez', 'legal', 'ley', 'justicia'],
      },
    },
    {
      id: 296,
      emoji: '👨‍⚖️',
      keywords: {
        en: ['male judge', 'legal', 'law', 'justice'],
        es: ['juez', 'legal', 'ley', 'justicia'],
      },
    },
    {
      id: 297,
      emoji: '👩‍⚖️',
      keywords: {
        en: ['female judge', 'legal', 'law', 'justice'],
        es: ['jueza', 'legal', 'ley', 'justicia'],
      },
    },
    {
      id: 298,
      emoji: '🧑‍🌾',
      keywords: {
        en: ['farmer', 'agriculture', 'crop', 'rural'],
        es: ['agricultor', 'agricultura', 'cultivo', 'rural'],
      },
    },
    {
      id: 299,
      emoji: '👨‍🌾',
      keywords: {
        en: ['male farmer', 'agriculture', 'crop', 'rural'],
        es: ['agricultor', 'agricultura', 'cultivo', 'rural'],
      },
    },
    {
      id: 300,
      emoji: '👩‍🌾',
      keywords: {
        en: ['female farmer', 'agriculture', 'crop', 'rural'],
        es: ['agricultora', 'agricultura', 'cultivo', 'rural'],
      },
    },
    {
      id: 301,
      emoji: '🧑‍🍳',
      keywords: {
        en: ['chef', 'cooking', 'culinary', 'kitchen'],
        es: ['chef', 'cocina', 'culinario', 'cocina'],
      },
    },
    {
      id: 302,
      emoji: '👨‍🍳',
      keywords: {
        en: ['male chef', 'cooking', 'culinary', 'kitchen'],
        es: ['chef hombre', 'cocina', 'culinario', 'cocina'],
      },
    },
    {
      id: 303,
      emoji: '👩‍🍳',
      keywords: {
        en: ['female chef', 'cooking', 'culinary', 'kitchen'],
        es: ['chef mujer', 'cocina', 'culinario', 'cocina'],
      },
    },
    {
      id: 304,
      emoji: '🧑‍🔧',
      keywords: {
        en: ['mechanic', 'repair', 'tools', 'fixing'],
        es: ['mecánico', 'reparación', 'herramientas', 'arreglo'],
      },
    },
    {
      id: 305,
      emoji: '👨‍🔧',
      keywords: {
        en: ['male mechanic', 'repair', 'tools', 'fixing'],
        es: ['mecánico', 'reparación', 'herramientas', 'arreglo'],
      },
    },
    {
      id: 306,
      emoji: '👩‍🔧',
      keywords: {
        en: ['female mechanic', 'repair', 'tools', 'fixing'],
        es: ['mecánica', 'reparación', 'herramientas', 'arreglo'],
      },
    },
    {
      id: 307,
      emoji: '🧑‍🏭',
      keywords: {
        en: ['factory worker', 'industry', 'manufacturing', 'production'],
        es: ['trabajador de fábrica', 'industria', 'manufactura', 'producción'],
      },
    },
    {
      id: 308,
      emoji: '👨‍🏭',
      keywords: {
        en: ['male factory worker', 'industry', 'manufacturing', 'production'],
        es: ['trabajador de fábrica', 'industria', 'manufactura', 'producción'],
      },
    },
    {
      id: 309,
      emoji: '👩‍🏭',
      keywords: {
        en: ['female factory worker', 'industry', 'manufacturing', 'production'],
        es: ['trabajadora de fábrica', 'industria', 'manufactura', 'producción'],
      },
    },
    {
      id: 310,
      emoji: '🧑‍💼',
      keywords: {
        en: ['office worker', 'business', 'professional', 'work'],
        es: ['oficinista', 'negocios', 'profesional', 'trabajo'],
      },
    },
    {
      id: 311,
      emoji: '👨‍💼',
      keywords: {
        en: ['male office worker', 'business', 'professional', 'work'],
        es: ['oficinista hombre', 'negocios', 'profesional', 'trabajo'],
      },
    },
    {
      id: 312,
      emoji: '👩‍💼',
      keywords: {
        en: ['female office worker', 'business', 'professional', 'work'],
        es: ['oficinista mujer', 'negocios', 'profesional', 'trabajo'],
      },
    },
    {
      id: 313,
      emoji: '🧑‍🔬',
      keywords: {
        en: ['scientist', 'research', 'lab', 'experiment'],
        es: ['científico', 'investigación', 'laboratorio', 'experimento'],
      },
    },
    {
      id: 314,
      emoji: '👨‍🔬',
      keywords: {
        en: ['male scientist', 'research', 'lab', 'experiment'],
        es: ['científico', 'investigación', 'laboratorio', 'experimento'],
      },
    },
    {
      id: 315,
      emoji: '👩‍🔬',
      keywords: {
        en: ['female scientist', 'research', 'lab', 'experiment'],
        es: ['científica', 'investigación', 'laboratorio', 'experimento'],
      },
    },
    {
      id: 316,
      emoji: '🧑‍💻',
      keywords: {
        en: ['technologist', 'technology', 'computer', 'coding'],
        es: ['tecnólogo', 'tecnología', 'computador', 'programación'],
      },
    },
    {
      id: 317,
      emoji: '👨‍💻',
      keywords: {
        en: ['male technologist', 'technology', 'computer', 'coding'],
        es: ['tecnólogo', 'tecnología', 'computador', 'programación'],
      },
    },
    {
      id: 318,
      emoji: '👩‍💻',
      keywords: {
        en: ['female technologist', 'technology', 'computer', 'coding'],
        es: ['tecnóloga', 'tecnología', 'computador', 'programación'],
      },
    },
    {
      id: 319,
      emoji: '🧑‍🎤',
      keywords: {
        en: ['singer', 'performer', 'music', 'entertainment'],
        es: ['cantante', 'artista', 'música', 'entretenimiento'],
      },
    },
    {
      id: 320,
      emoji: '👨‍🎤',
      keywords: {
        en: ['male singer', 'performer', 'music', 'entertainment'],
        es: ['cantante hombre', 'artista', 'música', 'entretenimiento'],
      },
    },
    {
      id: 321,
      emoji: '👩‍🎤',
      keywords: {
        en: ['female singer', 'performer', 'music', 'entertainment'],
        es: ['cantante mujer', 'artista', 'música', 'entretenimiento'],
      },
    },
    {
      id: 322,
      emoji: '🧑‍🎨',
      keywords: {
        en: ['artist', 'painting', 'creative', 'craft'],
        es: ['artista', 'pintura', 'creativo', 'manualidad'],
      },
    },
    {
      id: 323,
      emoji: '👨‍🎨',
      keywords: {
        en: ['male artist', 'painting', 'creative', 'craft'],
        es: ['artista hombre', 'pintura', 'creativo', 'manualidad'],
      },
    },
    {
      id: 324,
      emoji: '👩‍🎨',
      keywords: {
        en: ['female artist', 'painting', 'creative', 'craft'],
        es: ['artista mujer', 'pintura', 'creativo', 'manualidad'],
      },
    },
    {
      id: 325,
      emoji: '🧑‍✈️',
      keywords: {
        en: ['pilot', 'flying', 'aviation', 'travel'],
        es: ['piloto', 'volar', 'aviación', 'viaje'],
      },
    },
    {
      id: 326,
      emoji: '👨‍✈️',
      keywords: {
        en: ['male pilot', 'flying', 'aviation', 'travel'],
        es: ['piloto hombre', 'volar', 'aviación', 'viaje'],
      },
    },
    {
      id: 327,
      emoji: '👩‍✈️',
      keywords: {
        en: ['female pilot', 'flying', 'aviation', 'travel'],
        es: ['piloto mujer', 'volar', 'aviación', 'viaje'],
      },
    },
    {
      id: 328,
      emoji: '🧑‍🚀',
      keywords: {
        en: ['astronaut', 'space', 'exploration', 'science'],
        es: ['astronauta', 'espacio', 'exploración', 'ciencia'],
      },
    },
    {
      id: 329,
      emoji: '👨‍🚀',
      keywords: {
        en: ['male astronaut', 'space', 'exploration', 'science'],
        es: ['astronauta hombre', 'espacio', 'exploración', 'ciencia'],
      },
    },
    {
      id: 330,
      emoji: '👩‍🚀',
      keywords: {
        en: ['female astronaut', 'space', 'exploration', 'science'],
        es: ['astronauta mujer', 'espacio', 'exploración', 'ciencia'],
      },
    },
    {
      id: 331,
      emoji: '🧑‍🚒',
      keywords: {
        en: ['firefighter', 'rescue', 'emergency', 'safety'],
        es: ['bombero', 'rescate', 'emergencia', 'seguridad'],
      },
    },
    {
      id: 332,
      emoji: '👨‍🚒',
      keywords: {
        en: ['male firefighter', 'rescue', 'emergency', 'safety'],
        es: ['bombero', 'rescate', 'emergencia', 'seguridad'],
      },
    },
    {
      id: 333,
      emoji: '👩‍🚒',
      keywords: {
        en: ['female firefighter', 'rescue', 'emergency', 'safety'],
        es: ['bombera', 'rescate', 'emergencia', 'seguridad'],
      },
    },
    {
      id: 334,
      emoji: '👮',
      keywords: {
        en: ['police officer', 'law enforcement', 'security', 'uniform'],
        es: ['policía', 'autoridad', 'seguridad', 'uniforme'],
      },
    },
    {
      id: 335,
      emoji: '👮‍♂️',
      keywords: {
        en: ['male police officer', 'law enforcement', 'security', 'uniform'],
        es: ['policía hombre', 'autoridad', 'seguridad', 'uniforme'],
      },
    },
    {
      id: 336,
      emoji: '👮‍♀️',
      keywords: {
        en: ['female police officer', 'law enforcement', 'security', 'uniform'],
        es: ['policía mujer', 'autoridad', 'seguridad', 'uniforme'],
      },
    },
    {
      id: 337,
      emoji: '🕵️',
      keywords: {
        en: ['detective', 'investigation', 'mystery', 'spy'],
        es: ['detective', 'investigación', 'misterio', 'espía'],
      },
    },
    {
      id: 338,
      emoji: '🕵️‍♂️',
      keywords: {
        en: ['male detective', 'investigation', 'mystery', 'spy'],
        es: ['detective hombre', 'investigación', 'misterio', 'espía'],
      },
    },
    {
      id: 339,
      emoji: '🕵️‍♀️',
      keywords: {
        en: ['female detective', 'investigation', 'mystery', 'spy'],
        es: ['detective mujer', 'investigación', 'misterio', 'espía'],
      },
    },
    {
      id: 340,
      emoji: '💂',
      keywords: {
        en: ['guard', 'British', 'royal', 'uniform'],
        es: ['guardia', 'británico', 'real', 'uniforme'],
      },
    },
    {
      id: 341,
      emoji: '💂‍♂️',
      keywords: {
        en: ['male guard', 'British', 'royal', 'uniform'],
        es: ['guardia hombre', 'británico', 'real', 'uniforme'],
      },
    },
    {
      id: 342,
      emoji: '💂‍♀️',
      keywords: {
        en: ['female guard', 'British', 'royal', 'uniform'],
        es: ['guardia mujer', 'británico', 'real', 'uniforme'],
      },
    },
    {
      id: 343,
      emoji: '🥷',
      keywords: {
        en: ['ninja', 'stealth', 'martial arts', 'Japanese'],
        es: ['ninja', 'sigilo', 'artes marciales', 'japonés'],
      },
    },
    {
      id: 344,
      emoji: '👷',
      keywords: {
        en: ['construction worker', 'builder', 'labor', 'hard hat'],
        es: ['trabajador de construcción', 'constructor', 'labor', 'casco'],
      },
    },
    {
      id: 345,
      emoji: '👷‍♂️',
      keywords: {
        en: ['male construction worker', 'builder', 'labor', 'hard hat'],
        es: ['constructor', 'trabajador de construcción', 'labor', 'casco'],
      },
    },
    {
      id: 346,
      emoji: '👷‍♀️',
      keywords: {
        en: ['female construction worker', 'builder', 'labor', 'hard hat'],
        es: ['constructora', 'trabajadora de construcción', 'labor', 'casco'],
      },
    },
    {
      id: 347,
      emoji: '👼',
      keywords: {
        en: ['angel', 'innocent', 'heavenly', 'celestial'],
        es: ['ángel', 'inocente', 'celestial', 'divino'],
      },
    },
    {
      id: 348,
      emoji: '🎅',
      keywords: {
        en: ['Santa Claus', 'Christmas', 'holiday', 'gifts'],
        es: ['Santa Claus', 'Navidad', 'festividad', 'regalos'],
      },
    },
    {
      id: 349,
      emoji: '🤶',
      keywords: {
        en: ['Mrs. Claus', 'Christmas', 'holiday', 'gifts'],
        es: ['señora Claus', 'Navidad', 'festividad', 'regalos'],
      },
    },
    {
      id: 350,
      emoji: '🧑‍🎄',
      keywords: {
        en: ['Christmas tree', 'holiday', 'celebration', 'festive'],
        es: ['árbol de Navidad', 'festividad', 'celebración', 'festivo'],
      },
    },
    {
      id: 351,
      emoji: '🦸',
      keywords: {
        en: ['superhero', 'power', 'cape', 'comic'],
        es: ['superhéroe', 'poder', 'capa', 'cómic'],
      },
    },
    {
      id: 352,
      emoji: '🦸‍♂️',
      keywords: {
        en: ['male superhero', 'power', 'cape', 'comic'],
        es: ['superhéroe hombre', 'poder', 'capa', 'cómic'],
      },
    },
    {
      id: 353,
      emoji: '🦸‍♀️',
      keywords: {
        en: ['female superhero', 'power', 'cape', 'comic'],
        es: ['superheroína', 'poder', 'capa', 'cómic'],
      },
    },
    {
      id: 354,
      emoji: '🦹',
      keywords: {
        en: ['supervillain', 'evil', 'antagonist', 'comic'],
        es: ['supervillano', 'malvado', 'antagonista', 'cómic'],
      },
    },
    {
      id: 355,
      emoji: '🦹‍♂️',
      keywords: {
        en: ['male supervillain', 'evil', 'antagonist', 'comic'],
        es: ['supervillano hombre', 'malvado', 'antagonista', 'cómic'],
      },
    },
    {
      id: 356,
      emoji: '🦹‍♀️',
      keywords: {
        en: ['female supervillain', 'evil', 'antagonist', 'comic'],
        es: ['supervillana', 'malvada', 'antagonista', 'cómic'],
      },
    },
    {
      id: 357,
      emoji: '🧙',
      keywords: {
        en: ['mage', 'wizard', 'magic', 'fantasy'],
        es: ['mago', 'hechicero', 'magia', 'fantasía'],
      },
    },
    {
      id: 358,
      emoji: '🧙‍♂️',
      keywords: {
        en: ['male mage', 'wizard', 'magic', 'fantasy'],
        es: ['mago', 'hechicero', 'magia', 'fantasía'],
      },
    },
    {
      id: 359,
      emoji: '🧙‍♀️',
      keywords: {
        en: ['female mage', 'wizard', 'magic', 'fantasy'],
        es: ['maga', 'hechicera', 'magia', 'fantasía'],
      },
    },
    {
      id: 360,
      emoji: '🧚',
      keywords: {
        en: ['fairy', 'magic', 'wings', 'fantasy'],
        es: ['hada', 'magia', 'alas', 'fantasía'],
      },
    },
    {
      id: 361,
      emoji: '🧚‍♂️',
      keywords: {
        en: ['male fairy', 'magic', 'wings', 'fantasy'],
        es: ['hada hombre', 'magia', 'alas', 'fantasía'],
      },
    },
    {
      id: 362,
      emoji: '🧚‍♀️',
      keywords: {
        en: ['female fairy', 'magic', 'wings', 'fantasy'],
        es: ['hada mujer', 'magia', 'alas', 'fantasía'],
      },
    },
    {
      id: 363,
      emoji: '🧛',
      keywords: {
        en: ['vampire', 'fangs', 'dark', 'undead'],
        es: ['vampiro', 'colmillos', 'oscuro', 'no muerto'],
      },
    },
    {
      id: 364,
      emoji: '🧛‍♂️',
      keywords: {
        en: ['male vampire', 'fangs', 'dark', 'undead'],
        es: ['vampiro hombre', 'colmillos', 'oscuro', 'no muerto'],
      },
    },
    {
      id: 365,
      emoji: '🧛‍♀️',
      keywords: {
        en: ['female vampire', 'fangs', 'dark', 'undead'],
        es: ['vampira', 'colmillos', 'oscuro', 'no muerto'],
      },
    },
    {
      id: 366,
      emoji: '🧜',
      keywords: {
        en: ['mermaid', 'ocean', 'mythical', 'fantasy'],
        es: ['sirena', 'océano', 'mítico', 'fantasía'],
      },
    },
    {
      id: 367,
      emoji: '🧜‍♂️',
      keywords: {
        en: ['male mermaid', 'ocean', 'mythical', 'fantasy'],
        es: ['tritón', 'océano', 'mítico', 'fantasía'],
      },
    },
    {
      id: 368,
      emoji: '🧜‍♀️',
      keywords: {
        en: ['female mermaid', 'ocean', 'mythical', 'fantasy'],
        es: ['sirena', 'océano', 'mítico', 'fantasía'],
      },
    },
    {
      id: 369,
      emoji: '🧝',
      keywords: {
        en: ['elf', 'mythical', 'fantasy', 'magical'],
        es: ['elfo', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 370,
      emoji: '🧝‍♂️',
      keywords: {
        en: ['male elf', 'mythical', 'fantasy', 'magical'],
        es: ['elfo hombre', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 371,
      emoji: '🧝‍♀️',
      keywords: {
        en: ['female elf', 'mythical', 'fantasy', 'magical'],
        es: ['elfa', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 372,
      emoji: '🧞',
      keywords: {
        en: ['genie', 'magic', 'wishes', 'fantasy'],
        es: ['genio', 'magia', 'deseos', 'fantasía'],
      },
    },
    {
      id: 373,
      emoji: '🧞‍♂️',
      keywords: {
        en: ['male genie', 'magic', 'wishes', 'fantasy'],
        es: ['genio hombre', 'magia', 'deseos', 'fantasía'],
      },
    },
    {
      id: 374,
      emoji: '🧞‍♀️',
      keywords: {
        en: ['female genie', 'magic', 'wishes', 'fantasy'],
        es: ['genia', 'magia', 'deseos', 'fantasía'],
      },
    },
    {
      id: 375,
      emoji: '🧟',
      keywords: {
        en: ['zombie', 'undead', 'horror', 'monster'],
        es: ['zombi', 'no muerto', 'terror', 'monstruo'],
      },
    },
    {
      id: 376,
      emoji: '🧟‍♂️',
      keywords: {
        en: ['male zombie', 'undead', 'horror', 'monster'],
        es: ['zombi hombre', 'no muerto', 'terror', 'monstruo'],
      },
    },
    {
      id: 377,
      emoji: '🧟‍♀️',
      keywords: {
        en: ['female zombie', 'undead', 'horror', 'monster'],
        es: ['zombi mujer', 'no muerto', 'terror', 'monstruo'],
      },
    },
    {
      id: 378,
      emoji: '🧌',
      keywords: {
        en: ['person in steamy room', 'sauna', 'relaxation', 'wellness'],
        es: ['persona en sauna', 'sauna', 'relajación', 'bienestar'],
      },
    },
    {
      id: 379,
      emoji: '💆',
      keywords: {
        en: ['person getting massage', 'relaxation', 'spa', 'stress relief'],
        es: ['persona recibiendo masaje', 'relajación', 'spa', 'alivio del estrés'],
      },
    },
    {
      id: 380,
      emoji: '💆‍♂️',
      keywords: {
        en: ['man getting massage', 'relaxation', 'spa', 'stress relief'],
        es: ['hombre recibiendo masaje', 'relajación', 'spa', 'alivio del estrés'],
      },
    },
    {
      id: 381,
      emoji: '💆‍♀️',
      keywords: {
        en: ['woman getting massage', 'relaxation', 'spa', 'stress relief'],
        es: ['mujer recibiendo masaje', 'relajación', 'spa', 'alivio del estrés'],
      },
    },
    {
      id: 382,
      emoji: '🧑‍🦯',
      keywords: {
        en: ['person with white cane', 'blind', 'visually impaired', 'disability'],
        es: ['persona con bastón blanco', 'ciego', 'discapacidad visual', 'discapacidad'],
      },
    },
    {
      id: 383,
      emoji: '👨‍🦯',
      keywords: {
        en: ['man with white cane', 'blind', 'visually impaired', 'disability'],
        es: ['hombre con bastón blanco', 'ciego', 'discapacidad visual', 'discapacidad'],
      },
    },
    {
      id: 384,
      emoji: '👩‍🦯',
      keywords: {
        en: ['woman with white cane', 'blind', 'visually impaired'],
        es: ['mujer con bastón blanco', 'ciega', 'discapacidad visual'],
      },
    },
    {
      id: 385,
      emoji: '🧑‍🤝‍🧑',
      keywords: {
        en: ['people holding hands', 'unity', 'togetherness', 'connection'],
        es: ['personas tomadas de la mano', 'unidad', 'unión', 'conexión'],
      },
    },
    {
      id: 386,
      emoji: '👭',
      keywords: {
        en: ['women holding hands', 'friendship', 'support', 'unity'],
        es: ['mujeres tomadas de la mano', 'amistad', 'apoyo', 'unidad'],
      },
    },
    {
      id: 387,
      emoji: '👫',
      keywords: {
        en: ['man and woman holding hands', 'couple', 'relationship', 'love'],
        es: ['hombre y mujer tomados de la mano', 'pareja', 'relación', 'amor'],
      },
    },
    {
      id: 388,
      emoji: '👬',
      keywords: {
        en: ['men holding hands', 'friendship', 'support', 'unity'],
        es: ['hombres tomados de la mano', 'amistad', 'apoyo', 'unidad'],
      },
    },
    {
      id: 389,
      emoji: '🧑‍🦼',
      keywords: {
        en: ['person in wheelchair', 'accessibility', 'disability', 'mobility'],
        es: ['persona en silla de ruedas', 'accesibilidad', 'discapacidad', 'movilidad'],
      },
    },
    {
      id: 390,
      emoji: '👨‍🦼',
      keywords: {
        en: ['man in wheelchair', 'accessibility', 'disability', 'mobility'],
        es: ['hombre en silla de ruedas', 'accesibilidad', 'discapacidad', 'movilidad'],
      },
    },
    {
      id: 391,
      emoji: '👩‍🦼',
      keywords: {
        en: ['woman in wheelchair', 'accessibility', 'disability', 'mobility'],
        es: ['mujer en silla de ruedas', 'accesibilidad', 'discapacidad', 'movilidad'],
      },
    },
    {
      id: 392,
      emoji: '🧑‍🦽',
      keywords: {
        en: ['person with white cane', 'blind', 'visually impaired', 'disability'],
        es: ['persona con bastón blanco', 'ciego', 'discapacidad visual', 'discapacidad'],
      },
    },
    {
      id: 393,
      emoji: '👨‍🦽',
      keywords: {
        en: ['man with white cane', 'blind', 'visually impaired', 'disability'],
        es: ['hombre con bastón blanco', 'ciego', 'discapacidad visual', 'discapacidad'],
      },
    },
    {
      id: 394,
      emoji: '👩‍🦽',
      keywords: {
        en: ['woman with white cane', 'blind', 'visually impaired', 'disability'],
        es: ['mujer con bastón blanco', 'ciega', 'discapacidad visual', 'discapacidad'],
      },
    },
    {
      id: 395,
      emoji: '💇',
      keywords: {
        en: ['haircut', 'hairstyle', 'salon', 'beauty'],
        es: ['corte de cabello', 'peinado', 'salón', 'belleza'],
      },
    },
    {
      id: 396,
      emoji: '💇‍♂️',
      keywords: {
        en: ['man getting haircut', 'hairstyle', 'barber', 'salon'],
        es: ['hombre cortándose el cabello', 'peinado', 'barbero', 'salón'],
      },
    },
    {
      id: 397,
      emoji: '💇‍♀️',
      keywords: {
        en: ['woman getting haircut', 'hairstyle', 'salon', 'beauty'],
        es: ['mujer cortándose el cabello', 'peinado', 'salón', 'belleza'],
      },
    },
    {
      id: 398,
      emoji: '🕴️',
      keywords: {
        en: ['man in suit levitating', 'levitation', 'formal', 'business'],
        es: ['hombre con traje levitando', 'levitación', 'formal', 'negocios'],
      },
    },
    {
      id: 399,
      emoji: '👯',
      keywords: {
        en: ['people with bunny ears', 'dancing', 'celebration', 'party'],
        es: ['personas con orejas de conejo', 'bailando', 'celebración', 'fiesta'],
      },
    },

    {
      id: 400,
      emoji: '👯‍♂️',
      keywords: {
        en: ['men with bunny ears', 'dancing', 'celebration', 'party'],
        es: ['hombres con orejas de conejo', 'bailando', 'celebración', 'fiesta'],
      },
    },
    {
      id: 401,
      emoji: '👯‍♀️',
      keywords: {
        en: ['women with bunny ears', 'dancing', 'celebration', 'party'],
        es: ['mujeres con orejas de conejo', 'bailando', 'celebración', 'fiesta'],
      },
    },
    {
      id: 402,
      emoji: '🧖',
      keywords: {
        en: ['person in steamy room', 'sauna', 'relaxation', 'wellness'],
        es: ['persona en sauna', 'sauna', 'relajación', 'bienestar'],
      },
    },
    {
      id: 403,
      emoji: '🧖‍♂️',
      keywords: {
        en: ['man in steamy room', 'sauna', 'relaxation', 'wellness'],
        es: ['hombre en sauna', 'sauna', 'relajación', 'bienestar'],
      },
    },
    {
      id: 404,
      emoji: '🧖‍♀️',
      keywords: {
        en: ['woman in steamy room', 'sauna', 'relaxation', 'wellness'],
        es: ['mujer en sauna', 'sauna', 'relajación', 'bienestar'],
      },
    },
    {
      id: 405,
      emoji: '🧘',
      keywords: {
        en: ['person in lotus position', 'meditation', 'calm', 'mindfulness'],
        es: ['persona en posición de loto', 'meditación', 'calma', 'atención plena'],
      },
    },
    {
      id: 406,
      emoji: '🧘‍♂️',
      keywords: {
        en: ['man in lotus position', 'meditation', 'calm', 'mindfulness'],
        es: ['hombre en posición de loto', 'meditación', 'calma', 'atención plena'],
      },
    },
    {
      id: 407,
      emoji: '🧘‍♀️',
      keywords: {
        en: ['woman in lotus position', 'meditation', 'calm', 'mindfulness'],
        es: ['mujer en posición de loto', 'meditación', 'calma', 'atención plena'],
      },
    },
    {
      id: 408,
      emoji: '👪',
      keywords: {
        en: ['family', 'together', 'parents', 'children'],
        es: ['familia', 'juntos', 'padres', 'niños'],
      },
    },
    {
      id: 409,
      emoji: '👨‍👩‍👦',
      keywords: {
        en: ['family: man, woman, boy', 'parents', 'children', 'together'],
        es: ['familia: hombre, mujer, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 410,
      emoji: '👨‍👩‍👧',
      keywords: {
        en: ['family: man, woman, girl', 'parents', 'children', 'together'],
        es: ['familia: hombre, mujer, niña', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 411,
      emoji: '👨‍👩‍👧‍👦',
      keywords: {
        en: ['family: man, woman, girl, boy', 'parents', 'children', 'together'],
        es: ['familia: hombre, mujer, niña, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 412,
      emoji: '👨‍👩‍👦‍👦',
      keywords: {
        en: ['family: man, woman, two boys', 'parents', 'children', 'together'],
        es: ['familia: hombre, mujer, dos niños', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 413,
      emoji: '👨‍👩‍👧‍👧',
      keywords: {
        en: ['family: man, woman, two girls', 'parents', 'children', 'together'],
        es: ['familia: hombre, mujer, dos niñas', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 414,
      emoji: '👨‍👨‍👦',
      keywords: {
        en: ['family: man, man, boy', 'parents', 'children', 'together'],
        es: ['familia: hombre, hombre, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 415,
      emoji: '👨‍👨‍👧',
      keywords: {
        en: ['family: man, man, girl', 'parents', 'children', 'together'],
        es: ['familia: hombre, hombre, niña', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 416,
      emoji: '👨‍👨‍👧‍👦',
      keywords: {
        en: ['family: man, man, girl, boy', 'parents', 'children', 'together'],
        es: ['familia: hombre, hombre, niña, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 417,
      emoji: '👨‍👨‍👦‍👦',
      keywords: {
        en: ['family: man, man, two boys', 'parents', 'children', 'together'],
        es: ['familia: hombre, hombre, dos niños', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 418,
      emoji: '👨‍👨‍👧‍👧',
      keywords: {
        en: ['family: man, man, two girls', 'parents', 'children', 'together'],
        es: ['familia: hombre, hombre, dos niñas', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 419,
      emoji: '👩‍👩‍👦',
      keywords: {
        en: ['family: woman, woman, boy', 'parents', 'children', 'together'],
        es: ['familia: mujer, mujer, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 420,
      emoji: '👩‍👩‍👧',
      keywords: {
        en: ['family: woman, woman, girl', 'parents', 'children', 'together'],
        es: ['familia: mujer, mujer, niña', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 421,
      emoji: '👩‍👩‍👧‍👦',
      keywords: {
        en: ['family: woman, woman, girl, boy', 'parents', 'children', 'together'],
        es: ['familia: mujer, mujer, niña, niño', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 422,
      emoji: '👩‍👩‍👦‍👦',
      keywords: {
        en: ['family: woman, woman, two boys', 'parents', 'children', 'together'],
        es: ['familia: mujer, mujer, dos niños', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 423,
      emoji: '👩‍👩‍👧‍👧',
      keywords: {
        en: ['family: woman, woman, two girls', 'parents', 'children', 'together'],
        es: ['familia: mujer, mujer, dos niñas', 'padres', 'niños', 'juntos'],
      },
    },
    {
      id: 424,
      emoji: '👨‍👦',
      keywords: {
        en: ['family: man, boy', 'father', 'son', 'together'],
        es: ['familia: hombre, niño', 'padre', 'hijo', 'juntos'],
      },
    },
    {
      id: 425,
      emoji: '👨‍👦‍👦',
      keywords: {
        en: ['family: man, two boys', 'father', 'sons', 'together'],
        es: ['familia: hombre, dos niños', 'padre', 'hijos', 'juntos'],
      },
    },
    {
      id: 426,
      emoji: '👨‍👧',
      keywords: {
        en: ['family: man, girl', 'father', 'daughter', 'together'],
        es: ['familia: hombre, niña', 'padre', 'hija', 'juntos'],
      },
    },
    {
      id: 427,
      emoji: '👨‍👧‍👦',
      keywords: {
        en: ['family: man, girl, boy', 'father', 'children', 'together'],
        es: ['familia: hombre, niña, niño', 'padre', 'hijos', 'juntos'],
      },
    },
    {
      id: 428,
      emoji: '👨‍👧‍👧',
      keywords: {
        en: ['family: man, girl, girl', 'father', 'children', 'together'],
        es: ['familia: hombre, niña, niña', 'padre', 'hijas', 'juntos'],
      },
    },
    {
      id: 429,
      emoji: '👩‍👦',
      keywords: {
        en: ['family: woman, boy', 'mother', 'son', 'together'],
        es: ['familia: mujer, niño', 'madre', 'hijo', 'juntos'],
      },
    },
    {
      id: 430,
      emoji: '👩‍👦‍👦',
      keywords: {
        en: ['family: woman, two boys', 'mother', 'sons', 'together'],
        es: ['familia: mujer, dos niños', 'madre', 'hijos', 'juntos'],
      },
    },
    {
      id: 431,
      emoji: '👩‍👧',
      keywords: {
        en: ['family: woman, girl', 'mother', 'daughter', 'together'],
        es: ['familia: mujer, niña', 'madre', 'hija', 'juntos'],
      },
    },
    {
      id: 432,
      emoji: '👩‍👧‍👦',
      keywords: {
        en: ['family: woman, girl, boy', 'mother', 'children', 'together'],
        es: ['familia: mujer, niña, niño', 'madre', 'hijos', 'juntos'],
      },
    },
    {
      id: 433,
      emoji: '👩‍👧‍👧',
      keywords: {
        en: ['family: woman, girl, girl', 'mother', 'children', 'together'],
        es: ['familia: mujer, niña, niña', 'madre', 'hijas', 'juntos'],
      },
    },
    {
      id: 434,
      emoji: '💏',
      keywords: {
        en: ['kiss', 'couple', 'relationship', 'love'],
        es: ['beso', 'pareja', 'relación', 'amor'],
      },
    },
    {
      id: 435,
      emoji: '👩‍❤️‍💋‍👨',
      keywords: {
        en: ['couple with heart', 'relationship', 'love', 'affection'],
        es: ['pareja con corazón', 'relación', 'amor', 'afecto'],
      },
    },
    {
      id: 436,
      emoji: '👨‍❤️‍💋‍👨',
      keywords: {
        en: ['couple with heart', 'relationship', 'love', 'affection'],
        es: ['pareja con corazón', 'relación', 'amor', 'afecto'],
      },
    },
    {
      id: 437,
      emoji: '👩‍❤️‍💋‍👩',
      keywords: {
        en: ['couple with heart', 'relationship', 'love', 'affection'],
        es: ['pareja con corazón', 'relación', 'amor', 'afecto'],
      },
    },
    {
      id: 438,
      emoji: '💑',
      keywords: {
        en: ['couple', 'relationship', 'love', 'partnership'],
        es: ['pareja', 'relación', 'amor', 'compañerismo'],
      },
    },
    {
      id: 439,
      emoji: '👩‍❤️‍👨',
      keywords: {
        en: ['couple', 'relationship', 'love', 'partnership'],
        es: ['pareja', 'relación', 'amor', 'compañerismo'],
      },
    },
    {
      id: 440,
      emoji: '👨‍❤️‍👨',
      keywords: {
        en: ['couple', 'relationship', 'love', 'partnership'],
        es: ['pareja', 'relación', 'amor', 'compañerismo'],
      },
    },
    {
      id: 441,
      emoji: '👩‍❤️‍👩',
      keywords: {
        en: ['couple', 'relationship', 'love', 'partnership'],
        es: ['pareja', 'relación', 'amor', 'compañerismo'],
      },
    },
    {
      id: 442,
      emoji: '💘',
      keywords: {
        en: ['heart with arrow', 'romance', 'love', 'passion'],
        es: ['corazón con flecha', 'romance', 'amor', 'pasión'],
      },
    },
    {
      id: 443,
      emoji: '💝',
      keywords: {
        en: ['heart with ribbon', 'gift', 'love', 'surprise'],
        es: ['corazón con lazo', 'regalo', 'amor', 'sorpresa'],
      },
    },
    {
      id: 444,
      emoji: '💖',
      keywords: {
        en: ['sparkling heart', 'love', 'romance', 'affection'],
        es: ['corazón brillante', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 445,
      emoji: '💗',
      keywords: {
        en: ['growing heart', 'love', 'affection', 'romance'],
        es: ['corazón creciente', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 446,
      emoji: '💓',
      keywords: {
        en: ['beating heart', 'heartbeat', 'love', 'affection'],
        es: ['corazón latiendo', 'latido', 'amor', 'afecto'],
      },
    },
    {
      id: 447,
      emoji: '💞',
      keywords: {
        en: ['revolving hearts', 'love', 'romance', 'affection'],
        es: ['corazones girando', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 448,
      emoji: '💕',
      keywords: {
        en: ['two hearts', 'love', 'romance', 'affection'],
        es: ['dos corazones', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 449,
      emoji: '💟',
      keywords: {
        en: ['heart decoration', 'love', 'romance', 'affection'],
        es: ['decoración de corazón', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 450,
      emoji: '❣️',
      keywords: {
        en: ['heart exclamation', 'love', 'romance', 'affection'],
        es: ['exclamación de corazón', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 451,
      emoji: '💔',
      keywords: {
        en: ['broken heart', 'sad', 'unhappy', 'heartbreak'],
        es: ['corazón roto', 'triste', 'infeliz', 'desamor'],
      },
    },
    {
      id: 452,
      emoji: '❤️‍🔥',
      keywords: {
        en: ['heart on fire', 'passionate', 'intense love', 'burning love'],
        es: ['corazón en llamas', 'apasionado', 'amor intenso', 'amor ardiente'],
      },
    },
    {
      id: 453,
      emoji: '❤️‍🩹',
      keywords: {
        en: ['mending heart', 'healing', 'recovery', 'repair'],
        es: ['corazón sanando', 'sanación', 'recuperación', 'reparación'],
      },
    },
    {
      id: 454,
      emoji: '❤️',
      keywords: {
        en: ['red heart', 'love', 'romance', 'affection'],
        es: ['corazón rojo', 'amor', 'romance', 'afecto'],
      },
    },
    {
      id: 455,
      emoji: '🩷',
      keywords: {
        en: ['anatomical heart', 'biology', 'medical', 'organ'],
        es: ['corazón anatómico', 'biología', 'médico', 'órgano'],
      },
    },
    {
      id: 456,
      emoji: '🧡',
      keywords: {
        en: ['orange heart', 'love', 'affection', 'romance'],
        es: ['corazón naranja', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 457,
      emoji: '💛',
      keywords: {
        en: ['yellow heart', 'love', 'affection', 'romance'],
        es: ['corazón amarillo', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 458,
      emoji: '💚',
      keywords: {
        en: ['green heart', 'love', 'affection', 'romance'],
        es: ['corazón verde', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 459,
      emoji: '💙',
      keywords: {
        en: ['blue heart', 'love', 'affection', 'romance'],
        es: ['corazón azul', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 460,
      emoji: '🩵',
      keywords: {
        en: ['brown heart', 'love', 'affection', 'romance'],
        es: ['corazón marrón', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 461,
      emoji: '💜',
      keywords: {
        en: ['purple heart', 'love', 'affection', 'romance'],
        es: ['corazón morado', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 462,
      emoji: '🤎',
      keywords: {
        en: ['brown heart', 'love', 'affection', 'romance'],
        es: ['corazón marrón', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 463,
      emoji: '🖤',
      keywords: {
        en: ['black heart', 'love', 'affection', 'romance'],
        es: ['corazón negro', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 464,
      emoji: '🩶',
      keywords: {
        en: ['white heart', 'love', 'affection', 'romance'],
        es: ['corazón blanco', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 465,
      emoji: '🤍',
      keywords: {
        en: ['white heart', 'love', 'affection', 'romance'],
        es: ['corazón blanco', 'amor', 'afecto', 'romance'],
      },
    },
    {
      id: 466,
      emoji: '🧤',
      keywords: {
        en: ['gloves', 'hands'],
        es: ['guantes', 'manos'],
      },
    },
    {
      id: 467,
      emoji: '🧣',
      keywords: {
        en: ['scarf', 'winter'],
        es: ['bufanda', 'invierno'],
      },
    },
    {
      id: 468,
      emoji: '🎩',
      keywords: {
        en: ['top hat', 'gentleman'],
        es: ['sombrero de copa', 'caballero'],
      },
    },
    {
      id: 469,
      emoji: '👓',
      keywords: {
        en: ['glasses', 'spectacles'],
        es: ['gafas', 'anteojos'],
      },
    },
    {
      id: 470,
      emoji: '🕶️',
      keywords: {
        en: ['sunglasses', 'shades'],
        es: ['gafas de sol', 'lentes oscuros'],
      },
    },
    {
      id: 471,
      emoji: '👔',
      keywords: {
        en: ['necktie', 'formal'],
        es: ['corbata', 'formal'],
      },
    },
    {
      id: 472,
      emoji: '👕',
      keywords: {
        en: ['t-shirt', 'casual'],
        es: ['camiseta', 'casual'],
      },
    },
    {
      id: 473,
      emoji: '👖',
      keywords: {
        en: ['jeans', 'pants'],
        es: ['jeans', 'pantalones'],
      },
    },
    {
      id: 474,
      emoji: '🧦',
      keywords: {
        en: ['socks', 'footwear'],
        es: ['medias', 'calzado'],
      },
    },
    {
      id: 475,
      emoji: '👟',
      keywords: {
        en: ['running shoe', 'sneaker'],
        es: ['zapato deportivo', 'tenis'],
      },
    },
    {
      id: 476,
      emoji: '👠',
      keywords: {
        en: ['high-heeled shoe', 'fashion'],
        es: ['zapato de tacón', 'moda'],
      },
    },
    {
      id: 477,
      emoji: '👡',
      keywords: {
        en: ['woman’s sandal', 'summer'],
        es: ['sandalia de mujer', 'verano'],
      },
    },
    {
      id: 478,
      emoji: '👢',
      keywords: {
        en: ['woman’s boot', 'fashion'],
        es: ['bota de mujer', 'moda'],
      },
    },
    {
      id: 479,
      emoji: '👞',
      keywords: {
        en: ['man’s shoe', 'formal'],
        es: ['zapato de hombre', 'formal'],
      },
    },
    {
      id: 480,
      emoji: '🧥',
      keywords: {
        en: ['coat', 'jacket'],
        es: ['abrigo', 'chaqueta'],
      },
    },
    {
      id: 481,
      emoji: '🧢',
      keywords: {
        en: ['billed cap', 'hat'],
        es: ['gorra', 'sombrero'],
      },
    },
    {
      id: 482,
      emoji: '👑',
      keywords: {
        en: ['crown', 'king'],
        es: ['corona', 'rey'],
      },
    },
    {
      id: 483,
      emoji: '👒',
      keywords: {
        en: ['woman’s hat', 'sun hat'],
        es: ['sombrero de mujer', 'sombrero de sol'],
      },
    },
    {
      id: 484,
      emoji: '🎓',
      keywords: {
        en: ['graduation cap', 'education'],
        es: ['birrete', 'educación'],
      },
    },
    {
      id: 485,
      emoji: '⛑️',
      keywords: {
        en: ['rescue worker’s helmet', 'safety'],
        es: ['casco de rescatista', 'seguridad'],
      },
    },
    {
      id: 486,
      emoji: '👜',
      keywords: {
        en: ['handbag', 'purse'],
        es: ['bolso', 'cartera'],
      },
    },
    {
      id: 487,
      emoji: '👛',
      keywords: {
        en: ['purse', 'clutch'],
        es: ['monedero', 'bolso de mano'],
      },
    },
    {
      id: 488,
      emoji: '👝',
      keywords: {
        en: ['clutch bag', 'pouch'],
        es: ['bolso de mano', 'estuche'],
      },
    },
    {
      id: 489,
      emoji: '🎒',
      keywords: {
        en: ['school backpack', 'bag'],
        es: ['morral escolar', 'bolso'],
      },
    },
    {
      id: 490,
      emoji: '🧢',
      keywords: {
        en: ['billed cap', 'hat'],
        es: ['gorra', 'sombrero'],
      },
    },
    {
      id: 491,
      emoji: '🌂',
      keywords: {
        en: ['closed umbrella', 'rain'],
        es: ['paraguas cerrado', 'lluvia'],
      },
    },
    {
      id: 492,
      emoji: '☂️',
      keywords: {
        en: ['umbrella', 'rain'],
        es: ['paraguas', 'lluvia'],
      },
    },
    {
      id: 493,
      emoji: '🧳',
      keywords: {
        en: ['luggage', 'travel'],
        es: ['equipaje', 'viaje'],
      },
    },
    {
      id: 494,
      emoji: '🕶️',
      keywords: {
        en: ['dark sunglasses', 'shades'],
        es: ['gafas oscuras', 'lentes oscuros'],
      },
    },
    {
      id: 495,
      emoji: '🥽',
      keywords: {
        en: ['goggles', 'protection'],
        es: ['gafas protectoras', 'protección'],
      },
    },
  ],
  animales: [
    {
      id: 496,
      emoji: '🐵',
      keywords: {
        en: ['monkey', 'animal', 'nature', 'wildlife'],
        es: ['mono', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 497,
      emoji: '🐒',
      keywords: {
        en: ['monkey', 'animal', 'nature', 'wildlife'],
        es: ['mono', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 498,
      emoji: '🦍',
      keywords: {
        en: ['gorilla', 'animal', 'nature', 'wildlife'],
        es: ['gorila', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 499,
      emoji: '🦧',
      keywords: {
        en: ['orangutan', 'animal', 'nature', 'wildlife'],
        es: ['orangután', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 500,
      emoji: '🐶',
      keywords: {
        en: ['dog', 'pet', 'animal', 'puppy'],
        es: ['perro', 'mascota', 'animal', 'cachorro'],
      },
    },
    {
      id: 501,
      emoji: '🐕',
      keywords: {
        en: ['dog', 'pet', 'animal', 'puppy'],
        es: ['perro', 'mascota', 'animal', 'cachorro'],
      },
    },
    {
      id: 502,
      emoji: '🦮',
      keywords: {
        en: ['guide dog', 'service animal', 'assistive', 'blind'],
        es: ['perro guía', 'animal de servicio', 'asistencia', 'ciego'],
      },
    },
    {
      id: 503,
      emoji: '🐕‍🦺',
      keywords: {
        en: ['therapy dog', 'comfort', 'support', 'animal'],
        es: ['perro de terapia', 'consuelo', 'apoyo', 'animal'],
      },
    },
    {
      id: 504,
      emoji: '🐩',
      keywords: {
        en: ['poodle', 'dog', 'pet', 'animal'],
        es: ['caniche', 'perro', 'mascota', 'animal'],
      },
    },
    {
      id: 505,
      emoji: '🐺',
      keywords: {
        en: ['wolf', 'animal', 'nature', 'wildlife'],
        es: ['lobo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 506,
      emoji: '🦊',
      keywords: {
        en: ['fox', 'animal', 'nature', 'wildlife'],
        es: ['zorro', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 507,
      emoji: '🦝',
      keywords: {
        en: ['raccoon', 'animal', 'nature', 'wildlife'],
        es: ['mapache', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 508,
      emoji: '🐱',
      keywords: {
        en: ['cat', 'pet', 'kitty', 'meow'],
        es: ['gato', 'mascota', 'gatito', 'miau'],
      },
    },
    {
      id: 509,
      emoji: '🐈',
      keywords: {
        en: ['cat', 'pet', 'kitty', 'meow'],
        es: ['gato', 'mascota', 'gatito', 'miau'],
      },
    },
    {
      id: 510,
      emoji: '🐈‍⬛',
      keywords: {
        en: ['black cat', 'pet', 'superstition', 'kitty'],
        es: ['gato negro', 'mascota', 'superstición', 'gatito'],
      },
    },
    {
      id: 511,
      emoji: '🦁',
      keywords: {
        en: ['lion', 'animal', 'nature', 'wildlife'],
        es: ['león', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 512,
      emoji: '🐯',
      keywords: {
        en: ['tiger', 'animal', 'nature', 'wildlife'],
        es: ['tigre', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 513,
      emoji: '🐅',
      keywords: {
        en: ['tiger', 'animal', 'nature', 'wildlife'],
        es: ['tigre', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 514,
      emoji: '🐆',
      keywords: {
        en: ['cheetah', 'animal', 'nature', 'wildlife'],
        es: ['guepardo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 515,
      emoji: '🐴',
      keywords: {
        en: ['horse', 'animal', 'nature', 'wildlife'],
        es: ['caballo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 516,
      emoji: '🫎',
      keywords: {
        en: ['unicorn', 'mythical', 'fantasy', 'magical'],
        es: ['unicornio', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 517,
      emoji: '🫏',
      keywords: {
        en: ['unicorn', 'mythical', 'fantasy', 'magical'],
        es: ['unicornio', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 518,
      emoji: '🐎',
      keywords: {
        en: ['horse', 'animal', 'nature', 'wildlife'],
        es: ['caballo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 519,
      emoji: '🦄',
      keywords: {
        en: ['unicorn', 'mythical', 'fantasy', 'magical'],
        es: ['unicornio', 'mítico', 'fantasía', 'mágico'],
      },
    },
    {
      id: 520,
      emoji: '🦓',
      keywords: {
        en: ['zebra', 'animal', 'nature', 'wildlife'],
        es: ['cebra', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 521,
      emoji: '🦌',
      keywords: {
        en: ['deer', 'animal', 'nature', 'wildlife'],
        es: ['ciervo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 522,
      emoji: '🦬',
      keywords: {
        en: ['bison', 'animal', 'nature', 'wildlife'],
        es: ['bisonte', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 523,
      emoji: '🐮',
      keywords: {
        en: ['cow', 'animal', 'nature', 'moo'],
        es: ['vaca', 'animal', 'naturaleza', 'muu'],
      },
    },
    {
      id: 524,
      emoji: '🐂',
      keywords: {
        en: ['ox', 'animal', 'nature', 'farm'],
        es: ['buey', 'animal', 'naturaleza', 'granja'],
      },
    },
    {
      id: 525,
      emoji: '🐃',
      keywords: {
        en: ['water buffalo', 'animal', 'nature', 'wildlife'],
        es: ['búfalo de agua', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 526,
      emoji: '🐄',
      keywords: {
        en: ['cow', 'animal', 'nature', 'moo'],
        es: ['vaca', 'animal', 'naturaleza', 'muu'],
      },
    },
    {
      id: 527,
      emoji: '🐷',
      keywords: {
        en: ['pig', 'animal', 'nature', 'oink'],
        es: ['cerdo', 'animal', 'naturaleza', 'oinc'],
      },
    },
    {
      id: 528,
      emoji: '🐖',
      keywords: {
        en: ['boar', 'animal', 'nature', 'wildlife'],
        es: ['jabalí', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 529,
      emoji: '🐗',
      keywords: {
        en: ['wild boar', 'animal', 'nature', 'wildlife'],
        es: ['jabalí salvaje', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 530,
      emoji: '🐽',
      keywords: {
        en: ['pig', 'snout', 'animal', 'nature'],
        es: ['cerdo', 'hocico', 'animal', 'naturaleza'],
      },
    },
    {
      id: 531,
      emoji: '🐏',
      keywords: {
        en: ['ram', 'sheep', 'animal', 'nature'],
        es: ['carnero', 'oveja', 'animal', 'naturaleza'],
      },
    },
    {
      id: 532,
      emoji: '🐑',
      keywords: {
        en: ['ewe', 'sheep', 'animal', 'nature'],
        es: ['oveja', 'cordero', 'animal', 'naturaleza'],
      },
    },
    {
      id: 533,
      emoji: '🐐',
      keywords: {
        en: ['goat', 'animal', 'nature', 'wildlife'],
        es: ['cabra', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 534,
      emoji: '🐪',
      keywords: {
        en: ['camel', 'animal', 'nature', 'desert'],
        es: ['camello', 'animal', 'naturaleza', 'desierto'],
      },
    },
    {
      id: 535,
      emoji: '🐫',
      keywords: {
        en: ['two-hump camel', 'animal', 'nature', 'desert'],
        es: ['camello de dos jorobas', 'animal', 'naturaleza', 'desierto'],
      },
    },
    {
      id: 536,
      emoji: '🦙',
      keywords: {
        en: ['llama', 'animal', 'nature', 'wildlife'],
        es: ['llama', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 537,
      emoji: '🦒',
      keywords: {
        en: ['giraffe', 'animal', 'nature', 'wildlife'],
        es: ['jirafa', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 538,
      emoji: '🐘',
      keywords: {
        en: ['elephant', 'animal', 'nature', 'wildlife'],
        es: ['elefante', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 539,
      emoji: '🦣',
      keywords: {
        en: ['mammoth', 'animal', 'prehistoric', 'wildlife'],
        es: ['mamut', 'animal', 'prehistórico', 'vida silvestre'],
      },
    },
    {
      id: 540,
      emoji: '🦏',
      keywords: {
        en: ['rhinoceros', 'animal', 'nature', 'wildlife'],
        es: ['rinoceronte', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 541,
      emoji: '🦛',
      keywords: {
        en: ['hippopotamus', 'animal', 'nature', 'wildlife'],
        es: ['hipopótamo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 542,
      emoji: '🐭',
      keywords: {
        en: ['mouse', 'animal', 'nature', 'rodent'],
        es: ['ratón', 'animal', 'naturaleza', 'roedor'],
      },
    },
    {
      id: 543,
      emoji: '🐁',
      keywords: {
        en: ['mouse', 'animal', 'nature', 'rodent'],
        es: ['ratón', 'animal', 'naturaleza', 'roedor'],
      },
    },
    {
      id: 544,
      emoji: '🐀',
      keywords: {
        en: ['rat', 'animal', 'nature', 'rodent'],
        es: ['rata', 'animal', 'naturaleza', 'roedor'],
      },
    },
    {
      id: 545,
      emoji: '🐹',
      keywords: {
        en: ['hamster', 'animal', 'pet', 'rodent'],
        es: ['hámster', 'animal', 'mascota', 'roedor'],
      },
    },
    {
      id: 546,
      emoji: '🐰',
      keywords: {
        en: ['rabbit', 'animal', 'nature', 'bunny'],
        es: ['conejo', 'animal', 'naturaleza', 'conejito'],
      },
    },
    {
      id: 547,
      emoji: '🐇',
      keywords: {
        en: ['rabbit', 'animal', 'nature', 'bunny'],
        es: ['conejo', 'animal', 'naturaleza', 'conejito'],
      },
    },
    {
      id: 548,
      emoji: '🐿️',
      keywords: {
        en: ['squirrel', 'animal', 'nature', 'rodent'],
        es: ['ardilla', 'animal', 'naturaleza', 'roedor'],
      },
    },
    {
      id: 549,
      emoji: '🦫',
      keywords: {
        en: ['beaver', 'animal', 'nature', 'wildlife'],
        es: ['castor', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 550,
      emoji: '🦔',
      keywords: {
        en: ['hedgehog', 'animal', 'nature', 'spikes'],
        es: ['erizo', 'animal', 'naturaleza', 'púas'],
      },
    },
    {
      id: 551,
      emoji: '🦇',
      keywords: {
        en: ['bat', 'animal', 'nature', 'wildlife'],
        es: ['murciélago', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 552,
      emoji: '🐻',
      keywords: {
        en: ['bear', 'animal', 'nature', 'wildlife'],
        es: ['oso', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 553,
      emoji: '🐻‍❄️',
      keywords: {
        en: ['polar bear', 'animal', 'nature', 'wildlife'],
        es: ['oso polar', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 554,
      emoji: '🐨',
      keywords: {
        en: ['koala', 'animal', 'nature', 'wildlife'],
        es: ['koala', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 555,
      emoji: '🐼',
      keywords: {
        en: ['panda', 'animal', 'nature', 'wildlife'],
        es: ['panda', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 556,
      emoji: '🦥',
      keywords: {
        en: ['sloth', 'animal', 'nature', 'wildlife'],
        es: ['perezoso', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 557,
      emoji: '🦦',
      keywords: {
        en: ['otter', 'animal', 'nature', 'wildlife'],
        es: ['nutria', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 558,
      emoji: '🦨',
      keywords: {
        en: ['skunk', 'animal', 'nature', 'wildlife'],
        es: ['mofeta', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 559,
      emoji: '🦘',
      keywords: {
        en: ['kangaroo', 'animal', 'nature', 'wildlife'],
        es: ['canguro', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 560,
      emoji: '🦡',
      keywords: {
        en: ['badger', 'animal', 'nature', 'wildlife'],
        es: ['tejón', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 561,
      emoji: '🐾',
      keywords: {
        en: ['paw prints', 'animal', 'nature', 'footprints'],
        es: ['huellas de patas', 'animal', 'naturaleza', 'huellas'],
      },
    },
    {
      id: 562,
      emoji: '🦃',
      keywords: {
        en: ['turkey', 'animal', 'nature', 'thanksgiving'],
        es: ['pavo', 'animal', 'naturaleza', 'acción de gracias'],
      },
    },
    {
      id: 563,
      emoji: '🐔',
      keywords: {
        en: ['chicken', 'animal', 'nature', 'cluck'],
        es: ['gallina', 'animal', 'naturaleza', 'cacareo'],
      },
    },
    {
      id: 564,
      emoji: '🐓',
      keywords: {
        en: ['rooster', 'animal', 'nature', 'cock-a-doodle-doo'],
        es: ['gallo', 'animal', 'naturaleza', 'quiquiriquí'],
      },
    },
    {
      id: 565,
      emoji: '🐣',
      keywords: {
        en: ['hatching chick', 'baby', 'animal', 'nature'],
        es: ['pollito naciendo', 'bebé', 'animal', 'naturaleza'],
      },
    },
    {
      id: 566,
      emoji: '🐤',
      keywords: {
        en: ['baby chick', 'chicken', 'animal', 'nature'],
        es: ['pollito', 'gallina', 'animal', 'naturaleza'],
      },
    },
    {
      id: 567,
      emoji: '🐥',
      keywords: {
        en: ['front-facing baby chick', 'chicken', 'animal', 'nature'],
        es: ['pollito de frente', 'gallina', 'animal', 'naturaleza'],
      },
    },
    {
      id: 568,
      emoji: '🐦',
      keywords: {
        en: ['bird', 'animal', 'nature', 'feathers'],
        es: ['pájaro', 'animal', 'naturaleza', 'plumas'],
      },
    },
    {
      id: 569,
      emoji: '🐧',
      keywords: {
        en: ['penguin', 'animal', 'nature', 'cold'],
        es: ['pingüino', 'animal', 'naturaleza', 'frío'],
      },
    },
    {
      id: 570,
      emoji: '🕊️',
      keywords: {
        en: ['dove', 'bird', 'peace', 'symbol'],
        es: ['paloma', 'pájaro', 'paz', 'símbolo'],
      },
    },
    {
      id: 571,
      emoji: '🦅',
      keywords: {
        en: ['eagle', 'bird', 'animal', 'nature'],
        es: ['águila', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 572,
      emoji: '🦆',
      keywords: {
        en: ['duck', 'bird', 'animal', 'nature'],
        es: ['pato', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 573,
      emoji: '🦢',
      keywords: {
        en: ['swan', 'bird', 'animal', 'nature'],
        es: ['cisne', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 574,
      emoji: '🦉',
      keywords: {
        en: ['owl', 'bird', 'animal', 'night'],
        es: ['búho', 'pájaro', 'animal', 'noche'],
      },
    },
    {
      id: 575,
      emoji: '🦤',
      keywords: {
        en: ['dodo', 'extinct', 'bird', 'animal'],
        es: ['dodo', 'extinto', 'pájaro', 'animal'],
      },
    },
    {
      id: 576,
      emoji: '🪶',
      keywords: {
        en: ['feather', 'bird', 'writing', 'quill'],
        es: ['pluma', 'pájaro', 'escritura', 'pluma de ave'],
      },
    },
    {
      id: 577,
      emoji: '🦩',
      keywords: {
        en: ['flamingo', 'bird', 'animal', 'nature'],
        es: ['flamenco', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 578,
      emoji: '🦚',
      keywords: {
        en: ['peacock', 'bird', 'animal', 'nature'],
        es: ['pavo real', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 579,
      emoji: '🦜',
      keywords: {
        en: ['parrot', 'bird', 'animal', 'nature'],
        es: ['loro', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 580,
      emoji: '🪽',
      keywords: {
        en: ['toothbrush', 'clean', 'oral hygiene', 'dental'],
        es: ['cepillo de dientes', 'limpio', 'higiene oral', 'dental'],
      },
    },
    {
      id: 581,
      emoji: '🦩',
      keywords: {
        en: ['flamingo', 'bird', 'animal', 'nature'],
        es: ['flamenco', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 582,
      emoji: '🦚',
      keywords: {
        en: ['peacock', 'bird', 'animal', 'nature'],
        es: ['pavo real', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 583,
      emoji: '🦜',
      keywords: {
        en: ['parrot', 'bird', 'animal', 'nature'],
        es: ['loro', 'pájaro', 'animal', 'naturaleza'],
      },
    },
    {
      id: 584,
      emoji: '🪽',
      keywords: {
        en: ['toothbrush', 'clean', 'oral hygiene', 'dental'],
        es: ['cepillo de dientes', 'limpio', 'higiene oral', 'dental'],
      },
    },
    {
      id: 585,
      emoji: '🐦‍⬛',
      keywords: {
        en: ['black bird', 'animal', 'nature', 'mystery'],
        es: ['pájaro negro', 'animal', 'naturaleza', 'misterio'],
      },
    },
    {
      id: 586,
      emoji: '🪿',
      keywords: {
        en: ['fly', 'insect', 'annoying', 'pest'],
        es: ['mosca', 'insecto', 'molesto', 'plaga'],
      },
    },
    {
      id: 587,
      emoji: '🐸',
      keywords: {
        en: ['frog', 'animal', 'nature', 'amphibian'],
        es: ['rana', 'animal', 'naturaleza', 'anfibio'],
      },
    },
    {
      id: 588,
      emoji: '🐊',
      keywords: {
        en: ['crocodile', 'animal', 'nature', 'wildlife'],
        es: ['cocodrilo', 'animal', 'naturaleza', 'vida silvestre'],
      },
    },
    {
      id: 589,
      emoji: '🐢',
      keywords: {
        en: ['turtle', 'animal', 'nature', 'slow'],
        es: ['tortuga', 'animal', 'naturaleza', 'lento'],
      },
    },
    {
      id: 590,
      emoji: '🦎',
      keywords: {
        en: ['lizard', 'animal', 'nature', 'reptile'],
        es: ['lagarto', 'animal', 'naturaleza', 'reptil'],
      },
    },
    {
      id: 591,
      emoji: '🐍',
      keywords: {
        en: ['snake', 'animal', 'nature', 'reptile'],
        es: ['serpiente', 'animal', 'naturaleza', 'reptil'],
      },
    },
    {
      id: 592,
      emoji: '🐲',
      keywords: {
        en: ['dragon face', 'mythical', 'fantasy', 'reptile'],
        es: ['cara de dragón', 'mítico', 'fantasía', 'reptil'],
      },
    },
    {
      id: 593,
      emoji: '🐉',
      keywords: {
        en: ['dragon', 'mythical', 'fantasy', 'reptile'],
        es: ['dragón', 'mítico', 'fantasía', 'reptil'],
      },
    },
    {
      id: 594,
      emoji: '🦕',
      keywords: {
        en: ['sauropod', 'dinosaur', 'prehistoric', 'extinct'],
        es: ['saurópodo', 'dinosaurio', 'prehistórico', 'extinto'],
      },
    },
    {
      id: 595,
      emoji: '🦖',
      keywords: {
        en: ['T-Rex', 'dinosaur', 'prehistoric', 'extinct'],
        es: ['T-Rex', 'dinosaurio', 'prehistórico', 'extinto'],
      },
    },
    {
      id: 596,
      emoji: '🐳',
      keywords: {
        en: ['spouting whale', 'animal', 'nature', 'sea'],
        es: ['ballena expulsando agua', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 597,
      emoji: '🐋',
      keywords: {
        en: ['whale', 'animal', 'nature', 'sea'],
        es: ['ballena', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 598,
      emoji: '🐬',
      keywords: {
        en: ['dolphin', 'animal', 'nature', 'sea'],
        es: ['delfín', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 599,
      emoji: '🦭',
      keywords: {
        en: ['seal', 'animal', 'nature', 'sea'],
        es: ['foca', 'animal', 'naturaleza', 'mar'],
      },
    },

    {
      id: 600,
      emoji: '🐟',
      keywords: {
        en: ['fish', 'animal', 'nature', 'sea'],
        es: ['pez', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 601,
      emoji: '🐠',
      keywords: {
        en: ['tropical fish', 'animal', 'nature', 'aquarium'],
        es: ['pez tropical', 'animal', 'naturaleza', 'acuario'],
      },
    },
    {
      id: 602,
      emoji: '🐡',
      keywords: {
        en: ['blowfish', 'animal', 'nature', 'sea'],
        es: ['pez globo', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 603,
      emoji: '🦈',
      keywords: {
        en: ['shark', 'animal', 'nature', 'sea'],
        es: ['tiburón', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 604,
      emoji: '🐙',
      keywords: {
        en: ['octopus', 'animal', 'nature', 'sea'],
        es: ['pulpo', 'animal', 'naturaleza', 'mar'],
      },
    },
    {
      id: 605,
      emoji: '🐚',
      keywords: {
        en: ['spiral shell', 'sea', 'ocean', 'beach'],
        es: ['concha marina', 'mar', 'océano', 'playa'],
      },
    },
    {
      id: 606,
      emoji: '🪸',
      keywords: {
        en: ['pinata', 'celebration', 'party', 'candy'],
        es: ['piñata', 'celebración', 'fiesta', 'dulces'],
      },
    },
    {
      id: 607,
      emoji: '🪼',
      keywords: {
        en: ['soap', 'clean', 'hygiene', 'bath'],
        es: ['jabón', 'limpio', 'higiene', 'baño'],
      },
    },
    {
      id: 608,
      emoji: '🐌',
      keywords: {
        en: ['snail', 'animal', 'nature', 'slow'],
        es: ['caracol', 'animal', 'naturaleza', 'lento'],
      },
    },
    {
      id: 609,
      emoji: '🦋',
      keywords: {
        en: ['butterfly', 'insect', 'nature', 'metamorphosis'],
        es: ['mariposa', 'insecto', 'naturaleza', 'metamorfosis'],
      },
    },
    {
      id: 610,
      emoji: '🐛',
      keywords: {
        en: ['bug', 'insect', 'nature', 'worm'],
        es: ['bicho', 'insecto', 'naturaleza', 'gusano'],
      },
    },
    {
      id: 611,
      emoji: '🐜',
      keywords: {
        en: ['ant', 'insect', 'nature', 'strong'],
        es: ['hormiga', 'insecto', 'naturaleza', 'fuerte'],
      },
    },
    {
      id: 612,
      emoji: '🐝',
      keywords: {
        en: ['honeybee', 'insect', 'nature', 'buzz'],
        es: ['abeja', 'insecto', 'naturaleza', 'zumbido'],
      },
    },
    {
      id: 613,
      emoji: '🪲',
      keywords: {
        en: ['beetle', 'insect', 'nature', 'bug'],
        es: ['escarabajo', 'insecto', 'naturaleza', 'bicho'],
      },
    },
    {
      id: 614,
      emoji: '🐞',
      keywords: {
        en: ['ladybug', 'insect', 'nature', 'luck'],
        es: ['mariquita', 'insecto', 'naturaleza', 'suerte'],
      },
    },
    {
      id: 615,
      emoji: '🦗',
      keywords: {
        en: ['cricket', 'insect', 'nature', 'chirp'],
        es: ['grillo', 'insecto', 'naturaleza', 'chirrido'],
      },
    },
    {
      id: 616,
      emoji: '🪳',
      keywords: {
        en: ['cockroach', 'insect', 'pest', 'unpleasant'],
        es: ['cucaracha', 'insecto', 'plaga', 'desagradable'],
      },
    },
    {
      id: 617,
      emoji: '🕷️',
      keywords: {
        en: ['spider', 'arachnid', 'insect', 'bug'],
        es: ['araña', 'arácnido', 'insecto', 'bicho'],
      },
    },
    {
      id: 618,
      emoji: '🕸️',
      keywords: {
        en: ['web', 'spiderweb', 'trap', 'sticky'],
        es: ['telaraña', 'red de araña', 'trampa', 'pegajoso'],
      },
    },
    {
      id: 619,
      emoji: '🦂',
      keywords: {
        en: ['scorpion', 'arachnid', 'stinger', 'poisonous'],
        es: ['escorpión', 'arácnido', 'aguijón', 'venenoso'],
      },
    },
    {
      id: 620,
      emoji: '🦟',
      keywords: {
        en: ['mosquito', 'insect', 'annoying', 'itchy'],
        es: ['mosquito', 'insecto', 'molesto', 'picazón'],
      },
    },
    {
      id: 621,
      emoji: '🪰',
      keywords: {
        en: ['fly', 'insect', 'annoying', 'buzzing'],
        es: ['mosca', 'insecto', 'molesta', 'zumbido'],
      },
    },
    {
      id: 622,
      emoji: '🪱',
      keywords: {
        en: ['worm', 'larva', 'insect', 'crawl'],
        es: ['gusano', 'larva', 'insecto', 'arrastrarse'],
      },
    },
    {
      id: 623,
      emoji: '🦠',
      keywords: {
        en: ['microbe', 'virus', 'bacteria', 'germ'],
        es: ['microbio', 'virus', 'bacteria', 'germen'],
      },
    },
    {
      id: 624,
      emoji: '💐',
      keywords: {
        en: ['bouquet', 'flowers', 'floral', 'gift'],
        es: ['ramo', 'flores', 'floral', 'regalo'],
      },
    },
    {
      id: 625,
      emoji: '🌸',
      keywords: {
        en: ['cherry blossom', 'flower', 'pink', 'spring'],
        es: ['flor de cerezo', 'flor', 'rosa', 'primavera'],
      },
    },
    {
      id: 626,
      emoji: '💮',
      keywords: {
        en: ['flower', 'white', 'blossom', 'Japanese'],
        es: ['flor', 'blanco', 'florecer', 'japonés'],
      },
    },
    {
      id: 627,
      emoji: '🪷',
      keywords: {
        en: ['pin', 'floral', 'decoration', 'accessory'],
        es: ['pin', 'floral', 'decoración', 'accesorio'],
      },
    },
    {
      id: 628,
      emoji: '🏵️',
      keywords: {
        en: ['rosette', 'prize', 'award', 'ceremony'],
        es: ['roseta', 'premio', 'reconocimiento', 'ceremonia'],
      },
    },
    {
      id: 629,
      emoji: '🌹',
      keywords: {
        en: ['rose', 'flower', 'romance', 'love'],
        es: ['rosa', 'flor', 'romance', 'amor'],
      },
    },
    {
      id: 630,
      emoji: '🥀',
      keywords: {
        en: ['wilted flower', 'sad', 'decay', 'mourning'],
        es: ['flor marchita', 'triste', 'decadencia', 'duelo'],
      },
    },
    {
      id: 631,
      emoji: '🌺',
      keywords: {
        en: ['hibiscus', 'flower', 'tropical', 'colorful'],
        es: ['hibisco', 'flor', 'tropical', 'colorido'],
      },
    },
    {
      id: 632,
      emoji: '🌻',
      keywords: {
        en: ['sunflower', 'flower', 'bright', 'cheerful'],
        es: ['girasol', 'flor', 'brillante', 'alegre'],
      },
    },
    {
      id: 633,
      emoji: '🌼',
      keywords: {
        en: ['blossom', 'flower', 'yellow', 'spring'],
        es: ['flor', 'florecer', 'amarillo', 'primavera'],
      },
    },
    {
      id: 634,
      emoji: '🌷',
      keywords: {
        en: ['tulip', 'flower', 'spring', 'bulbous'],
        es: ['tulipán', 'flor', 'primavera', 'bulbosa'],
      },
    },
    {
      id: 635,
      emoji: '🪻',
      keywords: {
        en: ['toilet paper', 'roll', 'bathroom', 'hygiene'],
        es: ['papel higiénico', 'rollo', 'baño', 'higiene'],
      },
    },
    {
      id: 636,
      emoji: '🌱',
      keywords: {
        en: ['seedling', 'plant', 'growth', 'green'],
        es: ['brote', 'planta', 'crecimiento', 'verde'],
      },
    },
    {
      id: 637,
      emoji: '🪴',
      keywords: {
        en: ['potted plant', 'indoor', 'greenery', 'decoration'],
        es: ['planta en maceta', 'interior', 'vegetación', 'decoración'],
      },
    },
    {
      id: 638,
      emoji: '🌲',
      keywords: {
        en: ['evergreen tree', 'forest', 'pine', 'nature'],
        es: ['árbol perenne', 'bosque', 'pino', 'naturaleza'],
      },
    },
    {
      id: 639,
      emoji: '🌳',
      keywords: {
        en: ['deciduous tree', 'forest', 'nature', 'leaves'],
        es: ['árbol frondoso', 'bosque', 'naturaleza', 'hojas'],
      },
    },
    {
      id: 640,
      emoji: '🌴',
      keywords: {
        en: ['palm tree', 'tropical', 'beach', 'summer'],
        es: ['palmera', 'tropical', 'playa', 'verano'],
      },
    },
    {
      id: 641,
      emoji: '🌵',
      keywords: {
        en: ['cactus', 'desert', 'succulent', 'spiky'],
        es: ['cactus', 'desierto', 'suculenta', 'espinoso'],
      },
    },
    {
      id: 642,
      emoji: '🌾',
      keywords: {
        en: ['ear of rice', 'crop', 'harvest', 'grain'],
        es: ['espiga de arroz', 'cultivo', 'cosecha', 'grano'],
      },
    },
    {
      id: 643,
      emoji: '🌿',
      keywords: {
        en: ['herb', 'plant', 'green', 'cooking'],
        es: ['hierba', 'planta', 'verde', 'cocina'],
      },
    },
    {
      id: 644,
      emoji: '☘️',
      keywords: {
        en: ['shamrock', 'luck', 'Irish', 'green'],
        es: ['trébol', 'suerte', 'irlandés', 'verde'],
      },
    },
    {
      id: 645,
      emoji: '🍀',
      keywords: {
        en: ['four-leaf clover', 'luck', 'Irish', 'green'],
        es: ['trébol de cuatro hojas', 'suerte', 'irlandés', 'verde'],
      },
    },
    {
      id: 646,
      emoji: '🍁',
      keywords: {
        en: ['maple leaf', 'autumn', 'fall', 'Canada'],
        es: ['hoja de arce', 'otoño', 'caída', 'Canadá'],
      },
    },
    {
      id: 647,
      emoji: '🍂',
      keywords: {
        en: ['fallen leaf', 'autumn', 'nature', 'brown'],
        es: ['hoja caída', 'otoño', 'naturaleza', 'marrón'],
      },
    },
    {
      id: 648,
      emoji: '🍃',
      keywords: {
        en: ['leaf', 'nature', 'green', 'fresh'],
        es: ['hoja', 'naturaleza', 'verde', 'fresco'],
      },
    },
    {
      id: 649,
      emoji: '🪹',
      keywords: {
        en: ['sponge', 'cleaning', 'absorbent', 'soft'],
        es: ['esponja', 'limpieza', 'absorbente', 'suave'],
      },
    },
    {
      id: 650,
      emoji: '🪺',
      keywords: {
        en: ['carpet', 'decor', 'flooring', 'textile'],
        es: ['alfombra', 'decoración', 'piso', 'textil'],
      },
    },
    {
      id: 651,
      emoji: '🍄',
      keywords: {
        en: ['mushroom', 'fungus', 'forage', 'wild'],
        es: ['hongo', 'fungi', 'recolección', 'silvestre'],
      },
    },
    {
      id: 652,
      emoji: '🌑',
      keywords: {
        en: ['new moon', 'moon', 'night', 'dark'],
        es: ['luna nueva', 'luna', 'noche', 'oscuro'],
      },
    },
    {
      id: 653,
      emoji: '🌒',
      keywords: {
        en: ['waxing crescent moon', 'moon', 'night', 'light'],
        es: ['luna creciente', 'luna', 'noche', 'luz'],
      },
    },
    {
      id: 654,
      emoji: '🌓',
      keywords: {
        en: ['first quarter moon', 'moon', 'night', 'phase'],
        es: ['cuarto creciente', 'luna', 'noche', 'fase'],
      },
    },
    {
      id: 655,
      emoji: '🌔',
      keywords: {
        en: ['waxing gibbous moon', 'moon', 'night', 'bright'],
        es: ['luna gibosa creciente', 'luna', 'noche', 'brillante'],
      },
    },
    {
      id: 656,
      emoji: '🌕',
      keywords: {
        en: ['full moon', 'moon', 'night', 'bright'],
        es: ['luna llena', 'luna', 'noche', 'brillante'],
      },
    },
    {
      id: 657,
      emoji: '🌖',
      keywords: {
        en: ['waning gibbous moon', 'moon', 'night', 'dim'],
        es: ['luna gibosa menguante', 'luna', 'noche', 'tenue'],
      },
    },
    {
      id: 658,
      emoji: '🌗',
      keywords: {
        en: ['last quarter moon', 'moon', 'night', 'phase'],
        es: ['cuarto menguante', 'luna', 'noche', 'fase'],
      },
    },
    {
      id: 659,
      emoji: '🌘',
      keywords: {
        en: ['waning crescent moon', 'moon', 'night', 'dim'],
        es: ['luna menguante', 'luna', 'noche', 'tenue'],
      },
    },
    {
      id: 660,
      emoji: '🌙',
      keywords: {
        en: ['crescent moon', 'moon', 'night', 'sky'],
        es: ['media luna', 'luna', 'noche', 'cielo'],
      },
    },
    {
      id: 661,
      emoji: '🌚',
      keywords: {
        en: ['new moon face', 'moon', 'night', 'dark'],
        es: ['cara de luna nueva', 'luna', 'noche', 'oscuro'],
      },
    },
    {
      id: 662,
      emoji: '🌛',
      keywords: {
        en: ['first quarter moon face', 'moon', 'night', 'light'],
        es: ['cara de cuarto creciente', 'luna', 'noche', 'luz'],
      },
    },
    {
      id: 663,
      emoji: '🌜',
      keywords: {
        en: ['last quarter moon face', 'moon', 'night', 'dim'],
        es: ['cara de cuarto menguante', 'luna', 'noche', 'tenue'],
      },
    },
    {
      id: 664,
      emoji: '🌡️',
      keywords: {
        en: ['thermometer', 'temperature', 'weather', 'hot'],
        es: ['termómetro', 'temperatura', 'clima', 'calor'],
      },
    },
    {
      id: 665,
      emoji: '☀️',
      keywords: {
        en: ['sun', 'sunny', 'day', 'brightness'],
        es: ['sol', 'soleado', 'día', 'brillo'],
      },
    },
    {
      id: 666,
      emoji: '🌝',
      keywords: {
        en: ['full moon face', 'moon', 'night', 'bright'],
        es: ['cara de luna llena', 'luna', 'noche', 'brillante'],
      },
    },
    {
      id: 667,
      emoji: '🌞',
      keywords: {
        en: ['sun with face', 'sun', 'day', 'bright'],
        es: ['sol con cara', 'sol', 'día', 'brillante'],
      },
    },
    {
      id: 668,
      emoji: '🪐',
      keywords: {
        en: ['ringed planet', 'planet', 'space', 'astronomy'],
        es: ['planeta con anillos', 'planeta', 'espacio', 'astronomía'],
      },
    },
    {
      id: 669,
      emoji: '⭐',
      keywords: {
        en: ['star', 'night', 'sparkle', 'celestial'],
        es: ['estrella', 'noche', 'brillo', 'celestial'],
      },
    },
    {
      id: 670,
      emoji: '🌟',
      keywords: {
        en: ['glowing star', 'sparkle', 'night', 'celestial'],
        es: ['estrella brillante', 'brillo', 'noche', 'celestial'],
      },
    },
    {
      id: 671,
      emoji: '🌠',
      keywords: {
        en: ['shooting star', 'night', 'sky', 'celestial'],
        es: ['estrella fugaz', 'noche', 'cielo', 'celestial'],
      },
    },
    {
      id: 672,
      emoji: '🌌',
      keywords: {
        en: ['milky way', 'galaxy', 'night', 'stars'],
        es: ['vía láctea', 'galaxia', 'noche', 'estrellas'],
      },
    },
    {
      id: 673,
      emoji: '☁️',
      keywords: {
        en: ['cloud', 'sky', 'weather', 'overcast'],
        es: ['nube', 'cielo', 'clima', 'nublado'],
      },
    },
    {
      id: 674,
      emoji: '⛅',
      keywords: {
        en: ['sun behind cloud', 'weather', 'cloudy', 'sky'],
        es: ['sol detrás de nube', 'clima', 'nublado', 'cielo'],
      },
    },
    {
      id: 675,
      emoji: '⛈️',
      keywords: {
        en: ['cloud with lightning and rain', 'storm', 'weather', 'thunder'],
        es: ['nube con rayos y lluvia', 'tormenta', 'clima', 'trueno'],
      },
    },
    {
      id: 676,
      emoji: '🌤️',
      keywords: {
        en: ['sun behind small cloud', 'weather', 'partly cloudy', 'sky'],
        es: ['sol detrás de nube pequeña', 'clima', 'parcialmente nublado', 'cielo'],
      },
    },
    {
      id: 677,
      emoji: '🌥️',
      keywords: {
        en: ['sun behind large cloud', 'weather', 'cloudy', 'sky'],
        es: ['sol detrás de nube grande', 'clima', 'nublado', 'cielo'],
      },
    },
    {
      id: 678,
      emoji: '🌦️',
      keywords: {
        en: ['sun behind rain cloud', 'weather', 'rainy', 'sky'],
        es: ['sol detrás de nube con lluvia', 'clima', 'lluvioso', 'cielo'],
      },
    },
    {
      id: 679,
      emoji: '🌧️',
      keywords: {
        en: ['cloud with rain', 'weather', 'rainy', 'precipitation'],
        es: ['nube con lluvia', 'clima', 'lluvioso', 'precipitación'],
      },
    },
    {
      id: 680,
      emoji: '🌨️',
      keywords: {
        en: ['cloud with snow', 'weather', 'snowy', 'winter'],
        es: ['nube con nieve', 'clima', 'nevado', 'invierno'],
      },
    },
    {
      id: 681,
      emoji: '🌩️',
      keywords: {
        en: ['cloud with lightning', 'weather', 'storm', 'thunder'],
        es: ['nube con rayo', 'clima', 'tormenta', 'trueno'],
      },
    },
    {
      id: 682,
      emoji: '🌪️',
      keywords: {
        en: ['tornado', 'weather', 'cyclone', 'twister'],
        es: ['tornado', 'clima', 'ciclón', 'torbellino'],
      },
    },
    {
      id: 683,
      emoji: '🌫️',
      keywords: {
        en: ['fog', 'weather', 'misty', 'hazy'],
        es: ['niebla', 'clima', 'brumoso', 'neblinoso'],
      },
    },
    {
      id: 684,
      emoji: '🌬️',
      keywords: {
        en: ['wind face', 'weather', 'blow', 'breeze'],
        es: ['cara de viento', 'clima', 'soplar', 'brisa'],
      },
    },
    {
      id: 685,
      emoji: '🌀',
      keywords: {
        en: ['cyclone', 'weather', 'swirl', 'wind'],
        es: ['ciclón', 'clima', 'remolino', 'viento'],
      },
    },
    {
      id: 686,
      emoji: '🌈',
      keywords: {
        en: ['rainbow', 'weather', 'color', 'sky'],
        es: ['arcoíris', 'clima', 'color', 'cielo'],
      },
    },
    {
      id: 687,
      emoji: '🌂',
      keywords: {
        en: ['closed umbrella', 'weather', 'rain', 'protection'],
        es: ['paraguas cerrado', 'clima', 'lluvia', 'protección'],
      },
    },
    {
      id: 688,
      emoji: '☂️',
      keywords: {
        en: ['umbrella', 'rain', 'weather', 'protection'],
        es: ['paraguas', 'lluvia', 'clima', 'protección'],
      },
    },
    {
      id: 689,
      emoji: '☔',
      keywords: {
        en: ['umbrella with rain drops', 'rain', 'weather', 'protection'],
        es: ['paraguas con gotas de lluvia', 'lluvia', 'clima', 'protección'],
      },
    },
    {
      id: 690,
      emoji: '⛱️',
      keywords: {
        en: ['umbrella on ground', 'beach', 'vacation', 'shade'],
        es: ['sombrilla en el suelo', 'playa', 'vacaciones', 'sombra'],
      },
    },
    {
      id: 691,
      emoji: '⚡',
      keywords: {
        en: ['high voltage', 'thunder', 'lightning', 'electricity'],
        es: ['alto voltaje', 'trueno', 'rayo', 'electricidad'],
      },
    },
    {
      id: 692,
      emoji: '❄️',
      keywords: {
        en: ['snowflake', 'snow', 'winter', 'cold'],
        es: ['copo de nieve', 'nieve', 'invierno', 'frío'],
      },
    },
    {
      id: 693,
      emoji: '☃️',
      keywords: {
        en: ['snowman', 'winter', 'snow', 'holiday'],
        es: ['muñeco de nieve', 'invierno', 'nieve', 'festividad'],
      },
    },
    {
      id: 694,
      emoji: '⛄',
      keywords: {
        en: ['snowman without snow', 'winter', 'cold', 'holiday'],
        es: ['muñeco de nieve sin nieve', 'invierno', 'frío', 'festividad'],
      },
    },
    {
      id: 695,
      emoji: '☄️',
      keywords: {
        en: ['comet', 'space', 'astronomy', 'celestial'],
        es: ['cometa', 'espacio', 'astronomía', 'celestial'],
      },
    },
    {
      id: 696,
      emoji: '🔥',
      keywords: {
        en: ['fire', 'flame', 'hot', 'burn'],
        es: ['fuego', 'llama', 'calor', 'quemar'],
      },
    },
    {
      id: 697,
      emoji: '💧',
      keywords: {
        en: ['droplet', 'water', 'drip', 'wet'],
        es: ['gota', 'agua', 'goteo', 'mojado'],
      },
    },
    {
      id: 698,
      emoji: '🌊',
      keywords: {
        en: ['water wave', 'sea', 'ocean', 'splash'],
        es: ['ola de agua', 'mar', 'océano', 'salpicadura'],
      },
    },
  ],
  comida: [
    {
      id: 699,
      emoji: '🍇',
      keywords: {
        en: ['grape', 'fruit', 'purple', 'vine'],
        es: ['uva', 'fruta', 'morado', 'vid'],
      },
    },
    {
      id: 700,
      emoji: '🍈',
      keywords: {
        en: ['melon', 'fruit', 'green', 'refreshing'],
        es: ['melón', 'fruta', 'verde', 'refrescante'],
      },
    },
    {
      id: 701,
      emoji: '🍉',
      keywords: {
        en: ['watermelon', 'fruit', 'summer', 'juicy'],
        es: ['sandía', 'fruta', 'verano', 'jugosa'],
      },
    },
    {
      id: 702,
      emoji: '🍊',
      keywords: {
        en: ['orange', 'fruit', 'citrus', 'juicy'],
        es: ['naranja', 'fruta', 'cítrico', 'jugosa'],
      },
    },
    {
      id: 703,
      emoji: '🍋',
      keywords: {
        en: ['lemon', 'fruit', 'yellow', 'sour'],
        es: ['limón', 'fruta', 'amarillo', 'ácido'],
      },
    },
    {
      id: 704,
      emoji: '🍌',
      keywords: {
        en: ['banana', 'fruit', 'yellow', 'tropical'],
        es: ['banano', 'fruta', 'amarillo', 'tropical'],
      },
    },
    {
      id: 705,
      emoji: '🍍',
      keywords: {
        en: ['pineapple', 'fruit', 'tropical', 'sweet'],
        es: ['piña', 'fruta', 'tropical', 'dulce'],
      },
    },
    {
      id: 706,
      emoji: '🥭',
      keywords: {
        en: ['mango', 'fruit', 'tropical', 'juicy'],
        es: ['mango', 'fruta', 'tropical', 'jugoso'],
      },
    },
    {
      id: 707,
      emoji: '🍎',
      keywords: {
        en: ['apple', 'fruit', 'red', 'crisp'],
        es: ['manzana', 'fruta', 'roja', 'crujiente'],
      },
    },
    {
      id: 708,
      emoji: '🍏',
      keywords: {
        en: ['green apple', 'fruit', 'crisp', 'sour'],
        es: ['manzana verde', 'fruta', 'crujiente', 'ácida'],
      },
    },
    {
      id: 709,
      emoji: '🍐',
      keywords: {
        en: ['pear', 'fruit', 'green', 'juicy'],
        es: ['pera', 'fruta', 'verde', 'jugosa'],
      },
    },
    {
      id: 710,
      emoji: '🍑',
      keywords: {
        en: ['peach', 'fruit', 'juicy', 'soft'],
        es: ['durazno', 'fruta', 'jugoso', 'suave'],
      },
    },
    {
      id: 711,
      emoji: '🍒',
      keywords: {
        en: ['cherries', 'fruit', 'red', 'sweet'],
        es: ['cerezas', 'fruta', 'rojo', 'dulce'],
      },
    },
    {
      id: 712,
      emoji: '🍓',
      keywords: {
        en: ['strawberry', 'fruit', 'red', 'sweet'],
        es: ['fresa', 'fruta', 'rojo', 'dulce'],
      },
    },
    {
      id: 713,
      emoji: '🫐',
      keywords: {
        en: ['blueberry', 'fruit', 'purple', 'antioxidant'],
        es: ['arándano', 'fruta', 'morado', 'antioxidante'],
      },
    },
    {
      id: 714,
      emoji: '🥝',
      keywords: {
        en: ['kiwi', 'fruit', 'green', 'tangy'],
        es: ['kiwi', 'fruta', 'verde', 'ácido'],
      },
    },
    {
      id: 715,
      emoji: '🍅',
      keywords: {
        en: ['tomato', 'fruit', 'red', 'vegetable'],
        es: ['tomate', 'fruta', 'rojo', 'vegetal'],
      },
    },
    {
      id: 716,
      emoji: '🫒',
      keywords: {
        en: ['olive', 'fruit', 'green', 'brine'],
        es: ['aceituna', 'fruta', 'verde', 'salmuera'],
      },
    },
    {
      id: 717,
      emoji: '🥥',
      keywords: {
        en: ['coconut', 'fruit', 'tropical', 'nutty'],
        es: ['coco', 'fruta', 'tropical', 'nuez'],
      },
    },
    {
      id: 718,
      emoji: '🥑',
      keywords: {
        en: ['avocado', 'fruit', 'green', 'creamy'],
        es: ['aguacate', 'fruta', 'verde', 'cremoso'],
      },
    },
    {
      id: 719,
      emoji: '🍆',
      keywords: {
        en: ['eggplant', 'vegetable', 'purple', 'cooking'],
        es: ['berenjena', 'vegetal', 'morado', 'cocina'],
      },
    },
    {
      id: 720,
      emoji: '🥔',
      keywords: {
        en: ['potato', 'vegetable', 'starchy', 'brown'],
        es: ['papa', 'vegetal', 'almidonado', 'marrón'],
      },
    },
    {
      id: 721,
      emoji: '🥕',
      keywords: {
        en: ['carrot', 'vegetable', 'orange', 'crunchy'],
        es: ['zanahoria', 'vegetal', 'naranja', 'crujiente'],
      },
    },
    {
      id: 722,
      emoji: '🌽',
      keywords: {
        en: ['corn', 'vegetable', 'yellow', 'cob'],
        es: ['maíz', 'vegetal', 'amarillo', 'mazorca'],
      },
    },
    {
      id: 723,
      emoji: '🌶️',
      keywords: {
        en: ['chili pepper', 'spicy', 'vegetable', 'hot'],
        es: ['ají picante', 'picante', 'vegetal', 'caliente'],
      },
    },
    {
      id: 724,
      emoji: '🫑',
      keywords: {
        en: ['bell pepper', 'vegetable', 'colorful', 'crunchy'],
        es: ['pimentón', 'vegetal', 'colorido', 'crujiente'],
      },
    },
    {
      id: 725,
      emoji: '🥒',
      keywords: {
        en: ['cucumber', 'vegetable', 'green', 'crisp'],
        es: ['pepino', 'vegetal', 'verde', 'crujiente'],
      },
    },
    {
      id: 726,
      emoji: '🥬',
      keywords: {
        en: ['leafy greens', 'vegetable', 'green', 'healthy'],
        es: ['hojas verdes', 'vegetal', 'verde', 'saludable'],
      },
    },
    {
      id: 727,
      emoji: '🥦',
      keywords: {
        en: ['broccoli', 'vegetable', 'green', 'nutrient'],
        es: ['brócoli', 'vegetal', 'verde', 'nutriente'],
      },
    },
    {
      id: 728,
      emoji: '🧄',
      keywords: {
        en: ['garlic', 'spice', 'cooking', 'pungent'],
        es: ['ajo', 'especia', 'cocina', 'fuerte'],
      },
    },
    {
      id: 729,
      emoji: '🧅',
      keywords: {
        en: ['onion', 'vegetable', 'cooking', 'pungent'],
        es: ['cebolla', 'vegetal', 'cocina', 'fuerte'],
      },
    },
    {
      id: 730,
      emoji: '🥜',
      keywords: {
        en: ['peanut', 'nut', 'protein', 'snack'],
        es: ['maní', 'nuez', 'proteína', 'snack'],
      },
    },
    {
      id: 731,
      emoji: '🍘',
      keywords: {
        en: ['rice cracker', 'snack', 'Japanese', 'crispy'],
        es: ['galleta de arroz', 'snack', 'japonés', 'crujiente'],
      },
    },
    {
      id: 732,
      emoji: '🍙',
      keywords: {
        en: ['rice ball', 'Japanese', 'food', 'seaweed'],
        es: ['bola de arroz', 'japonés', 'comida', 'alga'],
      },
    },
    {
      id: 733,
      emoji: '🍚',
      keywords: {
        en: ['cooked rice', 'food', 'Asian', 'grain'],
        es: ['arroz cocido', 'comida', 'asiático', 'grano'],
      },
    },
    {
      id: 734,
      emoji: '🍛',
      keywords: {
        en: ['curry rice', 'food', 'spicy', 'Japanese'],
        es: ['arroz con curry', 'comida', 'picante', 'japonés'],
      },
    },
    {
      id: 735,
      emoji: '🍜',
      keywords: {
        en: ['steaming bowl', 'food', 'noodle', 'soup'],
        es: ['tazón humeante', 'comida', 'fideo', 'sopa'],
      },
    },
    {
      id: 736,
      emoji: '🍝',
      keywords: {
        en: ['spaghetti', 'pasta', 'Italian', 'noodles'],
        es: ['espagueti', 'pasta', 'italiano', 'fideos'],
      },
    },
    {
      id: 737,
      emoji: '🍠',
      keywords: {
        en: ['roasted sweet potato', 'food', 'orange', 'vegetable'],
        es: ['batata asada', 'comida', 'naranja', 'vegetal'],
      },
    },
    {
      id: 738,
      emoji: '🍢',
      keywords: {
        en: ['oden', 'Japanese', 'skewer', 'food'],
        es: ['oden', 'japonés', 'brocheta', 'comida'],
      },
    },
    {
      id: 739,
      emoji: '🍣',
      keywords: {
        en: ['sushi', 'Japanese', 'food', 'fish'],
        es: ['sushi', 'japonés', 'comida', 'pescado'],
      },
    },
    {
      id: 740,
      emoji: '🍤',
      keywords: {
        en: ['fried shrimp', 'seafood', 'tempura', 'Japanese'],
        es: ['camarón frito', 'mariscos', 'tempura', 'japonés'],
      },
    },
    {
      id: 741,
      emoji: '🍥',
      keywords: {
        en: ['fish cake', 'Japanese', 'food', 'swirl'],
        es: ['pastel de pescado', 'japonés', 'comida', 'remolino'],
      },
    },
    {
      id: 742,
      emoji: '🥮',
      keywords: {
        en: ['moon cake', 'Chinese', 'dessert', 'sweet'],
        es: ['pastel de luna', 'chino', 'postre', 'dulce'],
      },
    },
    {
      id: 743,
      emoji: '🍡',
      keywords: {
        en: ['dango', 'Japanese', 'skewer', 'sweet'],
        es: ['dango', 'japonés', 'brocheta', 'dulce'],
      },
    },
    {
      id: 744,
      emoji: '🥟',
      keywords: {
        en: ['dumpling', 'Chinese', 'food', 'filled'],
        es: ['dumpling', 'chino', 'comida', 'relleno'],
      },
    },
    {
      id: 745,
      emoji: '🥠',
      keywords: {
        en: ['fortune cookie', 'Chinese', 'dessert', 'prediction'],
        es: ['galleta de la fortuna', 'chino', 'postre', 'predicción'],
      },
    },
    {
      id: 746,
      emoji: '🥡',
      keywords: {
        en: ['takeout box', 'food', 'Chinese', 'container'],
        es: ['caja de comida para llevar', 'comida', 'chino', 'contenedor'],
      },
    },
    {
      id: 747,
      emoji: '🦀',
      keywords: {
        en: ['crab', 'seafood', 'shellfish', 'claws'],
        es: ['cangrejo', 'mariscos', 'crustáceo', 'pinzas'],
      },
    },
    {
      id: 748,
      emoji: '🦞',
      keywords: {
        en: ['lobster', 'seafood', 'shellfish', 'claws'],
        es: ['langosta', 'mariscos', 'crustáceo', 'pinzas'],
      },
    },
    {
      id: 749,
      emoji: '🦐',
      keywords: {
        en: ['shrimp', 'seafood', 'shellfish', 'tail'],
        es: ['camarón', 'mariscos', 'crustáceo', 'cola'],
      },
    },
    {
      id: 750,
      emoji: '🦑',
      keywords: {
        en: ['squid', 'seafood', 'tentacles', 'ocean'],
        es: ['calamar', 'mariscos', 'tentáculos', 'océano'],
      },
    },
    {
      id: 751,
      emoji: '🦪',
      keywords: {
        en: ['oyster', 'seafood', 'shellfish', 'pearl'],
        es: ['ostra', 'mariscos', 'molusco', 'perla'],
      },
    },
    {
      id: 752,
      emoji: '🍦',
      keywords: {
        en: ['soft ice cream', 'dessert', 'sweet', 'cone'],
        es: ['helado suave', 'postre', 'dulce', 'cono'],
      },
    },
    {
      id: 753,
      emoji: '🍧',
      keywords: {
        en: ['shaved ice', 'dessert', 'cool', 'flavored'],
        es: ['hielo raspado', 'postre', 'frío', 'saborizado'],
      },
    },
    {
      id: 754,
      emoji: '🍨',
      keywords: {
        en: ['ice cream', 'dessert', 'sweet', 'scoop'],
        es: ['helado', 'postre', 'dulce', 'bola'],
      },
    },
    {
      id: 755,
      emoji: '🍩',
      keywords: {
        en: ['doughnut', 'dessert', 'sweet', 'ring'],
        es: ['dona', 'postre', 'dulce', 'anillo'],
      },
    },
    {
      id: 756,
      emoji: '🍪',
      keywords: {
        en: ['cookie', 'dessert', 'chocolate', 'snack'],
        es: ['galleta', 'postre', 'chocolate', 'snack'],
      },
    },
    {
      id: 757,
      emoji: '🎂',
      keywords: {
        en: ['birthday cake', 'celebration', 'dessert', 'candles'],
        es: ['pastel de cumpleaños', 'celebración', 'postre', 'velas'],
      },
    },
    {
      id: 758,
      emoji: '🍰',
      keywords: {
        en: ['shortcake', 'dessert', 'sweet', 'layered'],
        es: ['pastel', 'postre', 'dulce', 'en capas'],
      },
    },
    {
      id: 759,
      emoji: '🧁',
      keywords: {
        en: ['cupcake', 'dessert', 'sweet', 'frosting'],
        es: ['cupcake', 'postre', 'dulce', 'glaseado'],
      },
    },
    {
      id: 760,
      emoji: '🥧',
      keywords: {
        en: ['pie', 'dessert', 'sweet', 'fruit-filled'],
        es: ['tarta', 'postre', 'dulce', 'relleno de fruta'],
      },
    },
    {
      id: 761,
      emoji: '🍫',
      keywords: {
        en: ['chocolate bar', 'dessert', 'sweet', 'cocoa'],
        es: ['barra de chocolate', 'postre', 'dulce', 'cacao'],
      },
    },
    {
      id: 762,
      emoji: '🍬',
      keywords: {
        en: ['candy', 'sweet', 'colorful', 'treat'],
        es: ['dulce', 'caramelo', 'colorido', 'golosina'],
      },
    },
    {
      id: 763,
      emoji: '🍭',
      keywords: {
        en: ['lollipop', 'sweet', 'candy', 'sugar'],
        es: ['paleta', 'dulce', 'caramelo', 'azúcar'],
      },
    },
    {
      id: 764,
      emoji: '🍮',
      keywords: {
        en: ['custard', 'dessert', 'sweet', 'pudding'],
        es: ['flan', 'postre', 'dulce', 'pudín'],
      },
    },
    {
      id: 765,
      emoji: '🍯',
      keywords: {
        en: ['honey pot', 'sweet', 'golden', 'natural'],
        es: ['tarro de miel', 'dulce', 'dorado', 'natural'],
      },
    },
    {
      id: 766,
      emoji: '🍼',
      keywords: {
        en: ['baby bottle', 'milk', 'drink', 'feeding'],
        es: ['biberón', 'leche', 'bebida', 'alimentación'],
      },
    },
    {
      id: 767,
      emoji: '🥛',
      keywords: {
        en: ['glass of milk', 'drink', 'dairy', 'white'],
        es: ['vaso de leche', 'bebida', 'lácteo', 'blanco'],
      },
    },
    {
      id: 768,
      emoji: '☕',
      keywords: {
        en: ['hot beverage', 'drink', 'coffee', 'morning'],
        es: ['bebida caliente', 'bebida', 'café', 'mañana'],
      },
    },
    {
      id: 769,
      emoji: '🫖',
      keywords: {
        en: ['teapot', 'drink', 'tea', 'beverage'],
        es: ['tetera', 'bebida', 'té', 'infusión'],
      },
    },
    {
      id: 770,
      emoji: '🍵',
      keywords: {
        en: ['teacup', 'drink', 'tea', 'hot'],
        es: ['taza de té', 'bebida', 'té', 'caliente'],
      },
    },
    {
      id: 771,
      emoji: '🍶',
      keywords: {
        en: ['sake', 'drink', 'Japanese', 'alcohol'],
        es: ['sake', 'bebida', 'japonés', 'alcohol'],
      },
    },
    {
      id: 772,
      emoji: '🍾',
      keywords: {
        en: ['bottle with popping cork', 'celebration', 'drink', 'champagne'],
        es: ['botella descorchándose', 'celebración', 'bebida', 'champaña'],
      },
    },
    {
      id: 773,
      emoji: '🍷',
      keywords: {
        en: ['wine glass', 'drink', 'red wine', 'alcohol'],
        es: ['copa de vino', 'bebida', 'vino tinto', 'alcohol'],
      },
    },
    {
      id: 774,
      emoji: '🍸',
      keywords: {
        en: ['cocktail glass', 'drink', 'martini', 'alcohol'],
        es: ['copa de cóctel', 'bebida', 'martini', 'alcohol'],
      },
    },
    {
      id: 775,
      emoji: '🍹',
      keywords: {
        en: ['tropical drink', 'beach', 'alcohol', 'umbrella'],
        es: ['bebida tropical', 'playa', 'alcohol', 'sombrilla'],
      },
    },
    {
      id: 776,
      emoji: '🍺',
      keywords: {
        en: ['beer mug', 'drink', 'beer', 'alcohol'],
        es: ['jarra de cerveza', 'bebida', 'cerveza', 'alcohol'],
      },
    },
    {
      id: 777,
      emoji: '🍻',
      keywords: {
        en: ['clinking beer mugs', 'drink', 'beer', 'celebration'],
        es: ['jarras de cerveza brindando', 'bebida', 'cerveza', 'celebración'],
      },
    },
    {
      id: 778,
      emoji: '🥂',
      keywords: {
        en: ['clinking glasses', 'drink', 'cheers', 'celebration'],
        es: ['copas brindando', 'bebida', 'salud', 'celebración'],
      },
    },
    {
      id: 779,
      emoji: '🥃',
      keywords: {
        en: ['tumbler glass', 'drink', 'whiskey', 'alcohol'],
        es: ['vaso bajo', 'bebida', 'whisky', 'alcohol'],
      },
    },
    {
      id: 780,
      emoji: '🫗',
      keywords: {
        en: ['teapot with steaming cup', 'drink', 'tea', 'beverage'],
        es: ['tetera con taza humeante', 'bebida', 'té', 'infusión'],
      },
    },
    {
      id: 781,
      emoji: '🥤',
      keywords: {
        en: ['cup with straw', 'drink', 'beverage', 'refreshing'],
        es: ['vaso con pitillo', 'bebida', 'refresco', 'refrescante'],
      },
    },
    {
      id: 782,
      emoji: '🧋',
      keywords: {
        en: ['bubble tea', 'drink', 'tea', 'tapioca'],
        es: ['té de burbujas', 'bebida', 'té', 'tapioca'],
      },
    },
    {
      id: 783,
      emoji: '🧃',
      keywords: {
        en: ['beverage box', 'drink', 'juice', 'straw'],
        es: ['caja de bebida', 'bebida', 'jugo', 'pitillo'],
      },
    },
    {
      id: 784,
      emoji: '🧉',
      keywords: {
        en: ['mate', 'drink', 'beverage', 'herbal'],
        es: ['mate', 'bebida', 'infusión', 'hierbas'],
      },
    },
    {
      id: 785,
      emoji: '🧊',
      keywords: {
        en: ['ice', 'frozen', 'cool', 'cube'],
        es: ['hielo', 'congelado', 'frío', 'cubo'],
      },
    },
    {
      id: 786,
      emoji: '🥢',
      keywords: {
        en: ['chopsticks', 'food', 'Asian', 'eating'],
        es: ['palillos', 'comida', 'asiático', 'comer'],
      },
    },
    {
      id: 787,
      emoji: '🍽️',
      keywords: {
        en: ['fork and knife with plate', 'eating', 'utensils', 'dining'],
        es: ['tenedor y cuchillo con plato', 'comer', 'utensilios', 'comida'],
      },
    },
    {
      id: 788,
      emoji: '🍴',
      keywords: {
        en: ['fork and knife', 'utensils', 'cutlery', 'eating'],
        es: ['tenedor y cuchillo', 'utensilios', 'cubiertos', 'comer'],
      },
    },
    {
      id: 789,
      emoji: '🥄',
      keywords: {
        en: ['spoon', 'utensil', 'eating', 'scooping'],
        es: ['cuchara', 'utensilio', 'comer', 'servir'],
      },
    },
    {
      id: 790,
      emoji: '🔪',
      keywords: {
        en: ['kitchen knife', 'utensil', 'cutting', 'cooking'],
        es: ['cuchillo de cocina', 'utensilio', 'cortar', 'cocinar'],
      },
    },
    {
      id: 791,
      emoji: '🫙',
      keywords: {
        en: ['amphora', 'vase', 'container', 'ancient'],
        es: ['ánfora', 'jarrón', 'contenedor', 'antiguo'],
      },
    },
    {
      id: 792,
      emoji: '🏺',
      keywords: {
        en: ['amphora', 'vase', 'container', 'ancient'],
        es: ['ánfora', 'jarrón', 'contenedor', 'antiguo'],
      },
    },
  ],
  actividades: [
    {
      id: 793,
      emoji: '🎃',
      keywords: {
        en: ['jack-o-lantern', 'Halloween', 'pumpkin', 'spooky'],
        es: ['calabaza de Halloween', 'Halloween', 'calabaza', 'espeluznante'],
      },
    },
    {
      id: 794,
      emoji: '🎄',
      keywords: {
        en: ['Christmas tree', 'holiday', 'festive', 'decorations'],
        es: ['árbol de Navidad', 'festividad', 'festivo', 'decoraciones'],
      },
    },
    {
      id: 795,
      emoji: '🎆',
      keywords: {
        en: ['fireworks', 'celebration', 'sky', 'event'],
        es: ['fuegos artificiales', 'celebración', 'cielo', 'evento'],
      },
    },
    {
      id: 796,
      emoji: '🎇',
      keywords: {
        en: ['sparkler', 'celebration', 'fire', 'festive'],
        es: ['bengala', 'celebración', 'fuego', 'festivo'],
      },
    },
    {
      id: 797,
      emoji: '🧨',
      keywords: {
        en: ['firecracker', 'explosion', 'celebration', 'festive'],
        es: ['petardo', 'explosión', 'celebración', 'festivo'],
      },
    },
    {
      id: 798,
      emoji: '✨',
      keywords: {
        en: ['sparkles', 'magic', 'shiny', 'glitter'],
        es: ['destellos', 'magia', 'brillante', 'brillo'],
      },
    },
    {
      id: 799,
      emoji: '🎈',
      keywords: {
        en: ['balloon', 'celebration', 'party', 'colorful'],
        es: ['globo', 'celebración', 'fiesta', 'colorido'],
      },
    },
    {
      id: 800,
      emoji: '🎉',
      keywords: {
        en: ['party popper', 'celebration', 'confetti', 'happy'],
        es: ['confeti de fiesta', 'celebración', 'confeti', 'feliz'],
      },
    },
    {
      id: 801,
      emoji: '🎊',
      keywords: {
        en: ['confetti ball', 'celebration', 'party', 'happy'],
        es: ['bola de confeti', 'celebración', 'fiesta', 'feliz'],
      },
    },
    {
      id: 802,
      emoji: '🎋',
      keywords: {
        en: ['tanabata tree', 'Japanese', 'celebration', 'wish'],
        es: ['árbol de tanabata', 'japonés', 'celebración', 'deseo'],
      },
    },
    {
      id: 803,
      emoji: '🎍',
      keywords: {
        en: ['pine decoration', 'Japanese', 'celebration', 'new year'],
        es: ['decoración de pino', 'japonés', 'celebración', 'año nuevo'],
      },
    },
    {
      id: 804,
      emoji: '🎎',
      keywords: {
        en: ['Japanese doll', 'celebration', 'hinamatsuri', 'girls day'],
        es: ['muñeca japonesa', 'celebración', 'hinamatsuri', 'día de las niñas'],
      },
    },
    {
      id: 805,
      emoji: '🎏',
      keywords: {
        en: ['carp streamer', 'Japanese', 'celebration', 'childrens day'],
        es: ['banderín de carpa', 'japonés', 'celebración', 'día de los niños'],
      },
    },
    {
      id: 806,
      emoji: '🎐',
      keywords: {
        en: ['wind chime', 'Japanese', 'summer', 'sound'],
        es: ['campana de viento', 'japonés', 'verano', 'sonido'],
      },
    },
    {
      id: 807,
      emoji: '🎑',
      keywords: {
        en: ['moon viewing ceremony', 'Japanese', 'celebration', 'autumn'],
        es: ['ceremonia de contemplación lunar', 'japonés', 'celebración', 'otoño'],
      },
    },
    {
      id: 808,
      emoji: '🧧',
      keywords: {
        en: ['red envelope', 'Chinese', 'celebration', 'gift'],
        es: ['sobre rojo', 'chino', 'celebración', 'regalo'],
      },
    },
    {
      id: 809,
      emoji: '🎀',
      keywords: {
        en: ['ribbon', 'decoration', 'gift', 'bow'],
        es: ['cinta', 'decoración', 'regalo', 'lazo'],
      },
    },
    {
      id: 810,
      emoji: '🎁',
      keywords: {
        en: ['gift', 'present', 'celebration', 'wrapped'],
        es: ['regalo', 'presente', 'celebración', 'envuelto'],
      },
    },
    {
      id: 811,
      emoji: '🎗️',
      keywords: {
        en: ['reminder ribbon', 'awareness', 'cause', 'support'],
        es: ['cinta conmemorativa', 'conciencia', 'causa', 'apoyo'],
      },
    },
    {
      id: 812,
      emoji: '🎟️',
      keywords: {
        en: ['admission ticket', 'event', 'concert', 'entry'],
        es: ['boleto de entrada', 'evento', 'concierto', 'entrada'],
      },
    },
    {
      id: 813,
      emoji: '🎫',
      keywords: {
        en: ['ticket', 'admission', 'concert', 'event'],
        es: ['boleto', 'entrada', 'concierto', 'evento'],
      },
    },
    {
      id: 814,
      emoji: '🎖️',
      keywords: {
        en: ['medal', 'award', 'achievement', 'honor'],
        es: ['medalla', 'premio', 'logro', 'honor'],
      },
    },
    {
      id: 815,
      emoji: '🏆',
      keywords: {
        en: ['trophy', 'award', 'winner', 'competition'],
        es: ['trofeo', 'premio', 'ganador', 'competencia'],
      },
    },
    {
      id: 816,
      emoji: '🏅',
      keywords: {
        en: ['medal', 'award', 'achievement', 'winner'],
        es: ['medalla', 'premio', 'logro', 'ganador'],
      },
    },
    {
      id: 817,
      emoji: '🥇',
      keywords: {
        en: ['1st place medal', 'gold', 'winner', 'achievement'],
        es: ['medalla de primer lugar', 'oro', 'ganador', 'logro'],
      },
    },
    {
      id: 818,
      emoji: '🥈',
      keywords: {
        en: ['2nd place medal', 'silver', 'second', 'achievement'],
        es: ['medalla de segundo lugar', 'plata', 'segundo', 'logro'],
      },
    },
    {
      id: 819,
      emoji: '🥉',
      keywords: {
        en: ['3rd place medal', 'bronze', 'third', 'achievement'],
        es: ['medalla de tercer lugar', 'bronce', 'tercero', 'logro'],
      },
    },
    {
      id: 820,
      emoji: '⚽',
      keywords: {
        en: ['soccer ball', 'football', 'sports', 'game'],
        es: ['balón de fútbol', 'fútbol', 'deportes', 'juego'],
      },
    },
    {
      id: 821,
      emoji: '⚾',
      keywords: {
        en: ['baseball', 'sports', 'game', 'bat'],
        es: ['béisbol', 'deportes', 'juego', 'bate'],
      },
    },
    {
      id: 822,
      emoji: '🥎',
      keywords: {
        en: ['softball', 'sports', 'game', 'pitch'],
        es: ['softbol', 'deportes', 'juego', 'lanzamiento'],
      },
    },
    {
      id: 823,
      emoji: '🏀',
      keywords: {
        en: ['basketball', 'sports', 'hoop', 'game'],
        es: ['baloncesto', 'deportes', 'aro', 'juego'],
      },
    },
    {
      id: 824,
      emoji: '🏐',
      keywords: {
        en: ['volleyball', 'sports', 'game', 'beach'],
        es: ['voleibol', 'deportes', 'juego', 'playa'],
      },
    },
    {
      id: 825,
      emoji: '🏈',
      keywords: {
        en: ['american football', 'sports', 'game', 'NFL'],
        es: ['fútbol americano', 'deportes', 'juego', 'NFL'],
      },
    },
    {
      id: 826,
      emoji: '🏉',
      keywords: {
        en: ['rugby football', 'sports', 'game', 'ball'],
        es: ['rugby', 'deportes', 'juego', 'balón'],
      },
    },
    {
      id: 827,
      emoji: '🎾',
      keywords: {
        en: ['tennis', 'sports', 'racket', 'ball'],
        es: ['tenis', 'deportes', 'raqueta', 'pelota'],
      },
    },
    {
      id: 828,
      emoji: '🥏',
      keywords: {
        en: ['flying disc', 'sports', 'game', 'frisbee'],
        es: ['disco volador', 'deportes', 'juego', 'frisbee'],
      },
    },
    {
      id: 829,
      emoji: '🎳',
      keywords: {
        en: ['bowling', 'sports', 'game', 'pins'],
        es: ['bolos', 'deportes', 'juego', 'pinos'],
      },
    },
    {
      id: 830,
      emoji: '🏏',
      keywords: {
        en: ['cricket', 'sports', 'game', 'bat'],
        es: ['críquet', 'deportes', 'juego', 'bate'],
      },
    },
    {
      id: 831,
      emoji: '🏑',
      keywords: {
        en: ['field hockey', 'sports', 'game', 'stick'],
        es: ['hockey sobre césped', 'deportes', 'juego', 'palo'],
      },
    },
    {
      id: 832,
      emoji: '🏒',
      keywords: {
        en: ['ice hockey', 'sports', 'game', 'puck'],
        es: ['hockey sobre hielo', 'deportes', 'juego', 'disco'],
      },
    },
    {
      id: 833,
      emoji: '🥍',
      keywords: {
        en: ['lacrosse', 'sports', 'game', 'stick'],
        es: ['lacrosse', 'deportes', 'juego', 'palo'],
      },
    },
    {
      id: 834,
      emoji: '🏓',
      keywords: {
        en: ['ping pong', 'sports', 'table tennis', 'game'],
        es: ['ping pong', 'deportes', 'tenis de mesa', 'juego'],
      },
    },
    {
      id: 835,
      emoji: '🏸',
      keywords: {
        en: ['badminton', 'sports', 'game', 'racket'],
        es: ['bádminton', 'deportes', 'juego', 'raqueta'],
      },
    },
    {
      id: 836,
      emoji: '🥊',
      keywords: {
        en: ['boxing glove', 'sports', 'fight', 'punch'],
        es: ['guante de boxeo', 'deportes', 'pelea', 'golpe'],
      },
    },
    {
      id: 837,
      emoji: '🥋',
      keywords: {
        en: ['martial arts uniform', 'sports', 'karate', 'judo'],
        es: ['uniforme de artes marciales', 'deportes', 'karate', 'judo'],
      },
    },
    {
      id: 838,
      emoji: '🥅',
      keywords: {
        en: ['goal net', 'sports', 'hockey', 'soccer'],
        es: ['red de gol', 'deportes', 'hockey', 'fútbol'],
      },
    },
    {
      id: 839,
      emoji: '⛳',
      keywords: {
        en: ['golf hole', 'sports', 'game', 'putt'],
        es: ['hoyo de golf', 'deportes', 'juego', 'golpe corto'],
      },
    },
    {
      id: 840,
      emoji: '⛸️',
      keywords: {
        en: ['ice skate', 'sports', 'winter', 'cold'],
        es: ['patín de hielo', 'deportes', 'invierno', 'frío'],
      },
    },
    {
      id: 841,
      emoji: '🎣',
      keywords: {
        en: ['fishing pole', 'hobby', 'catch', 'outdoors'],
        es: ['caña de pescar', 'pasatiempo', 'pesca', 'aire libre'],
      },
    },
    {
      id: 842,
      emoji: '🤿',
      keywords: {
        en: ['diving mask', 'snorkel', 'underwater', 'ocean'],
        es: ['máscara de buceo', 'snorkel', 'bajo el agua', 'océano'],
      },
    },
    {
      id: 843,
      emoji: '🎽',
      keywords: {
        en: ['running shirt', 'sports', 'athletic', 'fitness'],
        es: ['camiseta de correr', 'deportes', 'atlético', 'fitness'],
      },
    },
    {
      id: 844,
      emoji: '🎿',
      keywords: {
        en: ['skis', 'winter', 'sports', 'cold'],
        es: ['esquís', 'invierno', 'deportes', 'frío'],
      },
    },
    {
      id: 845,
      emoji: '🛷',
      keywords: {
        en: ['sled', 'winter', 'snow', 'ride'],
        es: ['trineo', 'invierno', 'nieve', 'paseo'],
      },
    },
    {
      id: 846,
      emoji: '🥌',
      keywords: {
        en: ['curling stone', 'sports', 'game', 'winter'],
        es: ['piedra de curling', 'deportes', 'juego', 'invierno'],
      },
    },
    {
      id: 847,
      emoji: '🎯',
      keywords: {
        en: ['bullseye', 'target', 'game', 'dart'],
        es: ['diana', 'objetivo', 'juego', 'dardo'],
      },
    },
    {
      id: 848,
      emoji: '🪀',
      keywords: {
        en: ['yo-yo', 'toy', 'play', 'string'],
        es: ['yo-yo', 'juguete', 'jugar', 'cuerda'],
      },
    },
    {
      id: 849,
      emoji: '🪁',
      keywords: {
        en: ['kite', 'toy', 'wind', 'fly'],
        es: ['cometa', 'juguete', 'viento', 'volar'],
      },
    },
    {
      id: 850,
      emoji: '🔫',
      keywords: {
        en: ['water gun', 'toy', 'play', 'squirt'],
        es: ['pistola de agua', 'juguete', 'jugar', 'chorro'],
      },
    },
    {
      id: 851,
      emoji: '🎱',
      keywords: {
        en: ['pool 8 ball', 'game', 'billiards', 'cue'],
        es: ['bola 8 de billar', 'juego', 'billar', 'taco'],
      },
    },
    {
      id: 852,
      emoji: '🔮',
      keywords: {
        en: ['crystal ball', 'fortune', 'magic', 'mystical'],
        es: ['bola de cristal', 'fortuna', 'magia', 'místico'],
      },
    },
    {
      id: 853,
      emoji: '🪄',
      keywords: {
        en: ['magic wand', 'wizard', 'spell', 'enchant'],
        es: ['varita mágica', 'mago', 'hechizo', 'encantar'],
      },
    },
    {
      id: 854,
      emoji: '🎮',
      keywords: {
        en: ['video game', 'play', 'controller', 'console'],
        es: ['videojuego', 'jugar', 'control', 'consola'],
      },
    },
    {
      id: 855,
      emoji: '🕹️',
      keywords: {
        en: ['joystick', 'game', 'play', 'controller'],
        es: ['joystick', 'juego', 'jugar', 'control'],
      },
    },
    {
      id: 856,
      emoji: '🎰',
      keywords: {
        en: ['slot machine', 'gambling', 'bet', 'luck'],
        es: ['máquina tragamonedas', 'apuesta', 'azar', 'suerte'],
      },
    },
    {
      id: 857,
      emoji: '🎲',
      keywords: {
        en: ['game die', 'gambling', 'luck', 'roll'],
        es: ['dado', 'apuesta', 'suerte', 'tirar'],
      },
    },
    {
      id: 858,
      emoji: '🧩',
      keywords: {
        en: ['jigsaw puzzle', 'game', 'puzzle', 'pieces'],
        es: ['rompecabezas', 'juego', 'puzzle', 'piezas'],
      },
    },
    {
      id: 859,
      emoji: '🧸',
      keywords: {
        en: ['teddy bear', 'toy', 'cuddly', 'plush'],
        es: ['oso de peluche', 'juguete', 'tierno', 'peluche'],
      },
    },
    {
      id: 860,
      emoji: '🪅',
      keywords: {
        en: ['piñata', 'celebration', 'party', 'candy'],
        es: ['piñata', 'celebración', 'fiesta', 'dulces'],
      },
    },
    {
      id: 861,
      emoji: '🪩',
      keywords: {
        en: ['accordion', 'music', 'instrument', 'squeezebox'],
        es: ['acordeón', 'música', 'instrumento', 'concertina'],
      },
    },
    {
      id: 862,
      emoji: '🪆',
      keywords: {
        en: ['carp streamer', 'Japanese', 'celebration', 'childrens day'],
        es: ['banderín de carpa', 'japonés', 'celebración', 'día de los niños'],
      },
    },
    {
      id: 863,
      emoji: '♠️',
      keywords: {
        en: ['spade suit', 'playing card', 'cards', 'game'],
        es: ['palo de picas', 'carta de juego', 'cartas', 'juego'],
      },
    },
    {
      id: 864,
      emoji: '♥️',
      keywords: {
        en: ['heart suit', 'playing card', 'cards', 'game'],
        es: ['palo de corazones', 'carta de juego', 'cartas', 'juego'],
      },
    },
    {
      id: 865,
      emoji: '♦️',
      keywords: {
        en: ['diamond suit', 'playing card', 'cards', 'game'],
        es: ['palo de diamantes', 'carta de juego', 'cartas', 'juego'],
      },
    },
    {
      id: 866,
      emoji: '♣️',
      keywords: {
        en: ['club suit', 'playing card', 'cards', 'game'],
        es: ['palo de tréboles', 'carta de juego', 'cartas', 'juego'],
      },
    },
    {
      id: 867,
      emoji: '♟️',
      keywords: {
        en: ['chess pawn', 'game', 'board', 'strategy'],
        es: ['peón de ajedrez', 'juego', 'tablero', 'estrategia'],
      },
    },
    {
      id: 868,
      emoji: '🃏',
      keywords: {
        en: ['joker', 'playing card', 'cards', 'game'],
        es: ['comodín', 'carta de juego', 'cartas', 'juego'],
      },
    },
    {
      id: 869,
      emoji: '🀄',
      keywords: {
        en: ['mahjong red dragon', 'game', 'tiles', 'Chinese'],
        es: ['dragón rojo de mahjong', 'juego', 'fichas', 'chino'],
      },
    },
    {
      id: 870,
      emoji: '🎴',
      keywords: {
        en: ['flower playing cards', 'game', 'hanafuda', 'Japanese'],
        es: ['cartas de flores', 'juego', 'hanafuda', 'japonés'],
      },
    },
    {
      id: 871,
      emoji: '🎭',
      keywords: {
        en: ['performing arts', 'entertainment', 'theater', 'mask'],
        es: ['artes escénicas', 'entretenimiento', 'teatro', 'máscara'],
      },
    },
    {
      id: 872,
      emoji: '🖼️',
      keywords: {
        en: ['framed picture', 'art', 'gallery', 'display'],
        es: ['cuadro enmarcado', 'arte', 'galería', 'exhibición'],
      },
    },
    {
      id: 873,
      emoji: '🎨',
      keywords: {
        en: ['artist palette', 'art', 'painting', 'colors'],
        es: ['paleta de artista', 'arte', 'pintura', 'colores'],
      },
    },
    {
      id: 874,
      emoji: '🧵',
      keywords: {
        en: ['thread and needle', 'sewing', 'craft', 'fabric'],
        es: ['hilo y aguja', 'costura', 'manualidad', 'tela'],
      },
    },
    {
      id: 875,
      emoji: '🪡',
      keywords: {
        en: ['sewing needle', 'craft', 'fabric', 'textile'],
        es: ['aguja de coser', 'manualidad', 'tela', 'textil'],
      },
    },
    {
      id: 876,
      emoji: '🧶',
      keywords: {
        en: ['yarn', 'knitting', 'craft', 'textile'],
        es: ['lana', 'tejido', 'manualidad', 'textil'],
      },
    },
    {
      id: 877,
      emoji: '🪢',
      keywords: {
        en: ['knot', 'rope', 'tie', 'bind'],
        es: ['nudo', 'cuerda', 'atar', 'amarrar'],
      },
    },
    {
      id: 878,
      emoji: '🏃',
      keywords: {
        en: ['person running', 'exercise', 'jogging', 'fitness'],
        es: ['persona corriendo', 'ejercicio', 'trote', 'fitness'],
      },
    },
    {
      id: 879,
      emoji: '🏃‍♂️',
      keywords: {
        en: ['man running', 'exercise', 'jogging', 'fitness'],
        es: ['hombre corriendo', 'ejercicio', 'trote', 'fitness'],
      },
    },
    {
      id: 880,
      emoji: '🏃‍♀️',
      keywords: {
        en: ['woman running', 'exercise', 'jogging', 'fitness'],
        es: ['mujer corriendo', 'ejercicio', 'trote', 'fitness'],
      },
    },
    {
      id: 881,
      emoji: '🚶',
      keywords: {
        en: ['person walking', 'stroll', 'exercise', 'movement'],
        es: ['persona caminando', 'paseo', 'ejercicio', 'movimiento'],
      },
    },
    {
      id: 882,
      emoji: '🚶‍♂️',
      keywords: {
        en: ['man walking', 'stroll', 'exercise', 'movement'],
        es: ['hombre caminando', 'paseo', 'ejercicio', 'movimiento'],
      },
    },
    {
      id: 883,
      emoji: '🚶‍♀️',
      keywords: {
        en: ['woman walking', 'stroll', 'exercise', 'movement'],
        es: ['mujer caminando', 'paseo', 'ejercicio', 'movimiento'],
      },
    },
    {
      id: 884,
      emoji: '💇',
      keywords: {
        en: ['person getting haircut', 'hair', 'salon', 'beauty'],
        es: ['persona cortándose el cabello', 'cabello', 'salón', 'belleza'],
      },
    },
    {
      id: 885,
      emoji: '💇‍♂️',
      keywords: {
        en: ['man getting haircut', 'hair', 'salon', 'beauty'],
        es: ['hombre cortándose el cabello', 'cabello', 'salón', 'belleza'],
      },
    },
    {
      id: 886,
      emoji: '💇‍♀️',
      keywords: {
        en: ['woman getting haircut', 'hair', 'salon', 'beauty'],
        es: ['mujer cortándose el cabello', 'cabello', 'salón', 'belleza'],
      },
    },
    {
      id: 887,
      emoji: '🕴️',
      keywords: {
        en: ['man in suit levitating', 'suit', 'business', 'cool'],
        es: ['hombre con traje levitando', 'traje', 'negocios', 'genial'],
      },
    },
    {
      id: 888,
      emoji: '👯',
      keywords: {
        en: ['people with bunny ears', 'dancers', 'party', 'celebration'],
        es: ['personas con orejas de conejo', 'bailarines', 'fiesta', 'celebración'],
      },
    },
    {
      id: 889,
      emoji: '👯‍♂️',
      keywords: {
        en: ['men with bunny ears', 'dancers', 'party', 'celebration'],
        es: ['hombres con orejas de conejo', 'bailarines', 'fiesta', 'celebración'],
      },
    },
    {
      id: 890,
      emoji: '👯‍♀️',
      keywords: {
        en: ['women with bunny ears', 'dancers', 'party', 'celebration'],
        es: ['mujeres con orejas de conejo', 'bailarinas', 'fiesta', 'celebración'],
      },
    },
    {
      id: 891,
      emoji: '🧖',
      keywords: {
        en: ['person in steamy room', 'spa', 'relax', 'sauna'],
        es: ['persona en sauna', 'spa', 'relajación', 'sauna'],
      },
    },
    {
      id: 892,
      emoji: '🧖‍♂️',
      keywords: {
        en: ['man in steamy room', 'spa', 'relax', 'sauna'],
        es: ['hombre en sauna', 'spa', 'relajación', 'sauna'],
      },
    },
    {
      id: 893,
      emoji: '🧖‍♀️',
      keywords: {
        en: ['woman in steamy room', 'spa', 'relax', 'sauna'],
        es: ['mujer en sauna', 'spa', 'relajación', 'sauna'],
      },
    },
    {
      id: 894,
      emoji: '🧗',
      keywords: {
        en: ['person climbing', 'rock climbing', 'adventure', 'sports'],
        es: ['persona escalando', 'escalada en roca', 'aventura', 'deportes'],
      },
    },
    {
      id: 895,
      emoji: '🧗‍♂️',
      keywords: {
        en: ['man climbing', 'rock climbing', 'adventure', 'sports'],
        es: ['hombre escalando', 'escalada en roca', 'aventura', 'deportes'],
      },
    },
    {
      id: 896,
      emoji: '🧗‍♀️',
      keywords: {
        en: ['woman climbing', 'rock climbing', 'adventure', 'sports'],
        es: ['mujer escalando', 'escalada en roca', 'aventura', 'deportes'],
      },
    },
    {
      id: 897,
      emoji: '🤺',
      keywords: {
        en: ['person fencing', 'sword', 'combat', 'sport'],
        es: ['persona practicando esgrima', 'espada', 'combate', 'deporte'],
      },
    },
    {
      id: 898,
      emoji: '🏇',
      keywords: {
        en: ['horse racing', 'jockey', 'race', 'competition'],
        es: ['carrera de caballos', 'jinete', 'carrera', 'competencia'],
      },
    },
    {
      id: 899,
      emoji: '⛷️',
      keywords: {
        en: ['skier', 'winter', 'sports', 'snow'],
        es: ['esquiador', 'invierno', 'deportes', 'nieve'],
      },
    },
    {
      id: 900,
      emoji: '🏂',
      keywords: {
        en: ['snowboarder', 'winter', 'sports', 'snow'],
        es: ['snowboarder', 'invierno', 'deportes', 'nieve'],
      },
    },
    {
      id: 901,
      emoji: '🏌️',
      keywords: {
        en: ['person golfing', 'golf', 'sports', 'swing'],
        es: ['persona jugando golf', 'golf', 'deportes', 'swing'],
      },
    },
    {
      id: 902,
      emoji: '🏌️‍♂️',
      keywords: {
        en: ['man golfing', 'golf', 'sports', 'swing'],
        es: ['hombre jugando golf', 'golf', 'deportes', 'swing'],
      },
    },
    {
      id: 903,
      emoji: '🏌️‍♀️',
      keywords: {
        en: ['woman golfing', 'golf', 'sports', 'swing'],
        es: ['mujer jugando golf', 'golf', 'deportes', 'swing'],
      },
    },
    {
      id: 904,
      emoji: '🏄',
      keywords: {
        en: ['person surfing', 'surfboard', 'ocean', 'wave'],
        es: ['persona surfeando', 'tabla de surf', 'océano', 'ola'],
      },
    },
    {
      id: 905,
      emoji: '🏄‍♂️',
      keywords: {
        en: ['man surfing', 'surfboard', 'ocean', 'wave'],
        es: ['hombre surfeando', 'tabla de surf', 'océano', 'ola'],
      },
    },
    {
      id: 906,
      emoji: '🏄‍♀️',
      keywords: {
        en: ['woman surfing', 'surfboard', 'ocean', 'wave'],
        es: ['mujer surfeando', 'tabla de surf', 'océano', 'ola'],
      },
    },
    {
      id: 907,
      emoji: '🚣',
      keywords: {
        en: ['person rowing boat', 'rowing', 'sports', 'water'],
        es: ['persona remando', 'remo', 'deportes', 'agua'],
      },
    },
    {
      id: 908,
      emoji: '🚣‍♂️',
      keywords: {
        en: ['rowing', 'boat', 'man', 'water'],
        es: ['remo', 'bote', 'hombre', 'agua'],
      },
    },
    {
      id: 909,
      emoji: '🚣‍♀️',
      keywords: {
        en: ['rowing', 'boat', 'woman', 'water'],
        es: ['remo', 'bote', 'mujer', 'agua'],
      },
    },
    {
      id: 910,
      emoji: '🏊',
      keywords: {
        en: ['swimming', 'pool', 'water', 'exercise'],
        es: ['natación', 'piscina', 'agua', 'ejercicio'],
      },
    },
    {
      id: 911,
      emoji: '🏊‍♂️',
      keywords: {
        en: ['swimming', 'pool', 'man', 'exercise'],
        es: ['natación', 'piscina', 'hombre', 'ejercicio'],
      },
    },
    {
      id: 912,
      emoji: '🏊‍♀️',
      keywords: {
        en: ['swimming', 'pool', 'woman', 'exercise'],
        es: ['natación', 'piscina', 'mujer', 'ejercicio'],
      },
    },
    {
      id: 913,
      emoji: '⛹️',
      keywords: {
        en: ['basketball', 'sport', 'ball', 'player'],
        es: ['baloncesto', 'deporte', 'balón', 'jugador'],
      },
    },
    {
      id: 914,
      emoji: '⛹️‍♂️',
      keywords: {
        en: ['basketball', 'sport', 'ball', 'man'],
        es: ['baloncesto', 'deporte', 'balón', 'hombre'],
      },
    },
    {
      id: 915,
      emoji: '⛹️‍♀️',
      keywords: {
        en: ['basketball', 'sport', 'ball', 'woman'],
        es: ['baloncesto', 'deporte', 'balón', 'mujer'],
      },
    },
    {
      id: 916,
      emoji: '🏋️',
      keywords: {
        en: ['weightlifting', 'gym', 'lifting', 'exercise'],
        es: ['levantamiento de pesas', 'gimnasio', 'levantando', 'ejercicio'],
      },
    },
    {
      id: 917,
      emoji: '🏋️‍♂️',
      keywords: {
        en: ['weightlifting', 'gym', 'lifting', 'man'],
        es: ['levantamiento de pesas', 'gimnasio', 'levantando', 'hombre'],
      },
    },
    {
      id: 918,
      emoji: '🏋️‍♀️',
      keywords: {
        en: ['weightlifting', 'gym', 'lifting', 'woman'],
        es: ['levantamiento de pesas', 'gimnasio', 'levantando', 'mujer'],
      },
    },
    {
      id: 919,
      emoji: '🚴',
      keywords: {
        en: ['biking', 'bicycle', 'exercise', 'ride'],
        es: ['ciclismo', 'bicicleta', 'ejercicio', 'paseo'],
      },
    },
    {
      id: 920,
      emoji: '🚴‍♂️',
      keywords: {
        en: ['biking', 'bicycle', 'exercise', 'man'],
        es: ['ciclismo', 'bicicleta', 'ejercicio', 'hombre'],
      },
    },
    {
      id: 921,
      emoji: '🚴‍♀️',
      keywords: {
        en: ['biking', 'bicycle', 'exercise', 'woman'],
        es: ['ciclismo', 'bicicleta', 'ejercicio', 'mujer'],
      },
    },
    {
      id: 922,
      emoji: '🚵',
      keywords: {
        en: ['mountain biking', 'bicycle', 'exercise', 'outdoor'],
        es: ['ciclismo de montaña', 'bicicleta', 'ejercicio', 'aire libre'],
      },
    },
    {
      id: 923,
      emoji: '🚵‍♂️',
      keywords: {
        en: ['mountain biking', 'bicycle', 'exercise', 'man'],
        es: ['ciclismo de montaña', 'bicicleta', 'ejercicio', 'hombre'],
      },
    },
    {
      id: 924,
      emoji: '🚵‍♀️',
      keywords: {
        en: ['mountain biking', 'bicycle', 'exercise', 'woman'],
        es: ['ciclismo de montaña', 'bicicleta', 'ejercicio', 'mujer'],
      },
    },
    {
      id: 925,
      emoji: '🤸',
      keywords: {
        en: ['gymnastics', 'balance', 'flexible', 'acrobat'],
        es: ['gimnasia', 'equilibrio', 'flexible', 'acróbata'],
      },
    },
    {
      id: 926,
      emoji: '🤸‍♂️',
      keywords: {
        en: ['gymnastics', 'balance', 'flexible', 'acrobat'],
        es: ['gimnasia', 'equilibrio', 'flexible', 'acróbata'],
      },
    },
    {
      id: 927,
      emoji: '🤸‍♀️',
      keywords: {
        en: ['gymnastics', 'balance', 'flexible', 'acrobat'],
        es: ['gimnasia', 'equilibrio', 'flexible', 'acróbata'],
      },
    },
    {
      id: 928,
      emoji: '🤼',
      keywords: {
        en: ['wrestling', 'combat', 'sport', 'fight'],
        es: ['lucha', 'combate', 'deporte', 'pelea'],
      },
    },
    {
      id: 929,
      emoji: '🤼‍♂️',
      keywords: {
        en: ['wrestling', 'combat', 'sport', 'fight'],
        es: ['lucha', 'combate', 'deporte', 'pelea'],
      },
    },
    {
      id: 930,
      emoji: '🤼‍♀️',
      keywords: {
        en: ['wrestling', 'combat', 'sport', 'fight'],
        es: ['lucha', 'combate', 'deporte', 'pelea'],
      },
    },
    {
      id: 931,
      emoji: '🤽',
      keywords: {
        en: ['water polo', 'sport', 'ball', 'pool'],
        es: ['waterpolo', 'deporte', 'balón', 'piscina'],
      },
    },
    {
      id: 932,
      emoji: '🤽‍♂️',
      keywords: {
        en: ['water polo', 'sport', 'ball', 'pool'],
        es: ['waterpolo', 'deporte', 'balón', 'piscina'],
      },
    },
    {
      id: 933,
      emoji: '🤽‍♀️',
      keywords: {
        en: ['water polo', 'sport', 'ball', 'pool'],
        es: ['waterpolo', 'deporte', 'balón', 'piscina'],
      },
    },
    {
      id: 934,
      emoji: '🤾',
      keywords: {
        en: ['handball', 'sport', 'ball', 'team'],
        es: ['balonmano', 'deporte', 'balón', 'equipo'],
      },
    },
    {
      id: 935,
      emoji: '🤾‍♂️',
      keywords: {
        en: ['handball', 'sport', 'ball', 'team'],
        es: ['balonmano', 'deporte', 'balón', 'equipo'],
      },
    },
    {
      id: 936,
      emoji: '🤾‍♀️',
      keywords: {
        en: ['handball', 'sport', 'ball', 'team'],
        es: ['balonmano', 'deporte', 'balón', 'equipo'],
      },
    },
    {
      id: 937,
      emoji: '🤹',
      keywords: {
        en: ['juggling', 'circus', 'skill', 'entertainment'],
        es: ['malabares', 'circo', 'habilidad', 'entretenimiento'],
      },
    },
    {
      id: 938,
      emoji: '🤹‍♂️',
      keywords: {
        en: ['juggling', 'circus', 'skill', 'entertainment'],
        es: ['malabares', 'circo', 'habilidad', 'entretenimiento'],
      },
    },
    {
      id: 939,
      emoji: '🤹‍♀️',
      keywords: {
        en: ['juggling', 'circus', 'skill', 'entertainment'],
        es: ['malabares', 'circo', 'habilidad', 'entretenimiento'],
      },
    },
  ],
  objetos: [
    {
      id: 940,
      emoji: '👓',
      keywords: {
        en: ['glasses', 'eyewear', 'fashion', 'vision'],
        es: ['gafas', 'lentes', 'moda', 'visión'],
      },
    },
    {
      id: 941,
      emoji: '🕶️',
      keywords: {
        en: ['sunglasses', 'eyewear', 'summer', 'cool'],
        es: ['gafas de sol', 'lentes', 'verano', 'genial'],
      },
    },
    {
      id: 942,
      emoji: '🥽',
      keywords: {
        en: ['goggles', 'eyewear', 'protection', 'sports'],
        es: ['gafas protectoras', 'lentes', 'protección', 'deportes'],
      },
    },
    {
      id: 943,
      emoji: '🥼',
      keywords: {
        en: ['lab coat', 'clothing', 'professional', 'science'],
        es: ['bata de laboratorio', 'ropa', 'profesional', 'ciencia'],
      },
    },
    {
      id: 944,
      emoji: '🦺',
      keywords: {
        en: ['safety vest', 'clothing', 'visibility', 'work'],
        es: ['chaleco de seguridad', 'ropa', 'visibilidad', 'trabajo'],
      },
    },
    {
      id: 945,
      emoji: '👔',
      keywords: {
        en: ['shirt', 'clothing', 'formal', 'business'],
        es: ['camisa', 'ropa', 'formal', 'negocios'],
      },
    },
    {
      id: 946,
      emoji: '👕',
      keywords: {
        en: ['t-shirt', 'clothing', 'casual', 'comfortable'],
        es: ['camiseta', 'ropa', 'casual', 'cómodo'],
      },
    },
    {
      id: 947,
      emoji: '👖',
      keywords: {
        en: ['jeans', 'clothing', 'denim', 'casual'],
        es: ['jeans', 'ropa', 'denim', 'casual'],
      },
    },
    {
      id: 948,
      emoji: '🧣',
      keywords: {
        en: ['scarf', 'clothing', 'winter', 'warm'],
        es: ['bufanda', 'ropa', 'invierno', 'cálido'],
      },
    },
    {
      id: 949,
      emoji: '🧤',
      keywords: {
        en: ['gloves', 'clothing', 'warmth', 'winter'],
        es: ['guantes', 'ropa', 'calidez', 'invierno'],
      },
    },
    {
      id: 950,
      emoji: '🧥',
      keywords: {
        en: ['coat', 'clothing', 'outerwear', 'fashion'],
        es: ['abrigo', 'ropa', 'ropa exterior', 'moda'],
      },
    },
    {
      id: 951,
      emoji: '🧦',
      keywords: {
        en: ['socks', 'clothing', 'footwear', 'warm'],
        es: ['medias', 'ropa', 'calzado', 'cálido'],
      },
    },
    {
      id: 952,
      emoji: '👗',
      keywords: {
        en: ['dress', 'clothing', 'fashion', 'style'],
        es: ['vestido', 'ropa', 'moda', 'estilo'],
      },
    },
    {
      id: 953,
      emoji: '👘',
      keywords: {
        en: ['kimono', 'clothing', 'Japanese', 'traditional'],
        es: ['kimono', 'ropa', 'japonés', 'tradicional'],
      },
    },
    {
      id: 954,
      emoji: '🥻',
      keywords: {
        en: ['sari', 'clothing', 'Indian', 'traditional'],
        es: ['sari', 'ropa', 'indio', 'tradicional'],
      },
    },
    {
      id: 955,
      emoji: '🩱',
      keywords: {
        en: ['one-piece swimsuit', 'clothing', 'swimwear', 'beach'],
        es: ['traje de baño de una pieza', 'ropa', 'ropa de baño', 'playa'],
      },
    },
    {
      id: 956,
      emoji: '🩲',
      keywords: {
        en: ['briefs', 'underwear', 'clothing', 'comfort'],
        es: ['calzoncillos', 'ropa interior', 'ropa', 'comodidad'],
      },
    },
    {
      id: 957,
      emoji: '🩳',
      keywords: {
        en: ['shorts', 'clothing', 'summer', 'casual'],
        es: ['pantaloneta', 'ropa', 'verano', 'casual'],
      },
    },
    {
      id: 958,
      emoji: '👙',
      keywords: {
        en: ['bikini', 'swimwear', 'beach', 'summer'],
        es: ['bikini', 'ropa de baño', 'playa', 'verano'],
      },
    },
    {
      id: 959,
      emoji: '👚',
      keywords: {
        en: ['blouse', 'clothing', 'fashion', 'stylish'],
        es: ['blusa', 'ropa', 'moda', 'elegante'],
      },
    },
    {
      id: 960,
      emoji: '🪭',
      keywords: {
        en: ['knot', 'rope', 'decorative', 'craft'],
        es: ['nudo', 'cuerda', 'decorativo', 'manualidad'],
      },
    },
    {
      id: 961,
      emoji: '👛',
      keywords: {
        en: ['purse', 'handbag', 'accessory', 'fashion'],
        es: ['monedero', 'bolso', 'accesorio', 'moda'],
      },
    },
    {
      id: 962,
      emoji: '👜',
      keywords: {
        en: ['handbag', 'bag', 'fashion', 'accessory'],
        es: ['bolso', 'cartera', 'moda', 'accesorio'],
      },
    },
    {
      id: 963,
      emoji: '👝',
      keywords: {
        en: ['clutch bag', 'purse', 'accessory', 'fashion'],
        es: ['bolso de mano', 'monedero', 'accesorio', 'moda'],
      },
    },
    {
      id: 964,
      emoji: '🛍️',
      keywords: {
        en: ['shopping bags', 'shop', 'purchase', 'consumerism'],
        es: ['bolsas de compras', 'tienda', 'compra', 'consumo'],
      },
    },
    {
      id: 965,
      emoji: '🎒',
      keywords: {
        en: ['backpack', 'bag', 'school', 'travel'],
        es: ['mochila', 'bolso', 'escuela', 'viaje'],
      },
    },
    {
      id: 966,
      emoji: '🩴',
      keywords: {
        en: ['thong sandal', 'footwear', 'summer', 'beach'],
        es: ['chancla', 'calzado', 'verano', 'playa'],
      },
    },
    {
      id: 967,
      emoji: '👞',
      keywords: {
        en: ['men’s shoe', 'footwear', 'formal', 'fashion'],
        es: ['zapato de hombre', 'calzado', 'formal', 'moda'],
      },
    },
    {
      id: 968,
      emoji: '👟',
      keywords: {
        en: ['running shoe', 'footwear', 'athletic', 'sport'],
        es: ['zapato deportivo', 'calzado', 'atlético', 'deporte'],
      },
    },
    {
      id: 969,
      emoji: '🥾',
      keywords: {
        en: ['hiking boot', 'boot', 'outdoor', 'adventure'],
        es: ['bota de senderismo', 'bota', 'aire libre', 'aventura'],
      },
    },
    {
      id: 970,
      emoji: '🥿',
      keywords: {
        en: ['flat shoe', 'footwear', 'comfortable', 'casual'],
        es: ['zapato plano', 'calzado', 'cómodo', 'casual'],
      },
    },
    {
      id: 971,
      emoji: '👠',
      keywords: {
        en: ['high-heeled shoe', 'footwear', 'fashion', 'stylish'],
        es: ['zapato de tacón', 'calzado', 'moda', 'elegante'],
      },
    },
    {
      id: 972,
      emoji: '👡',
      keywords: {
        en: ['woman’s sandal', 'footwear', 'summer', 'casual'],
        es: ['sandalia de mujer', 'calzado', 'verano', 'casual'],
      },
    },
    {
      id: 973,
      emoji: '🩰',
      keywords: {
        en: ['ballet shoes', 'dance', 'performance', 'fashion'],
        es: ['zapatillas de ballet', 'baile', 'presentación', 'moda'],
      },
    },
    {
      id: 974,
      emoji: '👢',
      keywords: {
        en: ['woman’s boot', 'footwear', 'fashion', 'stylish'],
        es: ['bota de mujer', 'calzado', 'moda', 'elegante'],
      },
    },
    {
      id: 975,
      emoji: '🪮',
      keywords: {
        en: ['slippers', 'footwear', 'indoor', 'comfort'],
        es: ['pantuflas', 'calzado', 'interior', 'comodidad'],
      },
    },
    {
      id: 976,
      emoji: '👑',
      keywords: {
        en: ['crown', 'royalty', 'king', 'queen'],
        es: ['corona', 'realeza', 'rey', 'reina'],
      },
    },
    {
      id: 977,
      emoji: '👒',
      keywords: {
        en: ['woman’s hat', 'headwear', 'fashion', 'sun'],
        es: ['sombrero de mujer', 'tocado', 'moda', 'sol'],
      },
    },
    {
      id: 978,
      emoji: '🎩',
      keywords: {
        en: ['top hat', 'headwear', 'formal', 'gentleman'],
        es: ['sombrero de copa', 'tocado', 'formal', 'caballero'],
      },
    },
    {
      id: 979,
      emoji: '🎓',
      keywords: {
        en: ['graduation cap', 'cap', 'education', 'achievement'],
        es: ['birrete', 'gorra', 'educación', 'logro'],
      },
    },
    {
      id: 980,
      emoji: '🧢',
      keywords: {
        en: ['baseball cap', 'hat', 'sport', 'casual'],
        es: ['gorra de béisbol', 'sombrero', 'deporte', 'casual'],
      },
    },
    {
      id: 981,
      emoji: '🪖',
      keywords: {
        en: ['military helmet', 'helmet', 'protection', 'army'],
        es: ['casco militar', 'casco', 'protección', 'ejército'],
      },
    },
    {
      id: 982,
      emoji: '⛑️',
      keywords: {
        en: ['rescue helmet', 'helmet', 'safety', 'emergency'],
        es: ['casco de rescate', 'casco', 'seguridad', 'emergencia'],
      },
    },
    {
      id: 983,
      emoji: '📿',
      keywords: {
        en: ['necklace', 'jewelry', 'accessory', 'beads'],
        es: ['collar', 'joyería', 'accesorio', 'cuentas'],
      },
    },
    {
      id: 984,
      emoji: '💄',
      keywords: {
        en: ['lipstick', 'cosmetic', 'makeup', 'beauty'],
        es: ['labial', 'cosmético', 'maquillaje', 'belleza'],
      },
    },
    {
      id: 985,
      emoji: '💍',
      keywords: {
        en: ['ring', 'jewelry', 'engagement', 'wedding'],
        es: ['anillo', 'joyería', 'compromiso', 'boda'],
      },
    },
    {
      id: 986,
      emoji: '💎',
      keywords: {
        en: ['gemstone', 'jewelry', 'diamond', 'precious'],
        es: ['gema', 'joyería', 'diamante', 'precioso'],
      },
    },
    {
      id: 987,
      emoji: '🔇',
      keywords: {
        en: ['mute', 'sound', 'quiet', 'silence'],
        es: ['silenciar', 'sonido', 'callado', 'silencio'],
      },
    },
    {
      id: 988,
      emoji: '🔈',
      keywords: {
        en: ['speaker low volume', 'sound', 'audio', 'volume'],
        es: ['altavoz con volumen bajo', 'sonido', 'audio', 'volumen'],
      },
    },
    {
      id: 989,
      emoji: '🔉',
      keywords: {
        en: ['speaker medium volume', 'sound', 'audio', 'volume'],
        es: ['altavoz con volumen medio', 'sonido', 'audio', 'volumen'],
      },
    },
    {
      id: 990,
      emoji: '🔊',
      keywords: {
        en: ['speaker high volume', 'sound', 'audio', 'volume'],
        es: ['altavoz con volumen alto', 'sonido', 'audio', 'volumen'],
      },
    },
    {
      id: 991,
      emoji: '📢',
      keywords: {
        en: ['loudspeaker', 'announcement', 'public', 'broadcast'],
        es: ['altavoz', 'anuncio', 'público', 'transmisión'],
      },
    },
    {
      id: 992,
      emoji: '📣',
      keywords: {
        en: ['megaphone', 'announcement', 'loud', 'communication'],
        es: ['megáfono', 'anuncio', 'fuerte', 'comunicación'],
      },
    },
    {
      id: 993,
      emoji: '📯',
      keywords: {
        en: ['postal horn', 'announcement', 'music', 'brass'],
        es: ['corneta postal', 'anuncio', 'música', 'metal'],
      },
    },
    {
      id: 994,
      emoji: '🔔',
      keywords: {
        en: ['bell', 'sound', 'notification', 'alarm'],
        es: ['campana', 'sonido', 'notificación', 'alarma'],
      },
    },
    {
      id: 995,
      emoji: '🔕',
      keywords: {
        en: ['bell with slash', 'mute', 'silent', 'no sound'],
        es: ['campana silenciada', 'silenciar', 'silencioso', 'sin sonido'],
      },
    },
    {
      id: 996,
      emoji: '🎼',
      keywords: {
        en: ['musical score', 'sheet music', 'notes', 'composition'],
        es: ['partitura musical', 'partitura', 'notas', 'composición'],
      },
    },
    {
      id: 997,
      emoji: '🎵',
      keywords: {
        en: ['musical note', 'music', 'sound', 'melody'],
        es: ['nota musical', 'música', 'sonido', 'melodía'],
      },
    },
    {
      id: 998,
      emoji: '🎶',
      keywords: {
        en: ['musical notes', 'music', 'sound', 'melody'],
        es: ['notas musicales', 'música', 'sonido', 'melodía'],
      },
    },
    {
      id: 999,
      emoji: '🎙️',
      keywords: {
        en: ['studio microphone', 'music', 'recording', 'podcast'],
        es: ['micrófono de estudio', 'música', 'grabación', 'podcast'],
      },
    },
    {
      id: 1000,
      emoji: '🎚️',
      keywords: {
        en: ['level slider', 'audio', 'control', 'volume'],
        es: ['control deslizante', 'audio', 'control', 'volumen'],
      },
    },
    {
      id: 1001,
      emoji: '🎛️',
      keywords: {
        en: ['control knobs', 'audio', 'mixing', 'adjust'],
        es: ['perillas de control', 'audio', 'mezcla', 'ajustar'],
      },
    },
    {
      id: 1002,
      emoji: '🎤',
      keywords: {
        en: ['microphone', 'music', 'singing', 'vocal'],
        es: ['micrófono', 'música', 'canto', 'voz'],
      },
    },
    {
      id: 1003,
      emoji: '🎧',
      keywords: {
        en: ['headphone', 'music', 'sound', 'audio'],
        es: ['audífonos', 'música', 'sonido', 'audio'],
      },
    },
    {
      id: 1004,
      emoji: '📻',
      keywords: {
        en: ['radio', 'broadcast', 'music', 'communication'],
        es: ['radio', 'transmisión', 'música', 'comunicación'],
      },
    },
    {
      id: 1005,
      emoji: '🎷',
      keywords: {
        en: ['saxophone', 'music', 'instrument', 'jazz'],
        es: ['saxofón', 'música', 'instrumento', 'jazz'],
      },
    },
    {
      id: 1006,
      emoji: '🪗',
      keywords: {
        en: ['accordion', 'music', 'instrument', 'squeezebox'],
        es: ['acordeón', 'música', 'instrumento', 'concertina'],
      },
    },
    {
      id: 1007,
      emoji: '🎸',
      keywords: {
        en: ['guitar', 'music', 'instrument', 'rock'],
        es: ['guitarra', 'música', 'instrumento', 'rock'],
      },
    },
    {
      id: 1008,
      emoji: '🎹',
      keywords: {
        en: ['musical keyboard', 'piano', 'instrument', 'music'],
        es: ['teclado musical', 'piano', 'instrumento', 'música'],
      },
    },
    {
      id: 1009,
      emoji: '🎺',
      keywords: {
        en: ['trumpet', 'music', 'brass', 'instrument'],
        es: ['trompeta', 'música', 'metal', 'instrumento'],
      },
    },
    {
      id: 1010,
      emoji: '🎻',
      keywords: {
        en: ['violin', 'music', 'string', 'instrument'],
        es: ['violín', 'música', 'cuerda', 'instrumento'],
      },
    },
    {
      id: 1011,
      emoji: '🪕',
      keywords: {
        en: ['banjo', 'music', 'instrument', 'strings'],
        es: ['banjo', 'música', 'instrumento', 'cuerdas'],
      },
    },
    {
      id: 1012,
      emoji: '🥁',
      keywords: {
        en: ['drum', 'music', 'percussion', 'beat'],
        es: ['tambor', 'música', 'percusión', 'ritmo'],
      },
    },
    {
      id: 1013,
      emoji: '🪘',
      keywords: {
        en: ['long drum', 'music', 'percussion', 'instrument'],
        es: ['tambor largo', 'música', 'percusión', 'instrumento'],
      },
    },
    {
      id: 1014,
      emoji: '🪇',
      keywords: {
        en: ['drum with drumsticks', 'music', 'percussion', 'instrument'],
        es: ['tambor con baquetas', 'música', 'percusión', 'instrumento'],
      },
    },
    {
      id: 1015,
      emoji: '🪈',
      keywords: {
        en: ['banjo', 'music', 'instrument', 'strings'],
        es: ['banjo', 'música', 'instrumento', 'cuerdas'],
      },
    },
    {
      id: 1016,
      emoji: '📱',
      keywords: {
        en: ['mobile phone', 'technology', 'communication', 'smartphone'],
        es: ['teléfono móvil', 'tecnología', 'comunicación', 'smartphone'],
      },
    },
    {
      id: 1017,
      emoji: '📲',
      keywords: {
        en: ['mobile phone with arrow', 'technology', 'communication', 'smartphone'],
        es: ['teléfono móvil con flecha', 'tecnología', 'comunicación', 'smartphone'],
      },
    },
    {
      id: 1018,
      emoji: '☎️',
      keywords: {
        en: ['telephone', 'phone', 'communication', 'call'],
        es: ['teléfono', 'celular', 'comunicación', 'llamada'],
      },
    },
    {
      id: 1019,
      emoji: '📞',
      keywords: {
        en: ['telephone receiver', 'communication', 'call', 'phone'],
        es: ['auricular telefónico', 'comunicación', 'llamada', 'teléfono'],
      },
    },
    {
      id: 1020,
      emoji: '📟',
      keywords: {
        en: ['pager', 'communication', 'message', 'device'],
        es: ['buscapersonas', 'comunicación', 'mensaje', 'dispositivo'],
      },
    },
    {
      id: 1021,
      emoji: '📠',
      keywords: {
        en: ['fax machine', 'communication', 'document', 'office'],
        es: ['máquina de fax', 'comunicación', 'documento', 'oficina'],
      },
    },
    {
      id: 1022,
      emoji: '🔋',
      keywords: {
        en: ['battery', 'power', 'energy', 'electric'],
        es: ['batería', 'potencia', 'energía', 'eléctrico'],
      },
    },
    {
      id: 1023,
      emoji: '🪫',
      keywords: {
        en: ['toothbrush', 'cleaning', 'oral hygiene', 'bathroom'],
        es: ['cepillo de dientes', 'limpieza', 'higiene oral', 'baño'],
      },
    },
    {
      id: 1024,
      emoji: '🔌',
      keywords: {
        en: ['electric plug', 'power', 'energy', 'charging'],
        es: ['enchufe eléctrico', 'potencia', 'energía', 'carga'],
      },
    },
    {
      id: 1025,
      emoji: '💻',
      keywords: {
        en: ['laptop', 'computer', 'technology', 'work'],
        es: ['portátil', 'computador', 'tecnología', 'trabajo'],
      },
    },
    {
      id: 1026,
      emoji: '🖥️',
      keywords: {
        en: ['desktop computer', 'technology', 'monitor', 'screen'],
        es: ['computador de escritorio', 'tecnología', 'monitor', 'pantalla'],
      },
    },
    {
      id: 1027,
      emoji: '🖨️',
      keywords: {
        en: ['printer', 'office', 'document', 'print'],
        es: ['impresora', 'oficina', 'documento', 'imprimir'],
      },
    },
    {
      id: 1028,
      emoji: '⌨️',
      keywords: {
        en: ['keyboard', 'technology', 'typing', 'computer'],
        es: ['teclado', 'tecnología', 'escritura', 'computador'],
      },
    },
    {
      id: 1029,
      emoji: '🖱️',
      keywords: {
        en: ['computer mouse', 'technology', 'click', 'cursor'],
        es: ['mouse de computador', 'tecnología', 'clic', 'cursor'],
      },
    },
    {
      id: 1030,
      emoji: '🖲️',
      keywords: {
        en: ['trackball', 'technology', 'computer', 'mouse'],
        es: ['trackball', 'tecnología', 'computador', 'mouse'],
      },
    },
    {
      id: 1031,
      emoji: '💽',
      keywords: {
        en: ['computer disk', 'technology', 'data', 'storage'],
        es: ['disco de computador', 'tecnología', 'datos', 'almacenamiento'],
      },
    },
    {
      id: 1032,
      emoji: '💾',
      keywords: {
        en: ['floppy disk', 'technology', 'storage', 'data'],
        es: ['disquete', 'tecnología', 'almacenamiento', 'datos'],
      },
    },
    {
      id: 1033,
      emoji: '💿',
      keywords: {
        en: ['optical disk', 'technology', 'disc', 'data'],
        es: ['disco óptico', 'tecnología', 'disco', 'datos'],
      },
    },
    {
      id: 1034,
      emoji: '📀',
      keywords: {
        en: ['dvd', 'disc', 'media', 'entertainment'],
        es: ['dvd', 'disco', 'medio', 'entretenimiento'],
      },
    },
    {
      id: 1035,
      emoji: '🧮',
      keywords: {
        en: ['abacus', 'counting', 'math', 'calculation'],
        es: ['ábaco', 'conteo', 'matemáticas', 'cálculo'],
      },
    },
    {
      id: 1036,
      emoji: '🎥',
      keywords: {
        en: ['movie camera', 'film', 'cinema', 'video'],
        es: ['cámara de cine', 'película', 'cine', 'video'],
      },
    },
    {
      id: 1037,
      emoji: '🎞️',
      keywords: {
        en: ['film frames', 'movie', 'cinema', 'video'],
        es: ['fotogramas', 'película', 'cine', 'video'],
      },
    },
    {
      id: 1038,
      emoji: '📽️',
      keywords: {
        en: ['film projector', 'movie', 'cinema', 'video'],
        es: ['proyector de cine', 'película', 'cine', 'video'],
      },
    },
    {
      id: 1039,
      emoji: '🎬',
      keywords: {
        en: ['clapper board', 'film', 'movie', 'cinema'],
        es: ['claqueta', 'filmación', 'película', 'cine'],
      },
    },
    {
      id: 1040,
      emoji: '📺',
      keywords: {
        en: ['television', 'TV', 'entertainment', 'program'],
        es: ['televisión', 'TV', 'entretenimiento', 'programa'],
      },
    },
    {
      id: 1041,
      emoji: '📷',
      keywords: {
        en: ['camera', 'photography', 'photo', 'picture'],
        es: ['cámara', 'fotografía', 'foto', 'imagen'],
      },
    },
    {
      id: 1042,
      emoji: '📸',
      keywords: {
        en: ['camera with flash', 'photography', 'photo', 'picture'],
        es: ['cámara con flash', 'fotografía', 'foto', 'imagen'],
      },
    },
    {
      id: 1043,
      emoji: '📹',
      keywords: {
        en: ['video camera', 'film', 'record', 'movie'],
        es: ['cámara de video', 'filmación', 'grabar', 'película'],
      },
    },
    {
      id: 1044,
      emoji: '📼',
      keywords: {
        en: ['videocassette', 'video', 'record', 'old'],
        es: ['videocasete', 'video', 'grabar', 'antiguo'],
      },
    },
    {
      id: 1045,
      emoji: '🔍',
      keywords: {
        en: ['magnifying glass', 'search', 'zoom', 'investigate'],
        es: ['lupa', 'buscar', 'zoom', 'investigar'],
      },
    },
    {
      id: 1046,
      emoji: '🔎',
      keywords: {
        en: ['magnifying glass tilted', 'search', 'zoom', 'investigate'],
        es: ['lupa inclinada', 'buscar', 'zoom', 'investigar'],
      },
    },
    {
      id: 1047,
      emoji: '🕯️',
      keywords: {
        en: ['candle', 'light', 'fire', 'wax'],
        es: ['vela', 'luz', 'fuego', 'cera'],
      },
    },
    {
      id: 1048,
      emoji: '💡',
      keywords: {
        en: ['light bulb', 'idea', 'innovation', 'bright'],
        es: ['bombillo', 'idea', 'innovación', 'brillante'],
      },
    },
    {
      id: 1049,
      emoji: '🔦',
      keywords: {
        en: ['flashlight', 'light', 'dark', 'power outage'],
        es: ['linterna', 'luz', 'oscuridad', 'apagón'],
      },
    },
    {
      id: 1050,
      emoji: '🏮',
      keywords: {
        en: ['red paper lantern', 'light', 'decoration', 'celebration'],
        es: ['farol rojo de papel', 'luz', 'decoración', 'celebración'],
      },
    },
    {
      id: 1051,
      emoji: '🪔',
      keywords: {
        en: ['diya lamp', 'light', 'diwali', 'celebration'],
        es: ['lámpara diya', 'luz', 'diwali', 'celebración'],
      },
    },
    {
      id: 1052,
      emoji: '📔',
      keywords: {
        en: ['notebook with decorative cover', 'book', 'journal', 'writing'],
        es: ['cuaderno con portada decorativa', 'libro', 'diario', 'escritura'],
      },
    },
    {
      id: 1053,
      emoji: '📕',
      keywords: {
        en: ['closed book', 'book', 'read', 'knowledge'],
        es: ['libro cerrado', 'libro', 'leer', 'conocimiento'],
      },
    },
    {
      id: 1054,
      emoji: '📖',
      keywords: {
        en: ['open book', 'book', 'read', 'study'],
        es: ['libro abierto', 'libro', 'leer', 'estudio'],
      },
    },
    {
      id: 1055,
      emoji: '📗',
      keywords: {
        en: ['green book', 'book', 'read', 'study'],
        es: ['libro verde', 'libro', 'leer', 'estudio'],
      },
    },
    {
      id: 1056,
      emoji: '📘',
      keywords: {
        en: ['blue book', 'book', 'read', 'study'],
        es: ['libro azul', 'libro', 'leer', 'estudio'],
      },
    },
    {
      id: 1057,
      emoji: '📙',
      keywords: {
        en: ['orange book', 'book', 'read', 'study'],
        es: ['libro naranja', 'libro', 'leer', 'estudio'],
      },
    },
    {
      id: 1058,
      emoji: '📚',
      keywords: {
        en: ['books', 'library', 'study', 'knowledge'],
        es: ['libros', 'biblioteca', 'estudio', 'conocimiento'],
      },
    },
    {
      id: 1059,
      emoji: '📓',
      keywords: {
        en: ['notebook', 'journal', 'writing', 'study'],
        es: ['cuaderno', 'diario', 'escritura', 'estudio'],
      },
    },
    {
      id: 1060,
      emoji: '📒',
      keywords: {
        en: ['ledger', 'notebook', 'study', 'record'],
        es: ['libro de cuentas', 'cuaderno', 'estudio', 'registro'],
      },
    },
    {
      id: 1061,
      emoji: '📃',
      keywords: {
        en: ['page with curl', 'document', 'paper', 'writing'],
        es: ['página con borde curvado', 'documento', 'papel', 'escritura'],
      },
    },
    {
      id: 1062,
      emoji: '📜',
      keywords: {
        en: ['scroll', 'document', 'ancient', 'history'],
        es: ['pergamino', 'documento', 'antiguo', 'historia'],
      },
    },
    {
      id: 1063,
      emoji: '📄',
      keywords: {
        en: ['page facing up', 'document', 'paper', 'writing'],
        es: ['página hacia arriba', 'documento', 'papel', 'escritura'],
      },
    },
    {
      id: 1064,
      emoji: '📰',
      keywords: {
        en: ['newspaper', 'press', 'news', 'headlines'],
        es: ['periódico', 'prensa', 'noticias', 'titulares'],
      },
    },
    {
      id: 1065,
      emoji: '🗞️',
      keywords: {
        en: ['rolled-up newspaper', 'press', 'news', 'information'],
        es: ['periódico enrollado', 'prensa', 'noticias', 'información'],
      },
    },
    {
      id: 1066,
      emoji: '📑',
      keywords: {
        en: ['bookmark tabs', 'document', 'paper', 'organization'],
        es: ['marcadores de páginas', 'documento', 'papel', 'organización'],
      },
    },
    {
      id: 1067,
      emoji: '🔖',
      keywords: {
        en: ['bookmark', 'label', 'mark', 'reminder'],
        es: ['marcador', 'etiqueta', 'marca', 'recordatorio'],
      },
    },
    {
      id: 1068,
      emoji: '🏷️',
      keywords: {
        en: ['label', 'tag', 'price tag', 'category'],
        es: ['etiqueta', 'tag', 'etiqueta de precio', 'categoría'],
      },
    },
    {
      id: 1069,
      emoji: '💰',
      keywords: {
        en: ['money bag', 'dollar', 'cash', 'wealth'],
        es: ['bolsa de dinero', 'dólar', 'efectivo', 'riqueza'],
      },
    },
    {
      id: 1070,
      emoji: '🪙',
      keywords: {
        en: ['coin', 'money', 'change', 'currency'],
        es: ['moneda', 'dinero', 'cambio', 'divisa'],
      },
    },
    {
      id: 1071,
      emoji: '💴',
      keywords: {
        en: ['yen banknote', 'money', 'currency', 'cash'],
        es: ['billete de yen', 'dinero', 'moneda', 'efectivo'],
      },
    },
    {
      id: 1072,
      emoji: '💵',
      keywords: {
        en: ['dollar banknote', 'money', 'currency', 'cash'],
        es: ['billete de dólar', 'dinero', 'moneda', 'efectivo'],
      },
    },
    {
      id: 1073,
      emoji: '💶',
      keywords: {
        en: ['euro banknote', 'money', 'currency', 'cash'],
        es: ['billete de euro', 'dinero', 'moneda', 'efectivo'],
      },
    },
    {
      id: 1074,
      emoji: '💷',
      keywords: {
        en: ['pound banknote', 'money', 'currency', 'cash'],
        es: ['billete de libra', 'dinero', 'moneda', 'efectivo'],
      },
    },
    {
      id: 1075,
      emoji: '💸',
      keywords: {
        en: ['money with wings', 'dollar', 'cash', 'fly'],
        es: ['dinero con alas', 'dólar', 'efectivo', 'volar'],
      },
    },
    {
      id: 1076,
      emoji: '💳',
      keywords: {
        en: ['credit card', 'money', 'shopping', 'payment'],
        es: ['tarjeta de crédito', 'dinero', 'compras', 'pago'],
      },
    },
    {
      id: 1077,
      emoji: '🧾',
      keywords: {
        en: ['receipt', 'accounting', 'bill', 'payment'],
        es: ['recibo', 'contabilidad', 'factura', 'pago'],
      },
    },
    {
      id: 1078,
      emoji: '💹',
      keywords: {
        en: ['chart increasing with yen', 'money', 'sales', 'growth'],
        es: ['gráfico en aumento con yen', 'dinero', 'ventas', 'crecimiento'],
      },
    },
    {
      id: 1079,
      emoji: '✉️',
      keywords: {
        en: ['envelope', 'letter', 'mail', 'communication'],
        es: ['sobre', 'carta', 'correo', 'comunicación'],
      },
    },
    {
      id: 1080,
      emoji: '📧',
      keywords: {
        en: ['e-mail', 'email', 'communication', 'letter'],
        es: ['correo electrónico', 'email', 'comunicación', 'carta'],
      },
    },
    {
      id: 1081,
      emoji: '📨',
      keywords: {
        en: ['incoming envelope', 'envelope', 'mail', 'communication'],
        es: ['sobre entrante', 'sobre', 'correo', 'comunicación'],
      },
    },
    {
      id: 1082,
      emoji: '📩',
      keywords: {
        en: ['envelope with arrow', 'email', 'communication', 'send'],
        es: ['sobre con flecha', 'email', 'comunicación', 'enviar'],
      },
    },
    {
      id: 1083,
      emoji: '📤',
      keywords: {
        en: ['outbox tray', 'inbox', 'mail', 'sent'],
        es: ['bandeja de salida', 'bandeja', 'correo', 'enviado'],
      },
    },
    {
      id: 1084,
      emoji: '📥',
      keywords: {
        en: ['inbox tray', 'inbox', 'mail', 'receive'],
        es: ['bandeja de entrada', 'bandeja', 'correo', 'recibir'],
      },
    },
    {
      id: 1085,
      emoji: '📦',
      keywords: {
        en: ['package', 'box', 'delivery', 'shipping'],
        es: ['paquete', 'caja', 'entrega', 'envío'],
      },
    },
    {
      id: 1086,
      emoji: '📫',
      keywords: {
        en: ['closed mailbox with raised flag', 'mailbox', 'communication', 'mail'],
        es: ['buzón cerrado con bandera levantada', 'buzón', 'comunicación', 'correo'],
      },
    },
    {
      id: 1087,
      emoji: '📪',
      keywords: {
        en: ['closed mailbox with lowered flag', 'mailbox', 'communication', 'mail'],
        es: ['buzón cerrado con bandera baja', 'buzón', 'comunicación', 'correo'],
      },
    },
    {
      id: 1088,
      emoji: '📬',
      keywords: {
        en: ['open mailbox with raised flag', 'mailbox', 'communication', 'mail'],
        es: ['buzón abierto con bandera levantada', 'buzón', 'comunicación', 'correo'],
      },
    },
    {
      id: 1089,
      emoji: '📭',
      keywords: {
        en: ['open mailbox with lowered flag', 'mailbox', 'communication', 'mail'],
        es: ['buzón abierto con bandera baja', 'buzón', 'comunicación', 'correo'],
      },
    },
    {
      id: 1090,
      emoji: '🗳️',
      keywords: {
        en: ['ballot box with ballot', 'election', 'vote', 'voting'],
        es: ['urna con voto', 'elección', 'voto', 'votación'],
      },
    },
    {
      id: 1091,
      emoji: '✏️',
      keywords: {
        en: ['pencil', 'writing', 'draw', 'sketch'],
        es: ['lápiz', 'escritura', 'dibujar', 'boceto'],
      },
    },
    {
      id: 1092,
      emoji: '✒️',
      keywords: {
        en: ['black nib', 'pen', 'writing', 'ink'],
        es: ['plumilla negra', 'pluma', 'escritura', 'tinta'],
      },
    },
    {
      id: 1093,
      emoji: '🖋️',
      keywords: {
        en: ['fountain pen', 'writing', 'sign', 'ink'],
        es: ['pluma fuente', 'escritura', 'firmar', 'tinta'],
      },
    },
    {
      id: 1094,
      emoji: '🖊️',
      keywords: {
        en: ['pen', 'writing', 'stationery', 'ballpoint'],
        es: ['bolígrafo', 'escritura', 'papelería', 'esfero'],
      },
    },
    {
      id: 1095,
      emoji: '🖌️',
      keywords: {
        en: ['paintbrush', 'art', 'painting', 'drawing'],
        es: ['pincel', 'arte', 'pintura', 'dibujo'],
      },
    },
    {
      id: 1096,
      emoji: '🖍️',
      keywords: {
        en: ['crayon', 'art', 'drawing', 'coloring'],
        es: ['crayón', 'arte', 'dibujo', 'colorear'],
      },
    },
    {
      id: 1097,
      emoji: '📝',
      keywords: {
        en: ['memo', 'note', 'writing', 'document'],
        es: ['nota', 'apunte', 'escritura', 'documento'],
      },
    },
    {
      id: 1098,
      emoji: '💼',
      keywords: {
        en: ['briefcase', 'work', 'business', 'office'],
        es: ['maletín', 'trabajo', 'negocios', 'oficina'],
      },
    },
    {
      id: 1099,
      emoji: '📁',
      keywords: {
        en: ['file folder', 'document', 'organization', 'archive'],
        es: ['carpeta de archivos', 'documento', 'organización', 'archivo'],
      },
    },
    {
      id: 1100,
      emoji: '📂',
      keywords: {
        en: ['open file folder', 'document', 'organization', 'archive'],
        es: ['carpeta abierta', 'documento', 'organización', 'archivo'],
      },
    },
    {
      id: 1101,
      emoji: '🗂️',
      keywords: {
        en: ['card index dividers', 'organization', 'alphabet', 'archive'],
        es: ['separadores de archivo', 'organización', 'alfabeto', 'archivo'],
      },
    },
    {
      id: 1102,
      emoji: '📅',
      keywords: {
        en: ['calendar', 'date', 'planning', 'schedule'],
        es: ['calendario', 'fecha', 'planificación', 'horario'],
      },
    },
    {
      id: 1103,
      emoji: '📆',
      keywords: {
        en: ['tear-off calendar', 'schedule', 'date', 'planning'],
        es: ['calendario desprendible', 'horario', 'fecha', 'planificación'],
      },
    },
    {
      id: 1104,
      emoji: '🗒️',
      keywords: {
        en: ['spiral notepad', 'notes', 'memo', 'writing'],
        es: ['bloc de notas espiral', 'notas', 'apunte', 'escritura'],
      },
    },
    {
      id: 1105,
      emoji: '🗓️',
      keywords: {
        en: ['calendar', 'date', 'schedule', 'planning'],
        es: ['calendario', 'fecha', 'horario', 'planificación'],
      },
    },
    {
      id: 1106,
      emoji: '📇',
      keywords: {
        en: ['card index', 'organize', 'sort', 'files'],
        es: ['fichero', 'organizar', 'ordenar', 'archivos'],
      },
    },
    {
      id: 1107,
      emoji: '📈',
      keywords: {
        en: ['chart increasing', 'graph', 'growth', 'statistics'],
        es: ['gráfico en aumento', 'gráfica', 'crecimiento', 'estadísticas'],
      },
    },
    {
      id: 1108,
      emoji: '📉',
      keywords: {
        en: ['chart decreasing', 'graph', 'decline', 'statistics'],
        es: ['gráfico en descenso', 'gráfica', 'disminución', 'estadísticas'],
      },
    },
    {
      id: 1109,
      emoji: '📊',
      keywords: {
        en: ['bar chart', 'graph', 'data', 'statistics'],
        es: ['gráfico de barras', 'gráfica', 'datos', 'estadísticas'],
      },
    },
    {
      id: 1110,
      emoji: '📋',
      keywords: {
        en: ['clipboard', 'document', 'notes', 'record'],
        es: ['portapapeles', 'documento', 'notas', 'registro'],
      },
    },
    {
      id: 1111,
      emoji: '📌',
      keywords: {
        en: ['pushpin', 'pin', 'location', 'mark'],
        es: ['chincheta', 'pin', 'ubicación', 'marca'],
      },
    },
    {
      id: 1112,
      emoji: '📍',
      keywords: {
        en: ['round pushpin', 'location', 'mark', 'destination'],
        es: ['pin de ubicación', 'ubicación', 'marca', 'destino'],
      },
    },
    {
      id: 1113,
      emoji: '📎',
      keywords: {
        en: ['paperclip', 'attachment', 'fasten', 'office'],
        es: ['clip', 'adjunto', 'sujetar', 'oficina'],
      },
    },
    {
      id: 1114,
      emoji: '🖇️',
      keywords: {
        en: ['linked paperclips', 'attachment', 'together', 'bundle'],
        es: ['clips unidos', 'adjunto', 'juntos', 'paquete'],
      },
    },
    {
      id: 1115,
      emoji: '📏',
      keywords: {
        en: ['straight ruler', 'measure', 'length', 'tool'],
        es: ['regla recta', 'medir', 'longitud', 'herramienta'],
      },
    },
    {
      id: 1116,
      emoji: '📐',
      keywords: {
        en: ['triangular ruler', 'measure', 'geometry', 'tool'],
        es: ['regla triangular', 'medir', 'geometría', 'herramienta'],
      },
    },
    {
      id: 1117,
      emoji: '✂️',
      keywords: {
        en: ['scissors', 'cut', 'snip', 'tool'],
        es: ['tijeras', 'cortar', 'recortar', 'herramienta'],
      },
    },
    {
      id: 1118,
      emoji: '🗃️',
      keywords: {
        en: ['file cabinet', 'organize', 'storage', 'office'],
        es: ['archivador', 'organizar', 'almacenamiento', 'oficina'],
      },
    },
    {
      id: 1119,
      emoji: '🗄️',
      keywords: {
        en: ['file folder', 'documents', 'organize', 'office'],
        es: ['carpeta de archivos', 'documentos', 'organizar', 'oficina'],
      },
    },
    {
      id: 1120,
      emoji: '🗑️',
      keywords: {
        en: ['wastebasket', 'trash', 'bin', 'dispose'],
        es: ['papelera', 'basura', 'caneca', 'desechar'],
      },
    },
    {
      id: 1121,
      emoji: '🔒',
      keywords: {
        en: ['locked', 'security', 'privacy', 'safe'],
        es: ['bloqueado', 'seguridad', 'privacidad', 'seguro'],
      },
    },
    {
      id: 1122,
      emoji: '🔓',
      keywords: {
        en: ['unlocked', 'open', 'access', 'free'],
        es: ['desbloqueado', 'abierto', 'acceso', 'libre'],
      },
    },
    {
      id: 1123,
      emoji: '🔏',
      keywords: {
        en: ['locked with pen', 'privacy', 'security', 'write'],
        es: ['bloqueado con pluma', 'privacidad', 'seguridad', 'escribir'],
      },
    },
    {
      id: 1124,
      emoji: '🔐',
      keywords: {
        en: ['locked with key', 'privacy', 'security', 'access'],
        es: ['bloqueado con llave', 'privacidad', 'seguridad', 'acceso'],
      },
    },
    {
      id: 1125,
      emoji: '🔑',
      keywords: {
        en: ['key', 'lock', 'access', 'security'],
        es: ['llave', 'cerradura', 'acceso', 'seguridad'],
      },
    },
    {
      id: 1126,
      emoji: '🗝️',
      keywords: {
        en: ['old key', 'lock', 'access', 'antique'],
        es: ['llave antigua', 'cerradura', 'acceso', 'antiguo'],
      },
    },
    {
      id: 1127,
      emoji: '🔨',
      keywords: {
        en: ['hammer', 'tool', 'build', 'construction'],
        es: ['martillo', 'herramienta', 'construir', 'construcción'],
      },
    },
    {
      id: 1128,
      emoji: '🪓',
      keywords: {
        en: ['axe', 'tool', 'chop', 'wood'],
        es: ['hacha', 'herramienta', 'cortar', 'madera'],
      },
    },
    {
      id: 1129,
      emoji: '⛏️',
      keywords: {
        en: ['pick', 'tool', 'dig', 'mine'],
        es: ['pico', 'herramienta', 'excavar', 'mina'],
      },
    },
    {
      id: 1130,
      emoji: '⚒️',
      keywords: {
        en: ['hammer and pick', 'tool', 'work', 'craft'],
        es: ['martillo y pico', 'herramienta', 'trabajo', 'oficio'],
      },
    },
    {
      id: 1131,
      emoji: '🛠️',
      keywords: {
        en: ['hammer and wrench', 'tool', 'repair', 'build'],
        es: ['martillo y llave inglesa', 'herramienta', 'reparar', 'construir'],
      },
    },
    {
      id: 1132,
      emoji: '🗡️',
      keywords: {
        en: ['dagger', 'weapon', 'blade', 'sharp'],
        es: ['daga', 'arma', 'hoja', 'afilado'],
      },
    },
    {
      id: 1133,
      emoji: '⚔️',
      keywords: {
        en: ['crossed swords', 'weapon', 'battle', 'combat'],
        es: ['espadas cruzadas', 'arma', 'batalla', 'combate'],
      },
    },
    {
      id: 1134,
      emoji: '💣',
      keywords: {
        en: ['bomb', 'explode', 'explosion', 'danger'],
        es: ['bomba', 'explotar', 'explosión', 'peligro'],
      },
    },
    {
      id: 1135,
      emoji: '🪃',
      keywords: {
        en: ['boomerang', 'throw', 'return', 'weapon'],
        es: ['búmeran', 'lanzar', 'regresar', 'arma'],
      },
    },
    {
      id: 1136,
      emoji: '🏹',
      keywords: {
        en: ['bow and arrow', 'archery', 'hunt', 'weapon'],
        es: ['arco y flecha', 'arquería', 'cazar', 'arma'],
      },
    },
    {
      id: 1137,
      emoji: '🛡️',
      keywords: {
        en: ['shield', 'protection', 'defense', 'armor'],
        es: ['escudo', 'protección', 'defensa', 'armadura'],
      },
    },
    {
      id: 1138,
      emoji: '🪚',
      keywords: {
        en: ['carpentry saw', 'tool', 'cut', 'wood'],
        es: ['serrucho', 'herramienta', 'cortar', 'madera'],
      },
    },
    {
      id: 1139,
      emoji: '🔧',
      keywords: {
        en: ['wrench', 'tool', 'tighten', 'fix'],
        es: ['llave inglesa', 'herramienta', 'apretar', 'arreglar'],
      },
    },
    {
      id: 1140,
      emoji: '🪛',
      keywords: {
        en: ['screwdriver', 'tool', 'assemble', 'fix'],
        es: ['destornillador', 'herramienta', 'ensamblar', 'arreglar'],
      },
    },
    {
      id: 1141,
      emoji: '🔩',
      keywords: {
        en: ['nut and bolt', 'hardware', 'tool', 'fasten'],
        es: ['tuerca y tornillo', 'ferretería', 'herramienta', 'sujetar'],
      },
    },
    {
      id: 1142,
      emoji: '⚙️',
      keywords: {
        en: ['gear', 'settings', 'mechanism', 'engine'],
        es: ['engranaje', 'configuración', 'mecanismo', 'motor'],
      },
    },
    {
      id: 1143,
      emoji: '🗜️',
      keywords: {
        en: ['clamp', 'tool', 'hold', 'secure'],
        es: ['abrazadera', 'herramienta', 'sujetar', 'asegurar'],
      },
    },
    {
      id: 1144,
      emoji: '⚖️',
      keywords: {
        en: ['balance scale', 'justice', 'equality', 'law'],
        es: ['balanza', 'justicia', 'igualdad', 'ley'],
      },
    },
    {
      id: 1145,
      emoji: '🦯',
      keywords: {
        en: ['white cane', 'blind', 'visual impairment', 'mobility'],
        es: ['bastón blanco', 'ciego', 'discapacidad visual', 'movilidad'],
      },
    },
    {
      id: 1146,
      emoji: '🔗',
      keywords: {
        en: ['link', 'chain', 'connect', 'attachment'],
        es: ['enlace', 'cadena', 'conectar', 'adjunto'],
      },
    },
    {
      id: 1147,
      emoji: '⛓️',
      keywords: {
        en: ['chains', 'link', 'bound', 'constraint'],
        es: ['cadenas', 'enlace', 'atado', 'restricción'],
      },
    },
    {
      id: 1148,
      emoji: '🪝',
      keywords: {
        en: ['hook', 'tool', 'hang', 'attach'],
        es: ['gancho', 'herramienta', 'colgar', 'adjuntar'],
      },
    },
    {
      id: 1149,
      emoji: '🧰',
      keywords: {
        en: ['toolbox', 'tools', 'equipment', 'repair'],
        es: ['caja de herramientas', 'herramientas', 'equipo', 'reparación'],
      },
    },
    {
      id: 1150,
      emoji: '🧲',
      keywords: {
        en: ['magnet', 'attraction', 'pull', 'magnetic'],
        es: ['imán', 'atracción', 'halar', 'magnético'],
      },
    },
    {
      id: 1151,
      emoji: '🪜',
      keywords: {
        en: ['ladder', 'climb', 'reach', 'height'],
        es: ['escalera', 'subir', 'alcanzar', 'altura'],
      },
    },
    {
      id: 1152,
      emoji: '⚗️',
      keywords: {
        en: ['alembic', 'chemistry', 'experiment', 'science'],
        es: ['alambique', 'química', 'experimento', 'ciencia'],
      },
    },
    {
      id: 1153,
      emoji: '🧪',
      keywords: {
        en: ['petri dish', 'chemistry', 'experiment', 'biology'],
        es: ['placa de Petri', 'química', 'experimento', 'biología'],
      },
    },
    {
      id: 1154,
      emoji: '🧫',
      keywords: {
        en: ['microbe', 'biology', 'science', 'organism'],
        es: ['microbio', 'biología', 'ciencia', 'organismo'],
      },
    },
    {
      id: 1155,
      emoji: '🧬',
      keywords: {
        en: ['DNA', 'genetics', 'biology', 'science'],
        es: ['ADN', 'genética', 'biología', 'ciencia'],
      },
    },
    {
      id: 1156,
      emoji: '🔬',
      keywords: {
        en: ['microscope', 'science', 'laboratory', 'research'],
        es: ['microscopio', 'ciencia', 'laboratorio', 'investigación'],
      },
    },
    {
      id: 1157,
      emoji: '🔭',
      keywords: {
        en: ['telescope', 'astronomy', 'observe', 'space'],
        es: ['telescopio', 'astronomía', 'observar', 'espacio'],
      },
    },
    {
      id: 1158,
      emoji: '📡',
      keywords: {
        en: ['satellite antenna', 'communication', 'technology', 'broadcast'],
        es: ['antena satelital', 'comunicación', 'tecnología', 'transmisión'],
      },
    },
    {
      id: 1159,
      emoji: '💉',
      keywords: {
        en: ['syringe', 'inject', 'vaccination', 'medicine'],
        es: ['jeringa', 'inyectar', 'vacunación', 'medicina'],
      },
    },
    {
      id: 1160,
      emoji: '🩸',
      keywords: {
        en: ['drop of blood', 'health', 'donate', 'life'],
        es: ['gota de sangre', 'salud', 'donar', 'vida'],
      },
    },
    {
      id: 1161,
      emoji: '💊',
      keywords: {
        en: ['pill', 'medicine', 'health', 'prescription'],
        es: ['pastilla', 'medicina', 'salud', 'receta'],
      },
    },
    {
      id: 1162,
      emoji: '🩹',
      keywords: {
        en: ['adhesive bandage', 'health', 'wound', 'protect'],
        es: ['curita', 'salud', 'herida', 'proteger'],
      },
    },
    {
      id: 1163,
      emoji: '🩼',
      keywords: {
        en: ['stethoscope', 'health', 'doctor', 'heartbeat'],
        es: ['estetoscopio', 'salud', 'doctor', 'latido'],
      },
    },
    {
      id: 1164,
      emoji: '🩺',
      keywords: {
        en: ['diagnostic tool', 'health', 'doctor', 'medical'],
        es: ['herramienta de diagnóstico', 'salud', 'doctor', 'médico'],
      },
    },
    {
      id: 1165,
      emoji: '🩻',
      keywords: {
        en: ['thread', 'needle', 'sewing', 'craft'],
        es: ['hilo', 'aguja', 'costura', 'manualidad'],
      },
    },
    {
      id: 1166,
      emoji: '🚪',
      keywords: {
        en: ['door', 'entry', 'exit', 'privacy'],
        es: ['puerta', 'entrada', 'salida', 'privacidad'],
      },
    },
    {
      id: 1167,
      emoji: '🛗',
      keywords: {
        en: ['elevator', 'lift', 'building', 'transportation'],
        es: ['ascensor', 'elevador', 'edificio', 'transporte'],
      },
    },
    {
      id: 1168,
      emoji: '🪞',
      keywords: {
        en: ['mirror', 'reflection', 'vanity', 'decor'],
        es: ['espejo', 'reflejo', 'tocador', 'decoración'],
      },
    },
    {
      id: 1169,
      emoji: '🪟',
      keywords: {
        en: ['window', 'opening', 'light', 'ventilation'],
        es: ['ventana', 'abertura', 'luz', 'ventilación'],
      },
    },
    {
      id: 1170,
      emoji: '🛏️',
      keywords: {
        en: ['bed', 'sleep', 'rest', 'furniture'],
        es: ['cama', 'dormir', 'descanso', 'mueble'],
      },
    },
    {
      id: 1171,
      emoji: '🛋️',
      keywords: {
        en: ['couch', 'sofa', 'furniture', 'comfort'],
        es: ['sofá', 'mueble', 'comodidad', 'sillón'],
      },
    },
    {
      id: 1172,
      emoji: '🪑',
      keywords: {
        en: ['chair', 'seat', 'furniture', 'comfort'],
        es: ['silla', 'asiento', 'mueble', 'comodidad'],
      },
    },
    {
      id: 1173,
      emoji: '🚽',
      keywords: {
        en: ['toilet', 'bathroom', 'restroom', 'sanitation'],
        es: ['inodoro', 'baño', 'sanitario', 'higiene'],
      },
    },
    {
      id: 1174,
      emoji: '🪠',
      keywords: {
        en: ['plunger', 'bathroom', 'tool', 'unclog'],
        es: ['destapador', 'baño', 'herramienta', 'destapar'],
      },
    },
    {
      id: 1175,
      emoji: '🚿',
      keywords: {
        en: ['shower', 'bathroom', 'clean', 'refresh'],
        es: ['ducha', 'baño', 'limpio', 'refrescar'],
      },
    },
    {
      id: 1176,
      emoji: '🛁',
      keywords: {
        en: ['bathtub', 'bathroom', 'relax', 'clean'],
        es: ['bañera', 'baño', 'relajación', 'limpio'],
      },
    },
    {
      id: 1177,
      emoji: '🪤',
      keywords: {
        en: ['mouse trap', 'trap', 'pest control', 'mousetrap'],
        es: ['trampa para ratones', 'trampa', 'control de plagas', 'ratonera'],
      },
    },
    {
      id: 1178,
      emoji: '🪒',
      keywords: {
        en: ['razor', 'shaving', 'sharp', 'grooming'],
        es: ['rasuradora', 'afeitado', 'afilado', 'arreglo personal'],
      },
    },
    {
      id: 1179,
      emoji: '🧴',
      keywords: {
        en: ['lotion', 'cosmetics', 'moisturize', 'skincare'],
        es: ['loción', 'cosméticos', 'hidratar', 'cuidado de la piel'],
      },
    },
    {
      id: 1180,
      emoji: '🧷',
      keywords: {
        en: ['safety pin', 'secure', 'fasten', 'clothing'],
        es: ['imperdible', 'asegurar', 'sujetar', 'ropa'],
      },
    },
    {
      id: 1181,
      emoji: '🧹',
      keywords: {
        en: ['broom', 'clean', 'sweep', 'housekeeping'],
        es: ['escoba', 'limpiar', 'barrer', 'limpieza del hogar'],
      },
    },
    {
      id: 1182,
      emoji: '🧺',
      keywords: {
        en: ['basket', 'laundry', 'carry', 'storage'],
        es: ['canasta', 'lavandería', 'cargar', 'almacenamiento'],
      },
    },
    {
      id: 1183,
      emoji: '🧻',
      keywords: {
        en: ['toilet paper', 'bathroom', 'tissue', 'roll'],
        es: ['papel higiénico', 'baño', 'pañuelo', 'rollo'],
      },
    },
    {
      id: 1184,
      emoji: '🪣',
      keywords: {
        en: ['bucket', 'container', 'carry', 'cleaning'],
        es: ['balde', 'contenedor', 'cargar', 'limpieza'],
      },
    },
    {
      id: 1185,
      emoji: '🧼',
      keywords: {
        en: ['soap', 'clean', 'lather', 'hygiene'],
        es: ['jabón', 'limpio', 'espuma', 'higiene'],
      },
    },
    {
      id: 1186,
      emoji: '🫧',
      keywords: {
        en: ['sponge', 'cleaning', 'absorbent', 'soft'],
        es: ['esponja', 'limpieza', 'absorbente', 'suave'],
      },
    },
    {
      id: 1187,
      emoji: '🪥',
      keywords: {
        en: ['mop', 'clean', 'floor', 'housekeeping'],
        es: ['trapeador', 'limpiar', 'piso', 'limpieza del hogar'],
      },
    },
    {
      id: 1188,
      emoji: '🧽',
      keywords: {
        en: ['sponge', 'clean', 'scrub', 'household'],
        es: ['esponja', 'limpiar', 'restregar', 'hogar'],
      },
    },
    {
      id: 1189,
      emoji: '🧯',
      keywords: {
        en: ['fire extinguisher', 'safety', 'firefighting', 'emergency'],
        es: ['extintor', 'seguridad', 'apagar incendios', 'emergencia'],
      },
    },
    {
      id: 1190,
      emoji: '🛒',
      keywords: {
        en: ['shopping cart', 'groceries', 'retail', 'buying'],
        es: ['carrito de compras', 'mercado', 'comercio', 'comprar'],
      },
    },
    {
      id: 1191,
      emoji: '🚬',
      keywords: {
        en: ['cigarette', 'smoke', 'tobacco', 'addiction'],
        es: ['cigarrillo', 'humo', 'tabaco', 'adicción'],
      },
    },
    {
      id: 1192,
      emoji: '⚰️',
      keywords: {
        en: ['coffin', 'funeral', 'death', 'burial'],
        es: ['ataúd', 'funeral', 'muerte', 'entierro'],
      },
    },
    {
      id: 1193,
      emoji: '🪦',
      keywords: {
        en: ['headstone', 'grave', 'cemetary', 'memorial'],
        es: ['lápida', 'tumba', 'cementerio', 'memorial'],
      },
    },
    {
      id: 1194,
      emoji: '⚱️',
      keywords: {
        en: ['funeral urn', 'ashes', 'death', 'memorial'],
        es: ['urna funeraria', 'cenizas', 'muerte', 'memorial'],
      },
    },
    {
      id: 1195,
      emoji: '🧿',
      keywords: {
        en: ['nazar amulet', 'protection', 'ward off', 'evil eye'],
        es: ['amuleto nazar', 'protección', 'alejar', 'mal de ojo'],
      },
    },
    {
      id: 1196,
      emoji: '🪬',
      keywords: {
        en: ['beetle', 'insect', 'bug', 'nature'],
        es: ['escarabajo', 'insecto', 'bicho', 'naturaleza'],
      },
    },
    {
      id: 1197,
      emoji: '🗿',
      keywords: {
        en: ['moai', 'statue', 'Easter Island', 'monument'],
        es: ['moái', 'estatua', 'Isla de Pascua', 'monumento'],
      },
    },
    {
      id: 1198,
      emoji: '🪧',
      keywords: {
        en: ['flag in hole', 'golf', 'sport', 'hole-in-one'],
        es: ['bandera en hoyo', 'golf', 'deporte', 'hoyo en uno'],
      },
    },
    {
      id: 1199,
      emoji: '🪪',
      keywords: {
        en: ['firecracker', 'fireworks', 'celebration', 'explosion'],
        es: ['petardo', 'fuegos artificiales', 'celebración', 'explosión'],
      },
    },
  ],
  viajes: [
    {
      id: 1200,
      emoji: '🌍',
      keywords: {
        en: ['earth', 'globe', 'world', 'planet'],
        es: ['tierra', 'globo', 'mundo', 'planeta'],
      },
    },
    {
      id: 1201,
      emoji: '🌎',
      keywords: {
        en: ['earth', 'globe', 'world', 'planet'],
        es: ['tierra', 'globo', 'mundo', 'planeta'],
      },
    },
    {
      id: 1202,
      emoji: '🌏',
      keywords: {
        en: ['earth', 'globe', 'world', 'planet'],
        es: ['tierra', 'globo', 'mundo', 'planeta'],
      },
    },
    {
      id: 1203,
      emoji: '🌐',
      keywords: {
        en: ['globe', 'world', 'internet', 'communication'],
        es: ['globo', 'mundo', 'internet', 'comunicación'],
      },
    },
    {
      id: 1204,
      emoji: '🗺️',
      keywords: {
        en: ['world map', 'geography', 'location', 'navigation'],
        es: ['mapa mundial', 'geografía', 'ubicación', 'navegación'],
      },
    },
    {
      id: 1205,
      emoji: '🗾',
      keywords: {
        en: ['map of Japan', 'islands', 'geography', 'location'],
        es: ['mapa de Japón', 'islas', 'geografía', 'ubicación'],
      },
    },
    {
      id: 1206,
      emoji: '🧭',
      keywords: {
        en: ['compass', 'navigation', 'direction', 'orientation'],
        es: ['brújula', 'navegación', 'dirección', 'orientación'],
      },
    },
    {
      id: 1207,
      emoji: '🏔️',
      keywords: {
        en: ['snow-capped mountain', 'nature', 'cold', 'elevation'],
        es: ['montaña nevada', 'naturaleza', 'frío', 'elevación'],
      },
    },
    {
      id: 1208,
      emoji: '⛰️',
      keywords: {
        en: ['mountain', 'nature', 'height', 'elevation'],
        es: ['montaña', 'naturaleza', 'altura', 'elevación'],
      },
    },
    {
      id: 1209,
      emoji: '🌋',
      keywords: {
        en: ['volcano', 'nature', 'eruption', 'lava'],
        es: ['volcán', 'naturaleza', 'erupción', 'lava'],
      },
    },
    {
      id: 1210,
      emoji: '🗻',
      keywords: {
        en: ['mount fuji', 'Japan', 'nature', 'volcano'],
        es: ['monte Fuji', 'Japón', 'naturaleza', 'volcán'],
      },
    },
    {
      id: 1211,
      emoji: '🏕️',
      keywords: {
        en: ['camping', 'outdoors', 'tent', 'nature'],
        es: ['campamento', 'aire libre', 'carpa', 'naturaleza'],
      },
    },
    {
      id: 1212,
      emoji: '🏖️',
      keywords: {
        en: ['beach', 'vacation', 'coast', 'sea'],
        es: ['playa', 'vacaciones', 'costa', 'mar'],
      },
    },
    {
      id: 1213,
      emoji: '🏜️',
      keywords: {
        en: ['desert', 'arid', 'sand', 'landscape'],
        es: ['desierto', 'árido', 'arena', 'paisaje'],
      },
    },
    {
      id: 1214,
      emoji: '🏝️',
      keywords: {
        en: ['desert island', 'tropical', 'beach', 'paradise'],
        es: ['isla desierta', 'tropical', 'playa', 'paraíso'],
      },
    },
    {
      id: 1215,
      emoji: '🏞️',
      keywords: {
        en: ['national park', 'nature', 'landscape', 'scenery'],
        es: ['parque nacional', 'naturaleza', 'paisaje', 'escenario'],
      },
    },
    {
      id: 1216,
      emoji: '🏟️',
      keywords: {
        en: ['stadium', 'sports', 'venue', 'arena'],
        es: ['estadio', 'deportes', 'recinto', 'arena'],
      },
    },
    {
      id: 1217,
      emoji: '🏛️',
      keywords: {
        en: ['classical building', 'history', 'architecture', 'museum'],
        es: ['edificio clásico', 'historia', 'arquitectura', 'museo'],
      },
    },
    {
      id: 1218,
      emoji: '🏗️',
      keywords: {
        en: ['construction site', 'building', 'work', 'project'],
        es: ['obra de construcción', 'edificio', 'trabajo', 'proyecto'],
      },
    },
    {
      id: 1219,
      emoji: '🧱',
      keywords: {
        en: ['brick', 'construction', 'building', 'material'],
        es: ['ladrillo', 'construcción', 'edificio', 'material'],
      },
    },
    {
      id: 1220,
      emoji: '🪨',
      keywords: {
        en: ['rock', 'stone', 'nature', 'geology'],
        es: ['roca', 'piedra', 'naturaleza', 'geología'],
      },
    },
    {
      id: 1221,
      emoji: '🪵',
      keywords: {
        en: ['wood', 'nature', 'branch', 'tree'],
        es: ['madera', 'naturaleza', 'rama', 'árbol'],
      },
    },
    {
      id: 1222,
      emoji: '🛖',
      keywords: {
        en: ['hut', 'shelter', 'primitive', 'dwelling'],
        es: ['choza', 'refugio', 'primitivo', 'vivienda'],
      },
    },
    {
      id: 1223,
      emoji: '🏘️',
      keywords: {
        en: ['suburban', 'houses', 'neighborhood', 'residential'],
        es: ['suburbano', 'casas', 'vecindario', 'residencial'],
      },
    },
    {
      id: 1224,
      emoji: '🏚️',
      keywords: {
        en: ['derelict house', 'abandoned', 'ruin', 'decay'],
        es: ['casa abandonada', 'abandonado', 'ruina', 'deterioro'],
      },
    },
    {
      id: 1225,
      emoji: '🏠',
      keywords: {
        en: ['house', 'home', 'building', 'residential'],
        es: ['casa', 'hogar', 'edificio', 'residencial'],
      },
    },
    {
      id: 1226,
      emoji: '🏡',
      keywords: {
        en: ['house with garden', 'home', 'residential', 'yard'],
        es: ['casa con jardín', 'hogar', 'residencial', 'patio'],
      },
    },
    {
      id: 1227,
      emoji: '🏢',
      keywords: {
        en: ['office building', 'business', 'corporate', 'commercial'],
        es: ['edificio de oficinas', 'negocios', 'corporativo', 'comercial'],
      },
    },
    {
      id: 1228,
      emoji: '🏣',
      keywords: {
        en: ['Japanese post office', 'building', 'communication', 'mail'],
        es: ['oficina postal japonesa', 'edificio', 'comunicación', 'correo'],
      },
    },
    {
      id: 1229,
      emoji: '🏤',
      keywords: {
        en: ['post office', 'building', 'communication', 'mail'],
        es: ['oficina postal', 'edificio', 'comunicación', 'correo'],
      },
    },
    {
      id: 1230,
      emoji: '🏥',
      keywords: {
        en: ['hospital', 'health', 'medical', 'building'],
        es: ['hospital', 'salud', 'médico', 'edificio'],
      },
    },
    {
      id: 1231,
      emoji: '🏦',
      keywords: {
        en: ['bank', 'building', 'business', 'finance'],
        es: ['banco', 'edificio', 'negocios', 'finanzas'],
      },
    },
    {
      id: 1232,
      emoji: '🏨',
      keywords: {
        en: ['hotel', 'building', 'accommodation', 'lodging'],
        es: ['hotel', 'edificio', 'alojamiento', 'hospedaje'],
      },
    },
    {
      id: 1233,
      emoji: '🏩',
      keywords: {
        en: ['love hotel', 'building', 'romantic', 'lodging'],
        es: ['hotel romántico', 'edificio', 'romántico', 'hospedaje'],
      },
    },
    {
      id: 1234,
      emoji: '🏪',
      keywords: {
        en: ['convenience store', 'shop', 'market', 'retail'],
        es: ['tienda de conveniencia', 'tienda', 'mercado', 'comercio'],
      },
    },
    {
      id: 1235,
      emoji: '🏫',
      keywords: {
        en: ['school', 'building', 'education', 'institution'],
        es: ['escuela', 'edificio', 'educación', 'institución'],
      },
    },
    {
      id: 1236,
      emoji: '🏬',
      keywords: {
        en: ['department store', 'mall', 'shopping', 'retail'],
        es: ['tienda por departamentos', 'centro comercial', 'compras', 'comercio'],
      },
    },
    {
      id: 1237,
      emoji: '🏭',
      keywords: {
        en: ['factory', 'industry', 'manufacturing', 'production'],
        es: ['fábrica', 'industria', 'manufactura', 'producción'],
      },
    },
    {
      id: 1238,
      emoji: '🏯',
      keywords: {
        en: ['Japanese castle', 'fortress', 'history', 'architecture'],
        es: ['castillo japonés', 'fortaleza', 'historia', 'arquitectura'],
      },
    },
    {
      id: 1239,
      emoji: '🏰',
      keywords: {
        en: ['castle', 'fortress', 'royalty', 'medieval'],
        es: ['castillo', 'fortaleza', 'realeza', 'medieval'],
      },
    },
    {
      id: 1240,
      emoji: '💒',
      keywords: {
        en: ['wedding', 'marriage', 'chapel', 'love'],
        es: ['boda', 'matrimonio', 'capilla', 'amor'],
      },
    },
    {
      id: 1241,
      emoji: '🗼',
      keywords: {
        en: ['Tokyo Tower', 'Japan', 'landmark', 'communication'],
        es: ['Torre de Tokio', 'Japón', 'monumento', 'comunicación'],
      },
    },
    {
      id: 1242,
      emoji: '🗽',
      keywords: {
        en: ['Statue of Liberty', 'NYC', 'America', 'freedom'],
        es: ['Estatua de la Libertad', 'Nueva York', 'América', 'libertad'],
      },
    },
    {
      id: 1243,
      emoji: '⛪',
      keywords: {
        en: ['church', 'religion', 'worship', 'faith'],
        es: ['iglesia', 'religión', 'adoración', 'fe'],
      },
    },
    {
      id: 1244,
      emoji: '🕌',
      keywords: {
        en: ['mosque', 'islam', 'worship', 'religion'],
        es: ['mezquita', 'islam', 'adoración', 'religión'],
      },
    },
    {
      id: 1245,
      emoji: '🛕',
      keywords: {
        en: ['hindu temple', 'religion', 'worship', 'architecture'],
        es: ['templo hindú', 'religión', 'adoración', 'arquitectura'],
      },
    },
    {
      id: 1246,
      emoji: '🕍',
      keywords: {
        en: ['synagogue', 'judaism', 'worship', 'religion'],
        es: ['sinagoga', 'judaísmo', 'adoración', 'religión'],
      },
    },
    {
      id: 1247,
      emoji: '⛩️',
      keywords: {
        en: ['shinto shrine', 'Japan', 'worship', 'religion'],
        es: ['santuario sintoísta', 'Japón', 'adoración', 'religión'],
      },
    },
    {
      id: 1248,
      emoji: '🕋',
      keywords: {
        en: ['kaaba', 'islam', 'worship', 'religion'],
        es: ['kaaba', 'islam', 'adoración', 'religión'],
      },
    },
    {
      id: 1249,
      emoji: '⛲',
      keywords: {
        en: ['fountain', 'water', 'decorative', 'feature'],
        es: ['fuente', 'agua', 'decorativo', 'elemento'],
      },
    },
    {
      id: 1250,
      emoji: '⛺',
      keywords: {
        en: ['tent', 'camping', 'outdoors', 'shelter'],
        es: ['carpa', 'campamento', 'aire libre', 'refugio'],
      },
    },
    {
      id: 1251,
      emoji: '🌁',
      keywords: {
        en: ['foggy', 'weather', 'cloud', 'mist'],
        es: ['neblinoso', 'clima', 'nube', 'niebla'],
      },
    },
    {
      id: 1252,
      emoji: '🌃',
      keywords: {
        en: ['night with stars', 'evening', 'sky', 'astronomy'],
        es: ['noche con estrellas', 'noche', 'cielo', 'astronomía'],
      },
    },
    {
      id: 1253,
      emoji: '🏙️',
      keywords: {
        en: ['cityscape', 'urban', 'skyline', 'buildings'],
        es: ['paisaje urbano', 'urbano', 'horizonte', 'edificios'],
      },
    },
    {
      id: 1254,
      emoji: '🌄',
      keywords: {
        en: ['sunrise over mountains', 'morning', 'landscape', 'nature'],
        es: ['amanecer sobre montañas', 'mañana', 'paisaje', 'naturaleza'],
      },
    },
    {
      id: 1255,
      emoji: '🌅',
      keywords: {
        en: ['sunrise', 'morning', 'sky', 'horizon'],
        es: ['amanecer', 'mañana', 'cielo', 'horizonte'],
      },
    },
    {
      id: 1256,
      emoji: '🌆',
      keywords: {
        en: ['cityscape at dusk', 'urban', 'evening', 'sky'],
        es: ['ciudad al atardecer', 'urbano', 'tarde', 'cielo'],
      },
    },
    {
      id: 1257,
      emoji: '🌇',
      keywords: {
        en: ['sunset', 'evening', 'sky', 'horizon'],
        es: ['atardecer', 'tarde', 'cielo', 'horizonte'],
      },
    },
    {
      id: 1258,
      emoji: '🌉',
      keywords: {
        en: ['bridge at night', 'evening', 'structure', 'city'],
        es: ['puente de noche', 'noche', 'estructura', 'ciudad'],
      },
    },
    {
      id: 1259,
      emoji: '♨️',
      keywords: {
        en: ['hot springs', 'onsen', 'bath', 'relaxation'],
        es: ['aguas termales', 'onsen', 'baño', 'relajación'],
      },
    },
    {
      id: 1260,
      emoji: '🎠',
      keywords: {
        en: ['carousel', 'carnival', 'amusement park', 'ride'],
        es: ['carrusel', 'carnaval', 'parque de diversiones', 'atracción'],
      },
    },
    {
      id: 1261,
      emoji: '🛝',
      keywords: {
        en: ['cinema', 'movie', 'film', 'theater'],
        es: ['cine', 'película', 'film', 'teatro'],
      },
    },
    {
      id: 1262,
      emoji: '🎡',
      keywords: {
        en: ['ferris wheel', 'carnival', 'amusement park', 'ride'],
        es: ['rueda de la fortuna', 'carnaval', 'parque de diversiones', 'atracción'],
      },
    },
    {
      id: 1263,
      emoji: '🎢',
      keywords: {
        en: ['roller coaster', 'carnival', 'amusement park', 'ride'],
        es: ['montaña rusa', 'carnaval', 'parque de diversiones', 'atracción'],
      },
    },
    {
      id: 1264,
      emoji: '💈',
      keywords: {
        en: ['barber pole', 'barbershop', 'haircut', 'grooming'],
        es: ['poste de barbería', 'barbería', 'corte de cabello', 'arreglo personal'],
      },
    },
    {
      id: 1265,
      emoji: '🎪',
      keywords: {
        en: ['circus tent', 'carnival', 'amusement park', 'event'],
        es: ['carpa de circo', 'carnaval', 'parque de diversiones', 'evento'],
      },
    },
    {
      id: 1266,
      emoji: '🚂',
      keywords: {
        en: ['train', 'travel', 'transportation', 'railway'],
        es: ['tren', 'viaje', 'transporte', 'ferrocarril'],
      },
    },
    {
      id: 1267,
      emoji: '🚃',
      keywords: {
        en: ['tram car', 'transportation', 'vehicle', 'railway'],
        es: ['vagón de tranvía', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1268,
      emoji: '🚄',
      keywords: {
        en: ['high-speed train', 'transportation', 'vehicle', 'railway'],
        es: ['tren de alta velocidad', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1269,
      emoji: '🚅',
      keywords: {
        en: ['bullet train', 'transportation', 'vehicle', 'railway'],
        es: ['tren bala', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1270,
      emoji: '🚆',
      keywords: {
        en: ['train', 'transportation', 'vehicle', 'railway'],
        es: ['tren', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1271,
      emoji: '🚇',
      keywords: {
        en: ['subway', 'metro', 'transportation', 'vehicle'],
        es: ['metro', 'subterráneo', 'transporte', 'vehículo'],
      },
    },
    {
      id: 1272,
      emoji: '🚈',
      keywords: {
        en: ['light rail', 'transportation', 'vehicle', 'railway'],
        es: ['tren ligero', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1273,
      emoji: '🚉',
      keywords: {
        en: ['station', 'train', 'transportation', 'platform'],
        es: ['estación', 'tren', 'transporte', 'andén'],
      },
    },
    {
      id: 1274,
      emoji: '🚊',
      keywords: {
        en: ['tram', 'transportation', 'vehicle', 'railway'],
        es: ['tranvía', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1275,
      emoji: '🚝',
      keywords: {
        en: ['monorail', 'transportation', 'vehicle', 'railway'],
        es: ['monorriel', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1276,
      emoji: '🚞',
      keywords: {
        en: ['mountain railway', 'transportation', 'vehicle', 'railway'],
        es: ['tren de montaña', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1277,
      emoji: '🚋',
      keywords: {
        en: ['tram car', 'transportation', 'vehicle', 'railway'],
        es: ['vagón de tranvía', 'transporte', 'vehículo', 'ferrocarril'],
      },
    },
    {
      id: 1278,
      emoji: '🚌',
      keywords: {
        en: ['bus', 'transportation', 'vehicle', 'commute'],
        es: ['autobús', 'transporte', 'vehículo', 'viaje diario'],
      },
    },
    {
      id: 1279,
      emoji: '🚍',
      keywords: {
        en: ['oncoming bus', 'transportation', 'vehicle', 'commute'],
        es: ['autobús de frente', 'transporte', 'vehículo', 'viaje diario'],
      },
    },
    {
      id: 1280,
      emoji: '🚎',
      keywords: {
        en: ['trolleybus', 'transportation', 'vehicle', 'commute'],
        es: ['trolebús', 'transporte', 'vehículo', 'viaje diario'],
      },
    },
    {
      id: 1281,
      emoji: '🚐',
      keywords: {
        en: ['minibus', 'transportation', 'vehicle', 'commute'],
        es: ['microbús', 'transporte', 'vehículo', 'viaje diario'],
      },
    },
    {
      id: 1282,
      emoji: '🚑',
      keywords: {
        en: ['ambulance', 'emergency', 'vehicle', 'health'],
        es: ['ambulancia', 'emergencia', 'vehículo', 'salud'],
      },
    },
    {
      id: 1283,
      emoji: '🚒',
      keywords: {
        en: ['fire engine', 'fire truck', 'vehicle', 'firefighter'],
        es: ['camión de bomberos', 'carro de bomberos', 'vehículo', 'bombero'],
      },
    },
    {
      id: 1284,
      emoji: '🚓',
      keywords: {
        en: ['police car', 'law enforcement', 'vehicle', 'patrol'],
        es: ['carro de policía', 'autoridad', 'vehículo', 'patrulla'],
      },
    },
    {
      id: 1285,
      emoji: '🚔',
      keywords: {
        en: ['oncoming police car', 'law enforcement', 'vehicle', 'patrol'],
        es: ['carro de policía de frente', 'autoridad', 'vehículo', 'patrulla'],
      },
    },
    {
      id: 1286,
      emoji: '🚕',
      keywords: {
        en: ['taxi', 'transportation', 'vehicle', 'ride'],
        es: ['taxi', 'transporte', 'vehículo', 'viaje'],
      },
    },
    {
      id: 1287,
      emoji: '🚖',
      keywords: {
        en: ['oncoming taxi', 'transportation', 'vehicle', 'ride'],
        es: ['taxi de frente', 'transporte', 'vehículo', 'viaje'],
      },
    },
    {
      id: 1288,
      emoji: '🚗',
      keywords: {
        en: ['car', 'vehicle', 'transportation', 'drive'],
        es: ['carro', 'vehículo', 'transporte', 'conducir'],
      },
    },
    {
      id: 1289,
      emoji: '🚘',
      keywords: {
        en: ['oncoming car', 'vehicle', 'transportation', 'drive'],
        es: ['carro de frente', 'vehículo', 'transporte', 'conducir'],
      },
    },
    {
      id: 1290,
      emoji: '🚙',
      keywords: {
        en: ['sport utility vehicle', 'vehicle', 'transportation', 'off-road'],
        es: ['camioneta', 'vehículo', 'transporte', 'todoterreno'],
      },
    },
    {
      id: 1291,
      emoji: '🛻',
      keywords: {
        en: ['pickup truck', 'vehicle', 'transportation', 'cargo'],
        es: ['camioneta pickup', 'vehículo', 'transporte', 'carga'],
      },
    },
    {
      id: 1292,
      emoji: '🚚',
      keywords: {
        en: ['delivery truck', 'vehicle', 'transportation', 'cargo'],
        es: ['camión de reparto', 'vehículo', 'transporte', 'carga'],
      },
    },
    {
      id: 1293,
      emoji: '🚛',
      keywords: {
        en: ['articulated lorry', 'vehicle', 'transportation', 'cargo'],
        es: ['camión articulado', 'vehículo', 'transporte', 'carga'],
      },
    },
    {
      id: 1294,
      emoji: '🚜',
      keywords: {
        en: ['tractor', 'vehicle', 'farming', 'agriculture'],
        es: ['tractor', 'vehículo', 'granja', 'agricultura'],
      },
    },
    {
      id: 1295,
      emoji: '🏎️',
      keywords: {
        en: ['racing car', 'vehicle', 'speed', 'race'],
        es: ['carro de carreras', 'vehículo', 'velocidad', 'carrera'],
      },
    },
    {
      id: 1296,
      emoji: '🏍️',
      keywords: {
        en: ['motorcycle', 'vehicle', 'transportation', 'bike'],
        es: ['motocicleta', 'vehículo', 'transporte', 'moto'],
      },
    },
    {
      id: 1297,
      emoji: '🛵',
      keywords: {
        en: ['motor scooter', 'vehicle', 'transportation', 'bike'],
        es: ['motoneta', 'vehículo', 'transporte', 'moto'],
      },
    },
    {
      id: 1298,
      emoji: '🦽',
      keywords: {
        en: ['manual wheelchair', 'accessibility', 'mobility', 'disability'],
        es: ['silla de ruedas manual', 'accesibilidad', 'movilidad', 'discapacidad'],
      },
    },
    {
      id: 1299,
      emoji: '🦼',
      keywords: {
        en: ['motorized wheelchair', 'accessibility', 'mobility', 'disability'],
        es: ['silla de ruedas motorizada', 'accesibilidad', 'movilidad', 'discapacidad'],
      },
    },
    {
      id: 1300,
      emoji: '🛺',
      keywords: {
        en: ['auto rickshaw', 'vehicle', 'transportation', 'ride'],
        es: ['mototaxi', 'vehículo', 'transporte', 'viaje'],
      },
    },
    {
      id: 1301,
      emoji: '🚲',
      keywords: {
        en: ['bicycle', 'bike', 'transportation', 'exercise'],
        es: ['bicicleta', 'bici', 'transporte', 'ejercicio'],
      },
    },
    {
      id: 1302,
      emoji: '🛴',
      keywords: {
        en: ['kick scooter', 'vehicle', 'transportation', 'ride'],
        es: ['patineta', 'vehículo', 'transporte', 'paseo'],
      },
    },
    {
      id: 1303,
      emoji: '🛹',
      keywords: {
        en: ['skateboard', 'sports', 'recreation', 'ride'],
        es: ['patineta', 'deportes', 'recreación', 'paseo'],
      },
    },
    {
      id: 1304,
      emoji: '🛼',
      keywords: {
        en: ['roller skate', 'sports', 'recreation', 'activity'],
        es: ['patín', 'deportes', 'recreación', 'actividad'],
      },
    },
    {
      id: 1305,
      emoji: '🚏',
      keywords: {
        en: ['bus stop', 'transportation', 'station', 'waiting'],
        es: ['parada de autobús', 'transporte', 'estación', 'espera'],
      },
    },
    {
      id: 1306,
      emoji: '🛣️',
      keywords: {
        en: ['motorway', 'highway', 'road', 'transportation'],
        es: ['autopista', 'carretera', 'vía', 'transporte'],
      },
    },
    {
      id: 1307,
      emoji: '🛤️',
      keywords: {
        en: ['railway track', 'train', 'transportation', 'route'],
        es: ['vía férrea', 'tren', 'transporte', 'ruta'],
      },
    },
    {
      id: 1308,
      emoji: '🛢️',
      keywords: {
        en: ['oil drum', 'fuel', 'petroleum', 'container'],
        es: ['barril de petróleo', 'combustible', 'petróleo', 'contenedor'],
      },
    },
    {
      id: 1309,
      emoji: '⛽',
      keywords: {
        en: ['fuel pump', 'gas station', 'petrol', 'energy'],
        es: ['surtidor de gasolina', 'gasolinera', 'gasolina', 'energía'],
      },
    },
    {
      id: 1310,
      emoji: '🛞',
      keywords: {
        en: ['railway track', 'train', 'transportation', 'route'],
        es: ['vía férrea', 'tren', 'transporte', 'ruta'],
      },
    },
    {
      id: 1311,
      emoji: '🚨',
      keywords: {
        en: ['police car light', 'emergency', 'alert', 'siren'],
        es: ['luz de patrulla', 'emergencia', 'alerta', 'sirena'],
      },
    },
    {
      id: 1312,
      emoji: '🚥',
      keywords: {
        en: ['traffic light', 'signal', 'stop', 'intersection'],
        es: ['semáforo', 'señal', 'alto', 'intersección'],
      },
    },
    {
      id: 1313,
      emoji: '🚦',
      keywords: {
        en: ['traffic light', 'signal', 'stop', 'intersection'],
        es: ['semáforo', 'señal', 'alto', 'intersección'],
      },
    },
    {
      id: 1314,
      emoji: '🛑',
      keywords: {
        en: ['stop sign', 'warning', 'alert', 'prohibition'],
        es: ['señal de pare', 'advertencia', 'alerta', 'prohibición'],
      },
    },
    {
      id: 1315,
      emoji: '🚧',
      keywords: {
        en: ['construction barrier', 'caution', 'warning', 'obstacle'],
        es: ['barrera de construcción', 'precaución', 'advertencia', 'obstáculo'],
      },
    },
    {
      id: 1316,
      emoji: '⚓',
      keywords: {
        en: ['anchor', 'ship', 'boat', 'navy'],
        es: ['ancla', 'barco', 'bote', 'marina'],
      },
    },
    {
      id: 1317,
      emoji: '⚓',
      keywords: {
        en: ['anchor', 'nautical', 'ship', 'marine'],
        es: ['ancla', 'náutico', 'barco', 'marino'],
      },
    },
    {
      id: 1318,
      emoji: '🛟',
      keywords: {
        en: ['bed', 'furniture', 'sleep', 'rest'],
        es: ['cama', 'mueble', 'dormir', 'descanso'],
      },
    },
    {
      id: 1319,
      emoji: '⛵',
      keywords: {
        en: ['sailboat', 'boat', 'water', 'sailing'],
        es: ['velero', 'bote', 'agua', 'navegar'],
      },
    },
    {
      id: 1320,
      emoji: '🛶',
      keywords: {
        en: ['canoe', 'boat', 'paddle', 'water'],
        es: ['canoa', 'bote', 'remo', 'agua'],
      },
    },
    {
      id: 1321,
      emoji: '🚤',
      keywords: {
        en: ['speedboat', 'boat', 'water', 'fast'],
        es: ['lancha rápida', 'bote', 'agua', 'rápido'],
      },
    },
    {
      id: 1322,
      emoji: '🛳️',
      keywords: {
        en: ['passenger ship', 'cruise', 'travel', 'ocean'],
        es: ['barco de pasajeros', 'crucero', 'viaje', 'océano'],
      },
    },
    {
      id: 1323,
      emoji: '⛴️',
      keywords: {
        en: ['ferry', 'ship', 'boat', 'water'],
        es: ['ferri', 'barco', 'bote', 'agua'],
      },
    },
    {
      id: 1324,
      emoji: '🛥️',
      keywords: {
        en: ['motorboat', 'boat', 'water', 'engine'],
        es: ['lancha', 'bote', 'agua', 'motor'],
      },
    },
    {
      id: 1325,
      emoji: '🚢',
      keywords: {
        en: ['ship', 'boat', 'vessel', 'sea'],
        es: ['barco', 'bote', 'embarcación', 'mar'],
      },
    },
    {
      id: 1326,
      emoji: '✈️',
      keywords: {
        en: ['airplane', 'plane', 'flight', 'travel'],
        es: ['avión', 'aeronave', 'vuelo', 'viaje'],
      },
    },
    {
      id: 1327,
      emoji: '🛩️',
      keywords: {
        en: ['small airplane', 'plane', 'travel', 'aircraft'],
        es: ['avión pequeño', 'aeronave', 'viaje', 'avioneta'],
      },
    },
    {
      id: 1328,
      emoji: '🛫',
      keywords: {
        en: ['airplane departure', 'takeoff', 'flight', 'departure'],
        es: ['salida de avión', 'despegue', 'vuelo', 'salida'],
      },
    },
    {
      id: 1329,
      emoji: '🛬',
      keywords: {
        en: ['airplane arrival', 'landing', 'flight', 'arrival'],
        es: ['llegada de avión', 'aterrizaje', 'vuelo', 'llegada'],
      },
    },
    {
      id: 1330,
      emoji: '🪂',
      keywords: {
        en: ['parachute', 'skydiving', 'jump', 'fall'],
        es: ['paracaídas', 'paracaidismo', 'salto', 'caída'],
      },
    },
    {
      id: 1331,
      emoji: '💺',
      keywords: {
        en: ['seat', 'chair', 'airplane', 'furniture'],
        es: ['asiento', 'silla', 'avión', 'mueble'],
      },
    },
    {
      id: 1332,
      emoji: '🚁',
      keywords: {
        en: ['helicopter', 'flight', 'rotor', 'aircraft'],
        es: ['helicóptero', 'vuelo', 'rotor', 'aeronave'],
      },
    },
    {
      id: 1333,
      emoji: '🚟',
      keywords: {
        en: ['suspension railway', 'train', 'transportation', 'rail'],
        es: ['tren suspendido', 'tren', 'transporte', 'riel'],
      },
    },
    {
      id: 1334,
      emoji: '🚠',
      keywords: {
        en: ['mountain cableway', 'transportation', 'cable car', 'ride'],
        es: ['teleférico de montaña', 'transporte', 'teleférico', 'paseo'],
      },
    },
    {
      id: 1335,
      emoji: '🚡',
      keywords: {
        en: ['aerial tramway', 'transportation', 'cable car', 'ride'],
        es: ['tranvía aéreo', 'transporte', 'teleférico', 'paseo'],
      },
    },
    {
      id: 1336,
      emoji: '🛰️',
      keywords: {
        en: ['satellite', 'space', 'orbit', 'communication'],
        es: ['satélite', 'espacio', 'órbita', 'comunicación'],
      },
    },
    {
      id: 1337,
      emoji: '🚀',
      keywords: {
        en: ['rocket', 'launch', 'space', 'astronaut'],
        es: ['cohete', 'lanzamiento', 'espacio', 'astronauta'],
      },
    },
    {
      id: 1338,
      emoji: '🛸',
      keywords: {
        en: ['flying saucer', 'UFO', 'alien', 'spacecraft'],
        es: ['platillo volador', 'ovni', 'alienígena', 'nave espacial'],
      },
    },
    {
      id: 1339,
      emoji: '🛎️',
      keywords: {
        en: ['bellhop bell', 'hotel', 'service', 'ring'],
        es: ['campana de recepción', 'hotel', 'servicio', 'timbre'],
      },
    },
    {
      id: 1340,
      emoji: '🧳',
      keywords: {
        en: ['luggage', 'travel', 'bag', 'packing'],
        es: ['equipaje', 'viaje', 'bolso', 'empacar'],
      },
    },
    {
      id: 1341,
      emoji: '⌛',
      keywords: {
        en: ['hourglass done', 'time', 'countdown', 'deadline'],
        es: ['reloj de arena terminado', 'tiempo', 'cuenta regresiva', 'fecha límite'],
      },
    },
    {
      id: 1342,
      emoji: '⏳',
      keywords: {
        en: ['hourglass not done', 'time', 'countdown', 'waiting'],
        es: ['reloj de arena en curso', 'tiempo', 'cuenta regresiva', 'esperando'],
      },
    },
    {
      id: 1343,
      emoji: '⌚',
      keywords: {
        en: ['watch', 'time', 'wristwatch', 'clock'],
        es: ['reloj', 'tiempo', 'reloj de pulsera', 'hora'],
      },
    },
    {
      id: 1344,
      emoji: '⏰',
      keywords: {
        en: ['alarm clock', 'time', 'wake up', 'morning'],
        es: ['despertador', 'tiempo', 'despertar', 'mañana'],
      },
    },
    {
      id: 1345,
      emoji: '⏱️',
      keywords: {
        en: ['stopwatch', 'time', 'timer', 'clock'],
        es: ['cronómetro', 'tiempo', 'temporizador', 'reloj'],
      },
    },
    {
      id: 1346,
      emoji: '⏲️',
      keywords: {
        en: ['timer clock', 'time', 'alarm', 'countdown'],
        es: ['temporizador', 'tiempo', 'alarma', 'cuenta regresiva'],
      },
    },
    {
      id: 1347,
      emoji: '🕰️',
      keywords: {
        en: ['mantelpiece clock', 'time', 'clock', 'decor'],
        es: ['reloj de mesa', 'tiempo', 'reloj', 'decoración'],
      },
    },
    {
      id: 1348,
      emoji: '🕛',
      keywords: {
        en: ['twelve o’clock', 'time', 'midnight', 'noon'],
        es: ['doce en punto', 'tiempo', 'medianoche', 'mediodía'],
      },
    },
    {
      id: 1349,
      emoji: '🕧',
      keywords: {
        en: ['twelve-thirty', 'time', 'noon', 'midnight'],
        es: ['doce y media', 'tiempo', 'mediodía', 'medianoche'],
      },
    },
    {
      id: 1350,
      emoji: '🕐',
      keywords: {
        en: ['one o’clock', 'time', 'hour', 'clock'],
        es: ['una en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1351,
      emoji: '🕜',
      keywords: {
        en: ['one-thirty', 'time', 'half past one', 'clock'],
        es: ['una y media', 'tiempo', 'media pasada la una', 'reloj'],
      },
    },
    {
      id: 1352,
      emoji: '🕑',
      keywords: {
        en: ['two o’clock', 'time', 'hour', 'clock'],
        es: ['dos en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1353,
      emoji: '🕝',
      keywords: {
        en: ['two-thirty', 'time', 'half past two', 'clock'],
        es: ['dos y media', 'tiempo', 'media pasada las dos', 'reloj'],
      },
    },
    {
      id: 1354,
      emoji: '🕒',
      keywords: {
        en: ['three o’clock', 'time', 'hour', 'clock'],
        es: ['tres en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1355,
      emoji: '🕞',
      keywords: {
        en: ['three-thirty', 'time', 'half past three', 'clock'],
        es: ['tres y media', 'tiempo', 'media pasada las tres', 'reloj'],
      },
    },
    {
      id: 1356,
      emoji: '🕓',
      keywords: {
        en: ['four o’clock', 'time', 'hour', 'clock'],
        es: ['cuatro en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1357,
      emoji: '🕟',
      keywords: {
        en: ['four-thirty', 'time', 'half past four', 'clock'],
        es: ['cuatro y media', 'tiempo', 'media pasada las cuatro', 'reloj'],
      },
    },
    {
      id: 1358,
      emoji: '🕔',
      keywords: {
        en: ['five o’clock', 'time', 'hour', 'clock'],
        es: ['cinco en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1359,
      emoji: '🕠',
      keywords: {
        en: ['five-thirty', 'time', 'half past five', 'clock'],
        es: ['cinco y media', 'tiempo', 'media pasada las cinco', 'reloj'],
      },
    },
    {
      id: 1360,
      emoji: '🕕',
      keywords: {
        en: ['six o’clock', 'time', 'hour', 'clock'],
        es: ['seis en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1361,
      emoji: '🕡',
      keywords: {
        en: ['six-thirty', 'time', 'half past six', 'clock'],
        es: ['seis y media', 'tiempo', 'media pasada las seis', 'reloj'],
      },
    },
    {
      id: 1362,
      emoji: '🕖',
      keywords: {
        en: ['seven o’clock', 'time', 'hour', 'clock'],
        es: ['siete en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1363,
      emoji: '🕢',
      keywords: {
        en: ['seven-thirty', 'time', 'half past seven', 'clock'],
        es: ['siete y media', 'tiempo', 'media pasada las siete', 'reloj'],
      },
    },
    {
      id: 1364,
      emoji: '🕗',
      keywords: {
        en: ['eight o’clock', 'time', 'hour', 'clock'],
        es: ['ocho en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1365,
      emoji: '🕣',
      keywords: {
        en: ['eight-thirty', 'time', 'half past eight', 'clock'],
        es: ['ocho y media', 'tiempo', 'media pasada las ocho', 'reloj'],
      },
    },
    {
      id: 1366,
      emoji: '🕘',
      keywords: {
        en: ['nine o’clock', 'time', 'hour', 'clock'],
        es: ['nueve en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1367,
      emoji: '🕤',
      keywords: {
        en: ['nine-thirty', 'time', 'half past nine', 'clock'],
        es: ['nueve y media', 'tiempo', 'media pasada las nueve', 'reloj'],
      },
    },
    {
      id: 1368,
      emoji: '🕙',
      keywords: {
        en: ['ten o’clock', 'time', 'hour', 'clock'],
        es: ['diez en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1369,
      emoji: '🕥',
      keywords: {
        en: ['ten-thirty', 'time', 'half past ten', 'clock'],
        es: ['diez y media', 'tiempo', 'media pasada las diez', 'reloj'],
      },
    },
    {
      id: 1370,
      emoji: '🕚',
      keywords: {
        en: ['eleven o’clock', 'time', 'hour', 'clock'],
        es: ['once en punto', 'tiempo', 'hora', 'reloj'],
      },
    },
    {
      id: 1371,
      emoji: '🕦',
      keywords: {
        en: ['eleven-thirty', 'time', 'half past eleven', 'clock'],
        es: ['once y media', 'tiempo', 'media pasada las once', 'reloj'],
      },
    },
  ],
  simbolos: [
    {
      id: 1372,
      emoji: '🏧',
      keywords: {
        en: ['ATM', 'bank', 'automated teller', 'money'],
        es: ['cajero automático', 'banco', 'cajero', 'dinero'],
      },
    },
    {
      id: 1373,
      emoji: '🚮',
      keywords: {
        en: ['trash can', 'garbage', 'bin', 'dispose'],
        es: ['caneca de basura', 'basura', 'contenedor', 'desechar'],
      },
    },
    {
      id: 1374,
      emoji: '🚰',
      keywords: {
        en: ['potable water', 'drink', 'faucet', 'hydration'],
        es: ['agua potable', 'beber', 'grifo', 'hidratación'],
      },
    },
    {
      id: 1375,
      emoji: '♿',
      keywords: {
        en: ['wheelchair', 'accessible', 'disability', 'mobility'],
        es: ['silla de ruedas', 'accesible', 'discapacidad', 'movilidad'],
      },
    },
    {
      id: 1376,
      emoji: '🚹',
      keywords: {
        en: ['men', 'restroom', 'toilet', 'gentlemen'],
        es: ['hombres', 'baño', 'sanitario', 'caballeros'],
      },
    },
    {
      id: 1377,
      emoji: '🚺',
      keywords: {
        en: ['women', 'restroom', 'toilet', 'ladies'],
        es: ['mujeres', 'baño', 'sanitario', 'damas'],
      },
    },
    {
      id: 1378,
      emoji: '🚻',
      keywords: {
        en: ['restroom', 'toilet', 'gender-neutral', 'WC'],
        es: ['baño', 'sanitario', 'género neutro', 'WC'],
      },
    },
    {
      id: 1379,
      emoji: '🚼',
      keywords: {
        en: ['baby changing', 'diaper', 'infant', 'child'],
        es: ['cambio de bebé', 'pañal', 'bebé', 'niño'],
      },
    },
    {
      id: 1380,
      emoji: '🚾',
      keywords: {
        en: ['water closet', 'toilet', 'restroom', 'bathroom'],
        es: ['baño', 'sanitario', 'aseo', 'WC'],
      },
    },
    {
      id: 1381,
      emoji: '🛂',
      keywords: {
        en: ['passport control', 'customs', 'airport', 'travel'],
        es: ['control de pasaportes', 'aduana', 'aeropuerto', 'viaje'],
      },
    },
    {
      id: 1382,
      emoji: '🛃',
      keywords: {
        en: ['customs', 'security', 'inspection', 'border'],
        es: ['aduana', 'seguridad', 'inspección', 'frontera'],
      },
    },
    {
      id: 1383,
      emoji: '🛄',
      keywords: {
        en: ['baggage claim', 'airport', 'luggage', 'travel'],
        es: ['reclamo de equipaje', 'aeropuerto', 'equipaje', 'viaje'],
      },
    },
    {
      id: 1384,
      emoji: '🛅',
      keywords: {
        en: ['left luggage', 'storage', 'locker', 'travel'],
        es: ['consigna de equipaje', 'almacenamiento', 'casillero', 'viaje'],
      },
    },
    {
      id: 1385,
      emoji: '🗣️',
      keywords: {
        en: ['speaking head', 'talk', 'discussion', 'communication'],
        es: ['cabeza hablando', 'hablar', 'discusión', 'comunicación'],
      },
    },
    {
      id: 1386,
      emoji: '👤',
      keywords: {
        en: ['bust in silhouette', 'user', 'person', 'profile'],
        es: ['silueta de persona', 'usuario', 'persona', 'perfil'],
      },
    },
    {
      id: 1387,
      emoji: '👥',
      keywords: {
        en: ['busts in silhouette', 'users', 'people', 'profile'],
        es: ['siluetas de personas', 'usuarios', 'personas', 'perfil'],
      },
    },
    {
      id: 1388,
      emoji: '🫂',
      keywords: {
        en: ['people hugging', 'hug', 'embrace', 'support'],
        es: ['personas abrazándose', 'abrazo', 'abrazar', 'apoyo'],
      },
    },
    {
      id: 1389,
      emoji: '👣',
      keywords: {
        en: ['footprints', 'feet', 'tracking', 'trail'],
        es: ['huellas', 'pies', 'rastreo', 'camino'],
      },
    },
    {
      id: 1390,
      emoji: '⚠️',
      keywords: {
        en: ['warning', 'caution', 'alert', 'danger'],
        es: ['advertencia', 'precaución', 'alerta', 'peligro'],
      },
    },
    {
      id: 1391,
      emoji: '🚸',
      keywords: {
        en: ['children crossing', 'crosswalk', 'warning', 'school'],
        es: ['cruce de niños', 'paso peatonal', 'advertencia', 'escuela'],
      },
    },
    {
      id: 1392,
      emoji: '⛔',
      keywords: {
        en: ['no entry', 'forbidden', 'prohibited', 'access'],
        es: ['prohibido el paso', 'prohibido', 'restringido', 'acceso'],
      },
    },
    {
      id: 1393,
      emoji: '🚫',
      keywords: {
        en: ['no entry sign', 'forbidden', 'prohibited', 'stop'],
        es: ['señal de prohibido', 'prohibido', 'restringido', 'alto'],
      },
    },
    {
      id: 1394,
      emoji: '🚳',
      keywords: {
        en: ['no bicycles', 'forbidden', 'prohibited', 'bikes'],
        es: ['prohibido bicicletas', 'prohibido', 'restringido', 'bicicletas'],
      },
    },
    {
      id: 1395,
      emoji: '🚭',
      keywords: {
        en: ['no smoking', 'forbidden', 'prohibited', 'smoke'],
        es: ['prohibido fumar', 'prohibido', 'restringido', 'humo'],
      },
    },
    {
      id: 1396,
      emoji: '🚯',
      keywords: {
        en: ['no littering', 'forbidden', 'prohibited', 'trash'],
        es: ['prohibido tirar basura', 'prohibido', 'restringido', 'basura'],
      },
    },
    {
      id: 1397,
      emoji: '🚱',
      keywords: {
        en: ['non-potable water', 'forbidden', 'prohibited', 'drink'],
        es: ['agua no potable', 'prohibido', 'restringido', 'beber'],
      },
    },
    {
      id: 1398,
      emoji: '🚷',
      keywords: {
        en: ['no pedestrians', 'forbidden', 'prohibited', 'walking'],
        es: ['prohibido peatones', 'prohibido', 'restringido', 'caminar'],
      },
    },
    {
      id: 1399,
      emoji: '📵',
      keywords: {
        en: ['no mobile phones', 'forbidden', 'prohibited', 'cell'],
        es: ['prohibido celulares', 'prohibido', 'restringido', 'celular'],
      },
    },
    {
      id: 1400,
      emoji: '🔞',
      keywords: {
        en: ['no one under 18', 'eighteen', 'adults only', 'forbidden'],
        es: ['prohibido menores de 18', 'dieciocho', 'solo adultos', 'prohibido'],
      },
    },
    {
      id: 1401,
      emoji: '☢️',
      keywords: {
        en: ['radioactive', 'danger', 'hazard', 'nuclear'],
        es: ['radiactivo', 'peligro', 'riesgo', 'nuclear'],
      },
    },
    {
      id: 1402,
      emoji: '☣️',
      keywords: {
        en: ['biohazard', 'danger', 'hazard', 'toxic'],
        es: ['riesgo biológico', 'peligro', 'riesgo', 'tóxico'],
      },
    },
    {
      id: 1403,
      emoji: '⬆️',
      keywords: {
        en: ['up arrow', 'direction', 'elevate', 'increase'],
        es: ['flecha arriba', 'dirección', 'elevar', 'aumentar'],
      },
    },
    {
      id: 1404,
      emoji: '↗️',
      keywords: {
        en: ['up-right arrow', 'direction', 'northeast', 'diagonal'],
        es: ['flecha arriba derecha', 'dirección', 'noreste', 'diagonal'],
      },
    },
    {
      id: 1405,
      emoji: '➡️',
      keywords: {
        en: ['right arrow', 'direction', 'forward', 'next'],
        es: ['flecha derecha', 'dirección', 'adelante', 'siguiente'],
      },
    },
    {
      id: 1406,
      emoji: '↘️',
      keywords: {
        en: ['down-right arrow', 'direction', 'southeast', 'diagonal'],
        es: ['flecha abajo derecha', 'dirección', 'sureste', 'diagonal'],
      },
    },
    {
      id: 1407,
      emoji: '⬇️',
      keywords: {
        en: ['down arrow', 'direction', 'lower', 'decrease'],
        es: ['flecha abajo', 'dirección', 'bajar', 'disminuir'],
      },
    },
    {
      id: 1408,
      emoji: '↙️',
      keywords: {
        en: ['down-left arrow', 'direction', 'southwest', 'diagonal'],
        es: ['flecha abajo izquierda', 'dirección', 'suroeste', 'diagonal'],
      },
    },
    {
      id: 1409,
      emoji: '⬅️',
      keywords: {
        en: ['left arrow', 'direction', 'backward', 'previous'],
        es: ['flecha izquierda', 'dirección', 'atrás', 'anterior'],
      },
    },
    {
      id: 1410,
      emoji: '↖️',
      keywords: {
        en: ['up-left arrow', 'direction', 'northwest', 'diagonal'],
        es: ['flecha arriba izquierda', 'dirección', 'noroeste', 'diagonal'],
      },
    },
    {
      id: 1411,
      emoji: '↕️',
      keywords: {
        en: ['up-down arrow', 'direction', 'vertical', 'height'],
        es: ['flecha arriba abajo', 'dirección', 'vertical', 'altura'],
      },
    },
    {
      id: 1412,
      emoji: '↔️',
      keywords: {
        en: ['left-right arrow', 'direction', 'horizontal', 'width'],
        es: ['flecha izquierda derecha', 'dirección', 'horizontal', 'ancho'],
      },
    },
    {
      id: 1413,
      emoji: '↩️',
      keywords: {
        en: ['left arrow curving left', 'return', 'back', 'previous'],
        es: ['flecha curva hacia la izquierda', 'regresar', 'atrás', 'anterior'],
      },
    },
    {
      id: 1414,
      emoji: '↪️',
      keywords: {
        en: ['right arrow curving left', 'forward', 'next', 'continue'],
        es: ['flecha curva hacia la derecha', 'adelante', 'siguiente', 'continuar'],
      },
    },
    {
      id: 1415,
      emoji: '⤴️',
      keywords: {
        en: ['right arrow curving up', 'direction', 'upward', 'go'],
        es: ['flecha derecha curvando hacia arriba', 'dirección', 'hacia arriba', 'ir'],
      },
    },
    {
      id: 1416,
      emoji: '⤵️',
      keywords: {
        en: ['right arrow curving down', 'direction', 'downward', 'go'],
        es: ['flecha derecha curvando hacia abajo', 'dirección', 'hacia abajo', 'ir'],
      },
    },
    {
      id: 1417,
      emoji: '🔃',
      keywords: {
        en: ['circular arrow', 'refresh', 'reload', 'loop'],
        es: ['flecha circular', 'actualizar', 'recargar', 'bucle'],
      },
    },
    {
      id: 1418,
      emoji: '🔄',
      keywords: {
        en: ['counterclockwise arrows button', 'circular', 'repeat', 'loop'],
        es: ['flechas antihorarias', 'circular', 'repetir', 'bucle'],
      },
    },
    {
      id: 1419,
      emoji: '🔙',
      keywords: {
        en: ['BACK arrow', 'left', 'return', 'previous'],
        es: ['flecha atrás', 'izquierda', 'regresar', 'anterior'],
      },
    },
    {
      id: 1420,
      emoji: '🔚',
      keywords: {
        en: ['END arrow', 'right', 'finish', 'terminate'],
        es: ['flecha fin', 'derecha', 'finalizar', 'terminar'],
      },
    },
    {
      id: 1421,
      emoji: '🔛',
      keywords: {
        en: ['ON! arrow', 'beginning', 'start', 'commence'],
        es: ['flecha encendido', 'inicio', 'empezar', 'comenzar'],
      },
    },
    {
      id: 1422,
      emoji: '🔜',
      keywords: {
        en: ['SOON arrow', 'coming', 'upcoming', 'anticipated'],
        es: ['flecha pronto', 'viene', 'próximo', 'anticipado'],
      },
    },
    {
      id: 1423,
      emoji: '🔝',
      keywords: {
        en: ['TOP arrow', 'up', 'highest', 'maximum'],
        es: ['flecha arriba del todo', 'arriba', 'más alto', 'máximo'],
      },
    },
    {
      id: 1424,
      emoji: '🛐',
      keywords: {
        en: ['place of worship', 'religion', 'prayer', 'sacred'],
        es: ['lugar de culto', 'religión', 'oración', 'sagrado'],
      },
    },
    {
      id: 1425,
      emoji: '⚛️',
      keywords: {
        en: ['atom symbol', 'science', 'nuclear', 'physics'],
        es: ['símbolo de átomo', 'ciencia', 'nuclear', 'física'],
      },
    },
    {
      id: 1426,
      emoji: '🕉️',
      keywords: {
        en: ['om', 'religion', 'hinduism', 'chant'],
        es: ['om', 'religión', 'hinduismo', 'canto'],
      },
    },
    {
      id: 1427,
      emoji: '✡️',
      keywords: {
        en: ['star of David', 'religion', 'judaism', 'symbol'],
        es: ['estrella de David', 'religión', 'judaísmo', 'símbolo'],
      },
    },
    {
      id: 1428,
      emoji: '☸️',
      keywords: {
        en: ['wheel of dharma', 'religion', 'buddhism', 'symbol'],
        es: ['rueda del dharma', 'religión', 'budismo', 'símbolo'],
      },
    },
    {
      id: 1429,
      emoji: '☯️',
      keywords: {
        en: ['yin yang', 'balance', 'harmony', 'opposite'],
        es: ['yin yang', 'equilibrio', 'armonía', 'opuesto'],
      },
    },
    {
      id: 1430,
      emoji: '✝️',
      keywords: {
        en: ['latin cross', 'religion', 'christianity', 'symbol'],
        es: ['cruz latina', 'religión', 'cristianismo', 'símbolo'],
      },
    },
    {
      id: 1431,
      emoji: '☦️',
      keywords: {
        en: ['orthodox cross', 'religion', 'christianity', 'symbol'],
        es: ['cruz ortodoxa', 'religión', 'cristianismo', 'símbolo'],
      },
    },
    {
      id: 1432,
      emoji: '☪️',
      keywords: {
        en: ['star and crescent', 'religion', 'islam', 'symbol'],
        es: ['estrella y media luna', 'religión', 'islam', 'símbolo'],
      },
    },
    {
      id: 1433,
      emoji: '☮️',
      keywords: {
        en: ['peace symbol', 'hippie', 'pacifism', 'tranquility'],
        es: ['símbolo de paz', 'hippie', 'pacifismo', 'tranquilidad'],
      },
    },
    {
      id: 1434,
      emoji: '🕎',
      keywords: {
        en: ['menorah', 'religion', 'judaism', 'candelabrum'],
        es: ['menorá', 'religión', 'judaísmo', 'candelabro'],
      },
    },
    {
      id: 1435,
      emoji: '🔯',
      keywords: {
        en: ['dotted six-pointed star', 'religion', 'judaism', 'symbol'],
        es: ['estrella de seis puntas', 'religión', 'judaísmo', 'símbolo'],
      },
    },
    {
      id: 1436,
      emoji: '🪯',
      keywords: {
        en: ['diya lamp', 'lamp', 'light', 'hinduism'],
        es: ['lámpara diya', 'lámpara', 'luz', 'hinduismo'],
      },
    },
    {
      id: 1437,
      emoji: '♈',
      keywords: {
        en: ['Aries', 'zodiac', 'astrology', 'sign'],
        es: ['Aries', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1438,
      emoji: '♉',
      keywords: {
        en: ['Taurus', 'zodiac', 'astrology', 'sign'],
        es: ['Tauro', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1439,
      emoji: '♊',
      keywords: {
        en: ['Gemini', 'zodiac', 'astrology', 'sign'],
        es: ['Géminis', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1440,
      emoji: '♋',
      keywords: {
        en: ['Cancer', 'zodiac', 'astrology', 'sign'],
        es: ['Cáncer', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1441,
      emoji: '♌',
      keywords: {
        en: ['Leo', 'zodiac', 'astrology', 'sign'],
        es: ['Leo', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1442,
      emoji: '♍',
      keywords: {
        en: ['Virgo', 'zodiac', 'astrology', 'sign'],
        es: ['Virgo', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1443,
      emoji: '♎',
      keywords: {
        en: ['Libra', 'zodiac', 'astrology', 'sign'],
        es: ['Libra', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1444,
      emoji: '♏',
      keywords: {
        en: ['Scorpio', 'zodiac', 'astrology', 'sign'],
        es: ['Escorpio', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1445,
      emoji: '♐',
      keywords: {
        en: ['Sagittarius', 'zodiac', 'astrology', 'sign'],
        es: ['Sagitario', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1446,
      emoji: '♑',
      keywords: {
        en: ['Capricorn', 'zodiac', 'astrology', 'sign'],
        es: ['Capricornio', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1447,
      emoji: '♒',
      keywords: {
        en: ['Aquarius', 'zodiac', 'astrology', 'sign'],
        es: ['Acuario', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1448,
      emoji: '♓',
      keywords: {
        en: ['Pisces', 'zodiac', 'astrology', 'sign'],
        es: ['Piscis', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1449,
      emoji: '⛎',
      keywords: {
        en: ['Ophiuchus', 'zodiac', 'astrology', 'sign'],
        es: ['Ofiuco', 'zodiaco', 'astrología', 'signo'],
      },
    },
    {
      id: 1450,
      emoji: '🔀',
      keywords: {
        en: ['shuffle tracks button', 'music', 'random', 'mix'],
        es: ['botón de reproducción aleatoria', 'música', 'aleatorio', 'mezcla'],
      },
    },
    {
      id: 1451,
      emoji: '🔁',
      keywords: {
        en: ['repeat button', 'loop', 'cycle', 'recurrence'],
        es: ['botón de repetir', 'bucle', 'ciclo', 'recurrencia'],
      },
    },
    {
      id: 1452,
      emoji: '🔂',
      keywords: {
        en: ['repeat single button', 'loop', 'cycle', 'recurrence'],
        es: ['botón de repetir una vez', 'bucle', 'ciclo', 'recurrencia'],
      },
    },
    {
      id: 1453,
      emoji: '▶️',
      keywords: {
        en: ['play button', 'right', 'forward', 'start'],
        es: ['botón de reproducir', 'derecha', 'adelante', 'iniciar'],
      },
    },
    {
      id: 1454,
      emoji: '⏩',
      keywords: {
        en: ['fast-forward button', 'right', 'next', 'play'],
        es: ['botón de avance rápido', 'derecha', 'siguiente', 'reproducir'],
      },
    },
    {
      id: 1455,
      emoji: '⏭️',
      keywords: {
        en: ['next track button', 'right', 'forward', 'skip'],
        es: ['botón de siguiente pista', 'derecha', 'adelante', 'saltar'],
      },
    },
    {
      id: 1456,
      emoji: '⏯️',
      keywords: {
        en: ['play or pause button', 'right', 'forward', 'pause'],
        es: ['botón de reproducir o pausar', 'derecha', 'adelante', 'pausa'],
      },
    },
    {
      id: 1457,
      emoji: '◀️',
      keywords: {
        en: ['reverse button', 'left', 'backward', 'previous'],
        es: ['botón de retroceso', 'izquierda', 'atrás', 'anterior'],
      },
    },
    {
      id: 1458,
      emoji: '⏪',
      keywords: {
        en: ['fast reverse button', 'left', 'rewind', 'previous'],
        es: ['botón de retroceso rápido', 'izquierda', 'rebobinar', 'anterior'],
      },
    },
    {
      id: 1459,
      emoji: '⏮️',
      keywords: {
        en: ['last track button', 'left', 'backward', 'skip'],
        es: ['botón de pista anterior', 'izquierda', 'atrás', 'saltar'],
      },
    },
    {
      id: 1460,
      emoji: '🔼',
      keywords: {
        en: ['upwards button', 'above', 'top', 'triangle'],
        es: ['botón hacia arriba', 'arriba', 'superior', 'triángulo'],
      },
    },
    {
      id: 1461,
      emoji: '⏫',
      keywords: {
        en: ['fast up button', 'above', 'top', 'triangle'],
        es: ['botón rápido hacia arriba', 'arriba', 'superior', 'triángulo'],
      },
    },
    {
      id: 1462,
      emoji: '🔽',
      keywords: {
        en: ['downwards button', 'below', 'bottom', 'triangle'],
        es: ['botón hacia abajo', 'abajo', 'inferior', 'triángulo'],
      },
    },
    {
      id: 1463,
      emoji: '⏬',
      keywords: {
        en: ['fast down button', 'below', 'bottom', 'triangle'],
        es: ['botón rápido hacia abajo', 'abajo', 'inferior', 'triángulo'],
      },
    },
    {
      id: 1464,
      emoji: '⏸️',
      keywords: {
        en: ['pause button', 'pause', 'stop', 'break'],
        es: ['botón de pausa', 'pausa', 'detener', 'descanso'],
      },
    },
    {
      id: 1465,
      emoji: '⏹️',
      keywords: {
        en: ['stop button', 'square', 'end', 'finish'],
        es: ['botón de detener', 'cuadrado', 'fin', 'finalizar'],
      },
    },
    {
      id: 1466,
      emoji: '⏺️',
      keywords: {
        en: ['record button', 'circle', 'start', 'begin'],
        es: ['botón de grabar', 'círculo', 'iniciar', 'comenzar'],
      },
    },
    {
      id: 1467,
      emoji: '⏏️',
      keywords: {
        en: ['eject button', 'eject', 'discard', 'remove'],
        es: ['botón de expulsar', 'expulsar', 'descartar', 'remover'],
      },
    },
    {
      id: 1468,
      emoji: '🎦',
      keywords: {
        en: ['cinema', 'film', 'movie', 'theater'],
        es: ['cine', 'film', 'película', 'teatro'],
      },
    },
    {
      id: 1469,
      emoji: '🔅',
      keywords: {
        en: ['dim button', 'brightness', 'low', 'dark'],
        es: ['botón de brillo bajo', 'brillo', 'bajo', 'oscuro'],
      },
    },
    {
      id: 1470,
      emoji: '🔆',
      keywords: {
        en: ['bright button', 'brightness', 'light', 'intense'],
        es: ['botón de brillo alto', 'brillo', 'luz', 'intenso'],
      },
    },
    {
      id: 1471,
      emoji: '📶',
      keywords: {
        en: ['antenna bars', 'signal', 'reception', 'network'],
        es: ['barras de señal', 'señal', 'recepción', 'red'],
      },
    },
    {
      id: 1472,
      emoji: '🛜',
      keywords: {
        en: ['heavy equals sign', 'math', 'balance', 'equal'],
        es: ['signo igual grueso', 'matemáticas', 'equilibrio', 'igual'],
      },
    },
    {
      id: 1473,
      emoji: '📳',
      keywords: {
        en: ['vibration mode', 'phone', 'silent', 'sound'],
        es: ['modo vibración', 'teléfono', 'silencioso', 'sonido'],
      },
    },
    {
      id: 1474,
      emoji: '📴',
      keywords: {
        en: ['mobile phone off', 'phone', 'mute', 'silence'],
        es: ['teléfono apagado', 'teléfono', 'silenciar', 'silencio'],
      },
    },
    {
      id: 1475,
      emoji: '♀️',
      keywords: {
        en: ['female', 'woman', 'gender', 'feminine'],
        es: ['femenino', 'mujer', 'género', 'femenina'],
      },
    },
    {
      id: 1476,
      emoji: '♂️',
      keywords: {
        en: ['male', 'man', 'gender', 'masculine'],
        es: ['masculino', 'hombre', 'género', 'masculino'],
      },
    },
    {
      id: 1477,
      emoji: '⚧️',
      keywords: {
        en: ['transgender', 'genderqueer', 'identity', 'inclusive'],
        es: ['transgénero', 'género queer', 'identidad', 'inclusivo'],
      },
    },
    {
      id: 1478,
      emoji: '✖️',
      keywords: {
        en: ['multiply', 'cross', 'math', 'delete'],
        es: ['multiplicar', 'cruz', 'matemáticas', 'eliminar'],
      },
    },
    {
      id: 1479,
      emoji: '➕',
      keywords: {
        en: ['plus', 'addition', 'math', 'increase'],
        es: ['más', 'suma', 'matemáticas', 'aumentar'],
      },
    },
    {
      id: 1480,
      emoji: '➖',
      keywords: {
        en: ['minus', 'subtraction', 'math', 'decrease'],
        es: ['menos', 'resta', 'matemáticas', 'disminuir'],
      },
    },
    {
      id: 1481,
      emoji: '➗',
      keywords: {
        en: ['divide', 'math', 'division', 'fraction'],
        es: ['dividir', 'matemáticas', 'división', 'fracción'],
      },
    },
    {
      id: 1482,
      emoji: '🟰',
      keywords: {
        en: ['square', 'geometric', 'shape', 'box'],
        es: ['cuadrado', 'geométrico', 'forma', 'caja'],
      },
    },
    {
      id: 1483,
      emoji: '♾️',
      keywords: {
        en: ['infinity', 'endless', 'eternity', 'limitless'],
        es: ['infinito', 'sin fin', 'eternidad', 'ilimitado'],
      },
    },
    {
      id: 1484,
      emoji: '‼️',
      keywords: {
        en: ['double exclamation', 'attention', 'urgent', 'warning'],
        es: ['doble exclamación', 'atención', 'urgente', 'advertencia'],
      },
    },
    {
      id: 1485,
      emoji: '⁉️',
      keywords: {
        en: ['exclamation question', 'surprise', 'confusion', 'punctuation'],
        es: ['exclamación y pregunta', 'sorpresa', 'confusión', 'puntuación'],
      },
    },
    {
      id: 1486,
      emoji: '❓',
      keywords: {
        en: ['question mark', 'query', 'inquiry', 'confusion'],
        es: ['signo de pregunta', 'consulta', 'pregunta', 'confusión'],
      },
    },
    {
      id: 1487,
      emoji: '❔',
      keywords: {
        en: ['white question mark', 'question', 'unknown', 'uncertainty'],
        es: ['signo de pregunta blanco', 'pregunta', 'desconocido', 'incertidumbre'],
      },
    },
    {
      id: 1488,
      emoji: '❕',
      keywords: {
        en: ['exclamation mark', 'attention', 'alert', 'warning'],
        es: ['signo de exclamación', 'atención', 'alerta', 'advertencia'],
      },
    },
    {
      id: 1489,
      emoji: '❗',
      keywords: {
        en: ['exclamation mark', 'alert', 'attention', 'important'],
        es: ['signo de exclamación', 'alerta', 'atención', 'importante'],
      },
    },
    {
      id: 1490,
      emoji: '〰️',
      keywords: {
        en: ['wavy dash', 'tilde', 'flowing', 'continuous'],
        es: ['guion ondulado', 'tilde', 'fluido', 'continuo'],
      },
    },
    {
      id: 1491,
      emoji: '💱',
      keywords: {
        en: ['currency exchange', 'money', 'finance', 'economics'],
        es: ['cambio de divisas', 'dinero', 'finanzas', 'economía'],
      },
    },
    {
      id: 1492,
      emoji: '💲',
      keywords: {
        en: ['dollar sign', 'money', 'currency', 'cash'],
        es: ['signo de dólar', 'dinero', 'moneda', 'efectivo'],
      },
    },
    {
      id: 1493,
      emoji: '⚕️',
      keywords: {
        en: ['medical symbol', 'health', 'medicine', 'caduceus'],
        es: ['símbolo médico', 'salud', 'medicina', 'caduceo'],
      },
    },
    {
      id: 1494,
      emoji: '♻️',
      keywords: {
        en: ['recycling symbol', 'environment', 'green', 'sustainability'],
        es: ['símbolo de reciclaje', 'ambiente', 'verde', 'sostenibilidad'],
      },
    },
    {
      id: 1495,
      emoji: '⚜️',
      keywords: {
        en: ['fleur-de-lis', 'symbol', 'ornament', 'royalty'],
        es: ['flor de lis', 'símbolo', 'ornamento', 'realeza'],
      },
    },
    {
      id: 1496,
      emoji: '🔱',
      keywords: {
        en: ['trident emblem', 'poseidon', 'mythology', 'power'],
        es: ['emblema de tridente', 'Poseidón', 'mitología', 'poder'],
      },
    },
    {
      id: 1497,
      emoji: '📛',
      keywords: {
        en: ['name badge', 'label', 'identification', 'alert'],
        es: ['gafete de nombre', 'etiqueta', 'identificación', 'alerta'],
      },
    },
    {
      id: 1498,
      emoji: '🔰',
      keywords: {
        en: ['Japanese symbol for beginner', 'new', 'novice', 'learner'],
        es: ['símbolo japonés de principiante', 'nuevo', 'novato', 'aprendiz'],
      },
    },
    {
      id: 1499,
      emoji: '⭕',
      keywords: {
        en: ['heavy large circle', 'circle', 'round', 'complete'],
        es: ['círculo grande', 'círculo', 'redondo', 'completo'],
      },
    },
    {
      id: 1500,
      emoji: '✅',
      keywords: {
        en: ['check mark', 'approve', 'done', 'completed'],
        es: ['marca de verificación', 'aprobar', 'hecho', 'completado'],
      },
    },
    {
      id: 1501,
      emoji: '☑️',
      keywords: {
        en: ['ballot box with check', 'check mark', 'done', 'completed'],
        es: ['casilla con verificación', 'marca de verificación', 'hecho', 'completado'],
      },
    },
    {
      id: 1502,
      emoji: '✔️',
      keywords: {
        en: ['check mark', 'approve', 'done', 'completed'],
        es: ['marca de verificación', 'aprobar', 'hecho', 'completado'],
      },
    },
    {
      id: 1503,
      emoji: '❌',
      keywords: {
        en: ['cross mark', 'wrong', 'incorrect', 'delete'],
        es: ['marca de equis', 'mal', 'incorrecto', 'eliminar'],
      },
    },
    {
      id: 1504,
      emoji: '❎',
      keywords: {
        en: ['cross mark button', 'wrong', 'incorrect', 'delete'],
        es: ['botón de equis', 'mal', 'incorrecto', 'eliminar'],
      },
    },
    {
      id: 1505,
      emoji: '➰',
      keywords: {
        en: ['curly loop', 'scroll', 'design', 'pattern'],
        es: ['bucle rizado', 'desplazamiento', 'diseño', 'patrón'],
      },
    },
    {
      id: 1506,
      emoji: '➿',
      keywords: {
        en: ['double curly loop', 'scroll', 'design', 'pattern'],
        es: ['doble bucle rizado', 'desplazamiento', 'diseño', 'patrón'],
      },
    },
    {
      id: 1507,
      emoji: '〽️',
      keywords: {
        en: ['part alternation mark', 'Japanese', 'frequency', 'music'],
        es: ['marca de alternancia', 'japonés', 'frecuencia', 'música'],
      },
    },
    {
      id: 1508,
      emoji: '✳️',
      keywords: {
        en: ['eight-spoked asterisk', 'star', 'sparkle', 'shine'],
        es: ['asterisco de ocho puntas', 'estrella', 'destello', 'brillo'],
      },
    },
    {
      id: 1509,
      emoji: '✴️',
      keywords: {
        en: ['eight-pointed star', 'star', 'sparkle', 'shine'],
        es: ['estrella de ocho puntas', 'estrella', 'destello', 'brillo'],
      },
    },
    {
      id: 1510,
      emoji: '❇️',
      keywords: {
        en: ['sparkle', 'twinkle', 'clean', 'pure'],
        es: ['destello', 'brillar', 'limpio', 'puro'],
      },
    },
    {
      id: 1511,
      emoji: '©️',
      keywords: {
        en: ['copyright', 'intellectual property', 'rights', 'protection'],
        es: ['derechos de autor', 'propiedad intelectual', 'derechos', 'protección'],
      },
    },
    {
      id: 1512,
      emoji: '®️',
      keywords: {
        en: ['registered', 'trademark', 'brand', 'symbol'],
        es: ['registrado', 'marca registrada', 'marca', 'símbolo'],
      },
    },
    {
      id: 1513,
      emoji: '™️',
      keywords: {
        en: ['trade mark', 'brand', 'symbol', 'trademark'],
        es: ['marca comercial', 'marca', 'símbolo', 'marca registrada'],
      },
    },
    {
      id: 1514,
      emoji: '#️⃣',
      keywords: {
        en: ['number sign', 'hashtag', 'hash', 'pound'],
        es: ['signo numeral', 'hashtag', 'almohadilla', 'numeral'],
      },
    },
    {
      id: 1515,
      emoji: '*️⃣',
      keywords: {
        en: ['asterisk', 'star', 'symbol', 'multiply'],
        es: ['asterisco', 'estrella', 'símbolo', 'multiplicar'],
      },
    },
    {
      id: 1516,
      emoji: '0️⃣',
      keywords: {
        en: ['keycap 0', 'zero', 'number', '0'],
        es: ['tecla 0', 'cero', 'número', '0'],
      },
    },
    {
      id: 1517,
      emoji: '1️⃣',
      keywords: {
        en: ['keycap 1', 'one', 'number', '1'],
        es: ['tecla 1', 'uno', 'número', '1'],
      },
    },
    {
      id: 1518,
      emoji: '2️⃣',
      keywords: {
        en: ['keycap 2', 'two', 'number', '2'],
        es: ['tecla 2', 'dos', 'número', '2'],
      },
    },
    {
      id: 1519,
      emoji: '3️⃣',
      keywords: {
        en: ['keycap 3', 'three', 'number', '3'],
        es: ['tecla 3', 'tres', 'número', '3'],
      },
    },
    {
      id: 1520,
      emoji: '4️⃣',
      keywords: {
        en: ['keycap 4', 'four', 'number', '4'],
        es: ['tecla 4', 'cuatro', 'número', '4'],
      },
    },
    {
      id: 1521,
      emoji: '5️⃣',
      keywords: {
        en: ['keycap 5', 'five', 'number', '5'],
        es: ['tecla 5', 'cinco', 'número', '5'],
      },
    },
    {
      id: 1522,
      emoji: '6️⃣',
      keywords: {
        en: ['keycap 6', 'six', 'number', '6'],
        es: ['tecla 6', 'seis', 'número', '6'],
      },
    },
    {
      id: 1523,
      emoji: '7️⃣',
      keywords: {
        en: ['keycap 7', 'seven', 'number', '7'],
        es: ['tecla 7', 'siete', 'número', '7'],
      },
    },
    {
      id: 1524,
      emoji: '8️⃣',
      keywords: {
        en: ['keycap 8', 'eight', 'number', '8'],
        es: ['tecla 8', 'ocho', 'número', '8'],
      },
    },
    {
      id: 1525,
      emoji: '9️⃣',
      keywords: {
        en: ['keycap 9', 'nine', 'number', '9'],
        es: ['tecla 9', 'nueve', 'número', '9'],
      },
    },
    {
      id: 1526,
      emoji: '🔟',
      keywords: {
        en: ['keycap 10', 'ten', 'number', '10'],
        es: ['tecla 10', 'diez', 'número', '10'],
      },
    },
    {
      id: 1527,
      emoji: '🔠',
      keywords: {
        en: ['input latin uppercase', 'alphabet', 'letters', 'characters'],
        es: ['entrada de mayúsculas latinas', 'alfabeto', 'letras', 'caracteres'],
      },
    },
    {
      id: 1528,
      emoji: '🔡',
      keywords: {
        en: ['input latin lowercase', 'alphabet', 'letters', 'characters'],
        es: ['entrada de minúsculas latinas', 'alfabeto', 'letras', 'caracteres'],
      },
    },
    {
      id: 1529,
      emoji: '🔢',
      keywords: {
        en: ['input numbers', 'numbers', '123', 'math'],
        es: ['entrada de números', 'números', '123', 'matemáticas'],
      },
    },
    {
      id: 1530,
      emoji: '🔣',
      keywords: {
        en: ['input symbols', 'symbols', 'keyboard', 'characters'],
        es: ['entrada de símbolos', 'símbolos', 'teclado', 'caracteres'],
      },
    },
    {
      id: 1531,
      emoji: '🔤',
      keywords: {
        en: ['input latin letters', 'alphabet', 'characters', 'keyboard'],
        es: ['entrada de letras latinas', 'alfabeto', 'caracteres', 'teclado'],
      },
    },
    {
      id: 1532,
      emoji: '🅰️',
      keywords: {
        en: ['A button (blood type)', 'blood type', 'letter', 'alphabet'],
        es: ['botón A', 'tipo de sangre', 'letra', 'alfabeto'],
      },
    },
    {
      id: 1533,
      emoji: '🆎',
      keywords: {
        en: ['AB button (blood type)', 'blood type', 'letter', 'alphabet'],
        es: ['botón AB', 'tipo de sangre', 'letra', 'alfabeto'],
      },
    },
    {
      id: 1534,
      emoji: '🅱️',
      keywords: {
        en: ['B button (blood type)', 'blood type', 'letter', 'alphabet'],
        es: ['botón B', 'tipo de sangre', 'letra', 'alfabeto'],
      },
    },
    {
      id: 1535,
      emoji: '🆑',
      keywords: {
        en: ['CL button', 'clear', 'clean', 'delete'],
        es: ['botón CL', 'limpiar', 'borrar', 'eliminar'],
      },
    },
    {
      id: 1536,
      emoji: '🆒',
      keywords: {
        en: ['COOL button', 'cool', 'free', 'fresh'],
        es: ['botón cool', 'genial', 'gratis', 'fresco'],
      },
    },
    {
      id: 1537,
      emoji: '🆓',
      keywords: {
        en: ['FREE button', 'free', 'no cost', 'gratis'],
        es: ['botón gratis', 'gratis', 'sin costo', 'libre'],
      },
    },
    {
      id: 1538,
      emoji: 'ℹ️',
      keywords: {
        en: ['information', 'info', 'details', 'help'],
        es: ['información', 'info', 'detalles', 'ayuda'],
      },
    },
    {
      id: 1539,
      emoji: '🆔',
      keywords: {
        en: ['ID button', 'identification', 'identity', 'document'],
        es: ['botón ID', 'identificación', 'identidad', 'documento'],
      },
    },
    {
      id: 1540,
      emoji: 'Ⓜ️',
      keywords: {
        en: ['circled M', 'M', 'metro', 'subway'],
        es: ['M encerrada', 'M', 'metro', 'subterráneo'],
      },
    },
    {
      id: 1541,
      emoji: '🆕',
      keywords: {
        en: ['NEW button', 'new', 'fresh', 'novel'],
        es: ['botón nuevo', 'nuevo', 'fresco', 'novedoso'],
      },
    },
    {
      id: 1542,
      emoji: '🆖',
      keywords: {
        en: ['NG button', 'no good', 'disapprove', 'bad'],
        es: ['botón NG', 'no bueno', 'desaprobar', 'malo'],
      },
    },
    {
      id: 1543,
      emoji: '🅾️',
      keywords: {
        en: ['O button (blood type)', 'blood type', 'letter', 'alphabet'],
        es: ['botón O', 'tipo de sangre', 'letra', 'alfabeto'],
      },
    },
    {
      id: 1544,
      emoji: '🆗',
      keywords: {
        en: ['OK button', 'okay', 'approve', 'accept'],
        es: ['botón OK', 'ok', 'aprobar', 'aceptar'],
      },
    },
    {
      id: 1545,
      emoji: '🅿️',
      keywords: {
        en: ['P button', 'parking', 'alphabet', 'letters'],
        es: ['botón P', 'parqueadero', 'alfabeto', 'letras'],
      },
    },
    {
      id: 1546,
      emoji: '🆘',
      keywords: {
        en: ['SOS button', 'help', 'emergency', 'distress'],
        es: ['botón SOS', 'ayuda', 'emergencia', 'auxilio'],
      },
    },
    {
      id: 1547,
      emoji: '🆙',
      keywords: {
        en: ['UP! button', 'up', 'success', 'achievement'],
        es: ['botón UP', 'arriba', 'éxito', 'logro'],
      },
    },
    {
      id: 1548,
      emoji: '🆚',
      keywords: {
        en: ['VS button', 'versus', 'competition', 'challenge'],
        es: ['botón VS', 'versus', 'competencia', 'desafío'],
      },
    },
    {
      id: 1549,
      emoji: '🈁',
      keywords: {
        en: ['Japanese “here” button', 'here', 'location', 'place'],
        es: ['botón japonés aquí', 'aquí', 'ubicación', 'lugar'],
      },
    },
    {
      id: 1550,
      emoji: '🈂️',
      keywords: {
        en: ['Japanese “service charge” button', 'service', 'charge', 'price'],
        es: ['botón japonés cargo por servicio', 'servicio', 'cargo', 'precio'],
      },
    },
    {
      id: 1551,
      emoji: '🈷️',
      keywords: {
        en: ['Japanese “monthly amount” button', 'monthly', 'amount', 'fee'],
        es: ['botón japonés monto mensual', 'mensual', 'monto', 'tarifa'],
      },
    },
    {
      id: 1552,
      emoji: '🈶',
      keywords: {
        en: ['Japanese “not free of charge” button', 'not free', 'charge', 'fee'],
        es: ['botón japonés no gratuito', 'no gratis', 'cargo', 'tarifa'],
      },
    },
    {
      id: 1553,
      emoji: '🈯',
      keywords: {
        en: ['Japanese “reserved” button', 'reserved', 'booking', 'appointment'],
        es: ['botón japonés reservado', 'reservado', 'reserva', 'cita'],
      },
    },
    {
      id: 1554,
      emoji: '🉐',
      keywords: {
        en: ['Japanese “bargain” button', 'bargain', 'good deal', 'discount'],
        es: ['botón japonés oferta', 'oferta', 'buen trato', 'descuento'],
      },
    },
    {
      id: 1555,
      emoji: '🈹',
      keywords: {
        en: ['Japanese “discount” button', 'discount', 'sale', 'price'],
        es: ['botón japonés descuento', 'descuento', 'rebaja', 'precio'],
      },
    },
    {
      id: 1556,
      emoji: '🈚',
      keywords: {
        en: ['Japanese “free of charge” button', 'free', 'no cost', 'gratis'],
        es: ['botón japonés gratis', 'gratis', 'sin costo', 'gratuito'],
      },
    },
    {
      id: 1557,
      emoji: '🈲',
      keywords: {
        en: ['Japanese “prohibited” button', 'prohibited', 'forbidden', 'not allowed'],
        es: ['botón japonés prohibido', 'prohibido', 'restringido', 'no permitido'],
      },
    },
    {
      id: 1558,
      emoji: '🉑',
      keywords: {
        en: ['Japanese “acceptable” button', 'acceptable', 'OK', 'good'],
        es: ['botón japonés aceptable', 'aceptable', 'OK', 'bueno'],
      },
    },
    {
      id: 1559,
      emoji: '🈸',
      keywords: {
        en: ['Japanese “application” button', 'application', 'apply', 'request'],
        es: ['botón japonés solicitud', 'solicitud', 'aplicar', 'petición'],
      },
    },
    {
      id: 1560,
      emoji: '🈴',
      keywords: {
        en: ['Japanese “passing grade” button', 'passing grade', 'good', 'success'],
        es: ['botón japonés aprobado', 'nota aprobatoria', 'bueno', 'éxito'],
      },
    },
    {
      id: 1561,
      emoji: '🈳',
      keywords: {
        en: ['Japanese “vacancy” button', 'vacancy', 'available', 'space'],
        es: ['botón japonés vacante', 'vacante', 'disponible', 'espacio'],
      },
    },
    {
      id: 1562,
      emoji: '㊗️',
      keywords: {
        en: ['Japanese “congratulations” button', 'congratulations', 'celebrate', 'joy'],
        es: ['botón japonés felicitaciones', 'felicitaciones', 'celebrar', 'alegría'],
      },
    },
    {
      id: 1563,
      emoji: '㊙️',
      keywords: {
        en: ['Japanese “secret” button', 'secret', 'confidential', 'mystery'],
        es: ['botón japonés secreto', 'secreto', 'confidencial', 'misterio'],
      },
    },
    {
      id: 1564,
      emoji: '🈺',
      keywords: {
        en: ['Japanese “open for business” button', 'open', 'business', 'welcome'],
        es: ['botón japonés abierto', 'abierto', 'negocio', 'bienvenido'],
      },
    },
    {
      id: 1565,
      emoji: '🈵',
      keywords: {
        en: ['Japanese “no vacancy” button', 'no vacancy', 'full', 'occupied'],
        es: ['botón japonés sin vacantes', 'sin vacantes', 'lleno', 'ocupado'],
      },
    },
    {
      id: 1566,
      emoji: '🔴',
      keywords: {
        en: ['red circle', 'circle', 'shape', 'alert'],
        es: ['círculo rojo', 'círculo', 'forma', 'alerta'],
      },
    },
    {
      id: 1567,
      emoji: '🟠',
      keywords: {
        en: ['orange circle', 'circle', 'shape', 'color'],
        es: ['círculo naranja', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1568,
      emoji: '🟡',
      keywords: {
        en: ['yellow circle', 'circle', 'shape', 'color'],
        es: ['círculo amarillo', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1569,
      emoji: '🟢',
      keywords: {
        en: ['green circle', 'circle', 'shape', 'color'],
        es: ['círculo verde', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1570,
      emoji: '🔵',
      keywords: {
        en: ['blue circle', 'circle', 'shape', 'color'],
        es: ['círculo azul', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1571,
      emoji: '🟣',
      keywords: {
        en: ['purple circle', 'circle', 'shape', 'color'],
        es: ['círculo morado', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1572,
      emoji: '🟤',
      keywords: {
        en: ['brown circle', 'circle', 'shape', 'color'],
        es: ['círculo marrón', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1573,
      emoji: '⚫',
      keywords: {
        en: ['black circle', 'circle', 'shape', 'color'],
        es: ['círculo negro', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1574,
      emoji: '⚪',
      keywords: {
        en: ['white circle', 'circle', 'shape', 'color'],
        es: ['círculo blanco', 'círculo', 'forma', 'color'],
      },
    },
    {
      id: 1575,
      emoji: '🟥',
      keywords: {
        en: ['red square', 'square', 'shape', 'color'],
        es: ['cuadrado rojo', 'cuadrado', 'forma', 'color'],
      },
    },
    {
      id: 1576,
      emoji: '🟧',
      keywords: {
        en: ['orange square', 'square', 'shape', 'color'],
        es: ['cuadrado naranja', 'cuadrado', 'forma', 'color'],
      },
    },
    {
      id: 1577,
      emoji: '🟨',
      keywords: {
        en: ['yellow square', 'square', 'shape', 'color'],
        es: ['cuadrado amarillo', 'cuadrado', 'forma', 'color'],
      },
    },
    {
      id: 1578,
      emoji: '🟩',
      keywords: {
        en: ['green square', 'square', 'shape', 'color'],
        es: ['cuadrado verde', 'cuadrado', 'forma', 'color'],
      },
    },
    {
      id: 1579,
      emoji: '🟦',
      keywords: {
        en: ['blue square', 'color', 'shape', 'geometric'],
        es: ['cuadrado azul', 'color', 'forma', 'geométrico'],
      },
    },
    {
      id: 1580,
      emoji: '🟪',
      keywords: {
        en: ['purple square', 'color', 'shape', 'geometric'],
        es: ['cuadrado morado', 'color', 'forma', 'geométrico'],
      },
    },
    {
      id: 1581,
      emoji: '🟫',
      keywords: {
        en: ['brown square', 'color', 'shape', 'geometric'],
        es: ['cuadrado marrón', 'color', 'forma', 'geométrico'],
      },
    },
    {
      id: 1582,
      emoji: '⬛',
      keywords: {
        en: ['black square', 'color', 'shape', 'geometric'],
        es: ['cuadrado negro', 'color', 'forma', 'geométrico'],
      },
    },
    {
      id: 1583,
      emoji: '⬜',
      keywords: {
        en: ['white square', 'color', 'shape', 'geometric'],
        es: ['cuadrado blanco', 'color', 'forma', 'geométrico'],
      },
    },
    {
      id: 1584,
      emoji: '◼️',
      keywords: {
        en: ['black medium square', 'shape', 'geometric', 'filled'],
        es: ['cuadrado mediano negro', 'forma', 'geométrico', 'relleno'],
      },
    },
    {
      id: 1585,
      emoji: '◻️',
      keywords: {
        en: ['white medium square', 'shape', 'geometric', 'empty'],
        es: ['cuadrado mediano blanco', 'forma', 'geométrico', 'vacío'],
      },
    },
    {
      id: 1586,
      emoji: '◾',
      keywords: {
        en: ['black medium-small square', 'shape', 'geometric', 'filled'],
        es: ['cuadrado mediano pequeño negro', 'forma', 'geométrico', 'relleno'],
      },
    },
    {
      id: 1587,
      emoji: '◽',
      keywords: {
        en: ['white medium-small square', 'shape', 'geometric', 'empty'],
        es: ['cuadrado mediano pequeño blanco', 'forma', 'geométrico', 'vacío'],
      },
    },
    {
      id: 1588,
      emoji: '▪️',
      keywords: {
        en: ['black small square', 'shape', 'geometric', 'filled'],
        es: ['cuadrado pequeño negro', 'forma', 'geométrico', 'relleno'],
      },
    },
    {
      id: 1589,
      emoji: '▫️',
      keywords: {
        en: ['white small square', 'shape', 'geometric', 'empty'],
        es: ['cuadrado pequeño blanco', 'forma', 'geométrico', 'vacío'],
      },
    },
    {
      id: 1590,
      emoji: '🔶',
      keywords: {
        en: ['large orange diamond', 'shape', 'geometric', 'jewel'],
        es: ['rombo naranja grande', 'forma', 'geométrico', 'joya'],
      },
    },
    {
      id: 1591,
      emoji: '🔷',
      keywords: {
        en: ['large blue diamond', 'shape', 'geometric', 'jewel'],
        es: ['rombo azul grande', 'forma', 'geométrico', 'joya'],
      },
    },
    {
      id: 1592,
      emoji: '🔸',
      keywords: {
        en: ['small orange diamond', 'shape', 'geometric', 'jewel'],
        es: ['rombo naranja pequeño', 'forma', 'geométrico', 'joya'],
      },
    },
    {
      id: 1593,
      emoji: '🔹',
      keywords: {
        en: ['small blue diamond', 'shape', 'geometric', 'jewel'],
        es: ['rombo azul pequeño', 'forma', 'geométrico', 'joya'],
      },
    },
    {
      id: 1594,
      emoji: '🔺',
      keywords: {
        en: ['red triangle pointed up', 'shape', 'geometric', 'direction'],
        es: ['triángulo rojo hacia arriba', 'forma', 'geométrico', 'dirección'],
      },
    },
    {
      id: 1595,
      emoji: '🔻',
      keywords: {
        en: ['red triangle pointed down', 'shape', 'geometric', 'direction'],
        es: ['triángulo rojo hacia abajo', 'forma', 'geométrico', 'dirección'],
      },
    },
    {
      id: 1596,
      emoji: '💠',
      keywords: {
        en: ['diamond with a dot', 'shape', 'geometric', 'jewel'],
        es: ['rombo con punto', 'forma', 'geométrico', 'joya'],
      },
    },
    {
      id: 1597,
      emoji: '🔘',
      keywords: {
        en: ['radio button', 'shape', 'geometric', 'circle'],
        es: ['botón de opción', 'forma', 'geométrico', 'círculo'],
      },
    },
    {
      id: 1598,
      emoji: '🔳',
      keywords: {
        en: ['white square button', 'shape', 'geometric', 'empty'],
        es: ['botón cuadrado blanco', 'forma', 'geométrico', 'vacío'],
      },
    },
    {
      id: 1599,
      emoji: '🔲',
      keywords: {
        en: ['black square button', 'shape', 'geometric', 'filled'],
        es: ['botón cuadrado negro', 'forma', 'geométrico', 'relleno'],
      },
    },
    {
      id: 1600,
      emoji: '💬',
      keywords: {
        en: ['speech balloon', 'chat', 'talk', 'communication'],
        es: ['burbuja de diálogo', 'chat', 'hablar', 'comunicación'],
      },
    },
    {
      id: 1601,
      emoji: '👁️‍🗨️',
      keywords: {
        en: ['eye in speech bubble', 'conversation', 'look', 'see'],
        es: ['ojo en burbuja de diálogo', 'conversación', 'mirar', 'ver'],
      },
    },
    {
      id: 1602,
      emoji: '🗨️',
      keywords: {
        en: ['left speech bubble', 'chat', 'talk', 'conversation'],
        es: ['burbuja de diálogo izquierda', 'chat', 'hablar', 'conversación'],
      },
    },
    {
      id: 1603,
      emoji: '🗯️',
      keywords: {
        en: ['right anger bubble', 'speech', 'talk', 'conversation'],
        es: ['burbuja de enojo derecha', 'discurso', 'hablar', 'conversación'],
      },
    },
    {
      id: 1604,
      emoji: '💭',
      keywords: {
        en: ['thought balloon', 'thinking', 'idea', 'communication'],
        es: ['burbuja de pensamiento', 'pensando', 'idea', 'comunicación'],
      },
    },
  ],
} satisfies Record<string, EmojiItem[]>
